(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(26753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60155);

var AllIcons = [
    {
        icon: "briefcase",
        iconWeb: "IoBriefcase",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBriefcase */ .BRz,
        title: "Work"
    },
    {
        icon: "happy",
        iconWeb: "IoHappy",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoHappy */ .HxL,
        title: "Private"
    },
    {
        icon: "car",
        iconWeb: "IoCar",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoCar */ .nf1,
        title: "Car"
    },
    {
        icon: "bicycle",
        iconWeb: "IoBicycle",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBicycle */ .iEX,
        title: "Freizeit"
    },
    {
        icon: "school",
        iconWeb: "IoSchool",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoSchool */ .yjR,
        title: "Education"
    },
    {
        icon: "shirt",
        iconWeb: "IoShirt",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoShirt */ .ugP,
        title: "Clothing"
    },
    {
        icon: "pint",
        iconWeb: "IoPint",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoPint */ .Og5,
        title: "Drinks"
    },
    {
        icon: "pizza",
        iconWeb: "IoPizza",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoPizza */ .lPl,
        title: "Food"
    },
    {
        icon: "at",
        iconWeb: "IoAtCircle",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoAtCircle */ .XRQ,
        title: "Digital"
    },
    {
        icon: "medkit",
        iconWeb: "IoMedkit",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoMedkit */ .D5c,
        title: "Medicine"
    },
    {
        icon: "airplane",
        iconWeb: "IoAirplane",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoAirplane */ .Z03,
        title: "Travel"
    },
    {
        icon: "home",
        iconWeb: "IoHome",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoHome */ .wB6,
        title: "Office"
    },
    {
        icon: "subway",
        iconWeb: "IoSubway",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoSubway */ .r3v,
        title: "Local Travel"
    },
    {
        icon: "color-wand",
        iconWeb: "IoColorPalette",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoColorPalette */ .dNS,
        title: "Art"
    },
    {
        icon: "tv",
        iconWeb: "IoTv",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoTv */ .WlF,
        title: "Elektronics"
    },
    {
        icon: "fitness",
        iconWeb: "IoFitness",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoFitness */ .Ptl,
        title: "Fitness"
    },
    {
        icon: "paw",
        iconWeb: "IoPaw",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoPaw */ .LLt,
        title: "Pets"
    },
    {
        icon: "musical-notes",
        iconWeb: "IoMusicalNotes",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoMusicalNotes */ .oV9,
        title: "Music"
    },
    {
        icon: "planet",
        iconWeb: "IoShapes",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoShapes */ .vCH,
        title: "Others"
    },
    {
        icon: "leaf",
        iconWeb: "IoLeaf",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoLeaf */ .FDJ,
        title: ""
    },
    {
        icon: "bag",
        iconWeb: "IoBag",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBag */ .ylN,
        title: ""
    },
    {
        icon: "barbell",
        iconWeb: "IoBarbell",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBarbell */ .fQo,
        title: ""
    },
    {
        icon: "beaker",
        iconWeb: "IoBeaker",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBeaker */ .W1I,
        title: ""
    },
    {
        icon: "build",
        iconWeb: "IoBuild",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBuild */ .aGA,
        title: ""
    },
    {
        icon: "business",
        iconWeb: "IoBusiness",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoBusiness */ .UQs,
        title: ""
    },
    {
        icon: "calendar",
        iconWeb: "IoCalendar",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoCalendar */ .LH9,
        title: ""
    },
    {
        icon: "terminal",
        iconWeb: "IoTerminal",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoTerminal */ .Bbd,
        title: ""
    },
    {
        icon: "cloud",
        iconWeb: "IoCloud",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoCloud */ .JcU,
        title: ""
    },
    {
        icon: "gift",
        iconWeb: "IoGift",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoGift */ .LqL,
        title: ""
    },
    {
        icon: "server",
        iconWeb: "IoServer",
        iconWebElement: react_icons_io5__WEBPACK_IMPORTED_MODULE_0__/* .IoServer */ .HnI,
        title: ""
    }
];
/* harmony default export */ __webpack_exports__["Z"] = (AllIcons);


/***/ }),

/***/ 26753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(82337);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(57805);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js + 7 modules
var dist_index_esm = __webpack_require__(645);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 3 modules
var toast_dist_index_esm = __webpack_require__(6240);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js + 1 modules
var hooks_dist_index_esm = __webpack_require__(48843);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/alert/dist/index.esm.js + 4 modules
var alert_dist_index_esm = __webpack_require__(33385);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35975);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/menu/dist/index.esm.js + 13 modules
var menu_dist_index_esm = __webpack_require__(17775);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js + 3 modules
var button_dist_index_esm = __webpack_require__(17297);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 2 modules
var avatar_dist_index_esm = __webpack_require__(41378);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 59 modules
var modal_dist_index_esm = __webpack_require__(85975);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js + 5 modules
var select_dist_index_esm = __webpack_require__(75237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/progress/dist/index.esm.js + 1 modules
var progress_dist_index_esm = __webpack_require__(21701);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/index.esm.js + 5 modules
var radio_dist_index_esm = __webpack_require__(14808);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(66682);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 10 modules
var checkbox_dist_index_esm = __webpack_require__(29486);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useProtectedSession.ts
var useProtectedSession = __webpack_require__(71589);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/jszip/dist/jszip.min.js
var jszip_min = __webpack_require__(55733);
var jszip_min_default = /*#__PURE__*/__webpack_require__.n(jszip_min);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
// EXTERNAL MODULE: ./src/utils/expandUploadFiles.ts
var expandUploadFiles = __webpack_require__(26866);
// EXTERNAL MODULE: ./node_modules/export-from-json/dist/esm/index.js + 5 modules
var esm = __webpack_require__(21359);
// EXTERNAL MODULE: ./node_modules/@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css
var DatePicker = __webpack_require__(28590);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/SubscriptionManager.tsx
var SubscriptionManager = __webpack_require__(27858);
// EXTERNAL MODULE: ./src/components/MenuElement.tsx + 2 modules
var MenuElement = __webpack_require__(57115);
// EXTERNAL MODULE: ./src/components/TutorialModal.tsx
var TutorialModal = __webpack_require__(36338);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(30083);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(28494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js + 5 modules
var tooltip_dist_index_esm = __webpack_require__(53097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var dist_esm = __webpack_require__(68856);
;// CONCATENATED MODULE: ./src/components/PdfViewer.tsx




function PdfViewer(param) {
    var url = param.url, className = param.className, _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    var proxyUrl = url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        className: className,
        bg: "white",
        borderRadius: embedded ? "none" : "lg",
        boxShadow: embedded ? "none" : "lg",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        h: embedded ? "100%" : undefined,
        minH: embedded ? 0 : undefined,
        flex: embedded ? 1 : undefined,
        w: "100%",
        children: [
            !embedded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                px: 2,
                py: 2,
                align: "center",
                justify: "space-between",
                borderBottom: "1px solid",
                borderColor: "gray.200",
                bg: "white",
                flexShrink: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                        spacing: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "sm",
                            fontWeight: "semibold",
                            color: "gray.700",
                            children: "PDF"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                        spacing: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            "aria-label": "PDF in neuem Tab \xf6ffnen",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoOpen */.CNz, {}),
                            size: "sm",
                            variant: "outline",
                            as: "a",
                            href: proxyUrl,
                            target: "_blank",
                            rel: "noreferrer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                flex: "1",
                height: "100%",
                minH: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("object", {
                    data: proxyUrl,
                    type: "application/pdf",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        p: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "sm",
                                color: "gray.700",
                                fontWeight: "semibold",
                                children: "PDF not loading"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                mt: 2,
                                fontSize: "sm",
                                color: "gray.600",
                                children: "\xd6ffne die PDF alternativ in einem neuen Tab:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                mt: 3,
                                size: "sm",
                                variant: "outline",
                                as: "a",
                                href: proxyUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoOpen */.CNz, {}),
                                children: "PDF \xf6ffnen"
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/InvoiceAttachmentPreviewPanel.tsx






function InvoiceAttachmentPreviewPanel(param) {
    var invoiceId = param.invoiceId, attachmentUrl = param.attachmentUrl, isPdf = param.isPdf, invoiceKind = param.invoiceKind, shop = param.shop, dateIso = param.dateIso, invoiceNumber = param.invoiceNumber, total = param.total, totalNet = param.totalNet, tax = param.tax, currency = param.currency, canEditAttachment = param.canEditAttachment, onRemoveAttachment = param.onRemoveAttachment;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)("document"), tab = ref[0], setTab = ref[1];
    (0,react.useEffect)(function() {
        setTab("document");
    }, [
        invoiceId,
        attachmentUrl
    ]);
    var formattedDate = function() {
        try {
            return new Date(dateIso).toLocaleDateString("de-DE");
        } catch (e) {
            return dateIso;
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        className: "pdf-viewer",
        bg: "white",
        borderRadius: "lg",
        boxShadow: "lg",
        borderWidth: "1px",
        borderColor: "gray.200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            direction: "column",
            h: "100%",
            minH: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    px: 3,
                    pt: 3,
                    pb: 2,
                    flexShrink: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        bg: "gray.100",
                        p: 1,
                        borderRadius: "lg",
                        display: "inline-flex",
                        flexWrap: "wrap",
                        gap: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                size: "sm",
                                h: "32px",
                                px: 3,
                                borderRadius: "md",
                                fontWeight: tab === "document" ? "600" : "500",
                                bg: tab === "document" ? "white" : "transparent",
                                boxShadow: tab === "document" ? "sm" : "none",
                                color: tab === "document" ? "gray.800" : "gray.600",
                                _hover: tab !== "document" ? {
                                    bg: "white",
                                    boxShadow: "sm",
                                    color: "gray.800"
                                } : {},
                                onClick: function() {
                                    return setTab("document");
                                },
                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: io5_index_esm/* IoDocumentAttachOutline */.tJY,
                                    boxSize: 3.5,
                                    color: tab === "document" ? "rekening.600" : "gray.500"
                                }),
                                transition: "all 0.15s ease",
                                children: t("invoiceDetails.previewPanelTabDocument")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                size: "sm",
                                h: "32px",
                                px: 3,
                                borderRadius: "md",
                                fontWeight: tab === "summary" ? "600" : "500",
                                bg: tab === "summary" ? "white" : "transparent",
                                boxShadow: tab === "summary" ? "sm" : "none",
                                color: tab === "summary" ? "gray.800" : "gray.600",
                                _hover: tab !== "summary" ? {
                                    bg: "white",
                                    boxShadow: "sm",
                                    color: "gray.800"
                                } : {},
                                onClick: function() {
                                    return setTab("summary");
                                },
                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: io5_index_esm/* IoInformationCircleOutline */.ib5,
                                    boxSize: 3.5,
                                    color: tab === "summary" ? "rekening.600" : "gray.500"
                                }),
                                transition: "all 0.15s ease",
                                children: t("invoiceDetails.previewPanelTabSummary")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    flex: "1",
                    minH: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    children: tab === "document" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                px: 3,
                                py: 2,
                                borderBottomWidth: "1px",
                                borderColor: "gray.200",
                                justify: "flex-end",
                                flexShrink: 0,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                        label: t("invoiceDetails.preview"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            "aria-label": t("invoiceDetails.preview"),
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoOpen */.CNz, {}),
                                            size: "sm",
                                            variant: "outline",
                                            as: "a",
                                            href: attachmentUrl,
                                            target: "_blank",
                                            rel: "noreferrer"
                                        })
                                    }),
                                    canEditAttachment && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                        label: t("invoiceDetails.delete"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            "aria-label": t("invoiceDetails.delete"),
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTrash */.VOs, {}),
                                            size: "sm",
                                            variant: "outline",
                                            colorScheme: "red",
                                            onClick: function() {
                                                return void onRemoveAttachment();
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                flex: "1",
                                minH: 0,
                                position: "relative",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                children: isPdf ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfViewer, {
                                    url: attachmentUrl,
                                    embedded: true
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    h: "100%",
                                    w: "100%",
                                    bg: "gray.50",
                                    backgroundImage: "url(".concat(attachmentUrl, ")"),
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        px: 4,
                        py: 3,
                        overflowY: "auto",
                        flex: "1",
                        minH: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                            align: "stretch",
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            fontSize: "sm",
                                            fontWeight: "semibold",
                                            color: "gray.800",
                                            noOfLines: 2,
                                            children: shop || "—"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                            colorScheme: "gray",
                                            variant: "subtle",
                                            flexShrink: 0,
                                            children: invoiceKind === "travel-expense" ? t("invoiceDetails.travelExpense") : t("invoiceDetails.invoice")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: formattedDate
                                }),
                                invoiceNumber ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    color: "gray.600",
                                    children: [
                                        t("invoiceDetails.invoiceNumber"),
                                        ": ",
                                        invoiceNumber
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            color: "gray.500",
                                            fontWeight: "600",
                                            textTransform: "uppercase",
                                            children: t("invoiceDetails.sectionAmounts")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                            fontSize: "lg",
                                            fontWeight: "bold",
                                            color: "gray.800",
                                            mt: 1,
                                            children: [
                                                total,
                                                " ",
                                                currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                            fontSize: "sm",
                                            color: "gray.600",
                                            children: [
                                                totalNet,
                                                " (",
                                                tax,
                                                ") ",
                                                currency
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-currency-input-field/dist/index.esm.js
var react_currency_input_field_dist_index_esm = __webpack_require__(50246);
// EXTERNAL MODULE: ./node_modules/@hassanmojab/react-modern-calendar-datepicker/lib/index.js
var lib = __webpack_require__(95236);
// EXTERNAL MODULE: ./node_modules/chakra-react-select/dist/esm/select/select.js + 55 modules
var select_select = __webpack_require__(65266);
// EXTERNAL MODULE: ./src/components/BookingAccountSkr3Select.tsx + 1 modules
var BookingAccountSkr3Select = __webpack_require__(28413);
;// CONCATENATED MODULE: ./src/components/BuKeySelect.tsx






var BU_KEY_OPTIONS = [
    {
        value: "0",
        label: "0 - Automatikkonto – Steuerlogik wird vollst\xe4ndig \xfcber das Sachkonto gesteuert",
        meaning: "Automatikkonto – Steuerlogik wird vollst\xe4ndig \xfcber das Sachkonto gesteuert"
    },
    {
        value: "1",
        label: "1 - Steuerfreie Ums\xe4tze mit Vorsteuerabzug (\xa74 Nr. 2–7 UStG)",
        meaning: "Steuerfreie Ums\xe4tze mit Vorsteuerabzug (\xa74 Nr. 2–7 UStG)"
    },
    {
        value: "2",
        label: "2 - Umsatzsteuer 7% (erm\xe4\xdfigt)",
        meaning: "Umsatzsteuer 7% (erm\xe4\xdfigt)"
    },
    {
        value: "3",
        label: "3 - Umsatzsteuer 19% (Regelsatz)",
        meaning: "Umsatzsteuer 19% (Regelsatz)"
    },
    {
        value: "5",
        label: "5 - Innergemeinschaftlicher Erwerb 19%",
        meaning: "Innergemeinschaftlicher Erwerb 19%"
    },
    {
        value: "6",
        label: "6 - Innergemeinschaftlicher Erwerb 7%",
        meaning: "Innergemeinschaftlicher Erwerb 7%"
    },
    {
        value: "8",
        label: "8 - Vorsteuer 7%",
        meaning: "Vorsteuer 7%"
    },
    {
        value: "9",
        label: "9 - Vorsteuer 19%",
        meaning: "Vorsteuer 19%"
    },
    {
        value: "10",
        label: "10 - Nicht steuerbare innergemeinschaftliche Lieferung",
        meaning: "Nicht steuerbare innergemeinschaftliche Lieferung"
    },
    {
        value: "11",
        label: "11 - Steuerfreie innergemeinschaftliche Lieferung mit USt-IdNr.",
        meaning: "Steuerfreie innergemeinschaftliche Lieferung mit USt-IdNr."
    },
    {
        value: "95",
        label: "95 - Reverse-Charge-Verfahren (\xa713b UStG)",
        meaning: "Reverse-Charge-Verfahren (\xa713b UStG)"
    },
    {
        value: "96",
        label: "96 - Aufzuteilende Vorsteuer (allgemein)",
        meaning: "Aufzuteilende Vorsteuer (allgemein)"
    },
    {
        value: "97",
        label: "97 - Aufzuteilende Vorsteuer 19%",
        meaning: "Aufzuteilende Vorsteuer 19%"
    },
    {
        value: "98",
        label: "98 - Aufzuteilende Vorsteuer 7%",
        meaning: "Aufzuteilende Vorsteuer 7%"
    }, 
];
function toOption(value) {
    var v = (value || "").trim();
    if (!v) return null;
    return BU_KEY_OPTIONS.find(function(o) {
        return o.value === v;
    }) || {
        value: v,
        label: v
    };
}
function BuKeySelect(param) {
    var value = param.value, onChange = param.onChange, isDisabled = param.isDisabled, label = param.label, placeholder = param.placeholder, hint = param.hint;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
        children: [
            label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                fontSize: "sm",
                display: "flex",
                alignItems: "center",
                gap: 2,
                children: label
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* default */.Z, {
                placeholder: placeholder || "Select BU key",
                value: toOption(value),
                isDisabled: !!isDisabled,
                onChange: function(selectedOption) {
                    var ref;
                    return onChange(((ref = selectedOption) === null || ref === void 0 ? void 0 : ref.value) || "");
                },
                options: BU_KEY_OPTIONS,
                isSearchable: true,
                isClearable: true,
                size: "md",
                menuPortalTarget:  true ? document.body : 0,
                menuPosition: "fixed",
                styles: {
                    menuPortal: function(base) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                            zIndex: 2000
                        });
                    }
                }
            }),
            hint ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    fontSize: "xs",
                    color: "gray.500",
                    children: hint
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SelectCurrency.tsx




var SelectCurrency = function(param) {
    var changeValue = param.changeValue, disabled = param.disabled, value = param.value;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "smaller",
                mb: "1",
                fontWeight: "bold",
                children: t("currencyElement.currency")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                onChange: function(e) {
                    changeValue("currency", e.target.value);
                },
                value: value,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "EUR",
                        children: "€ (EURO)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "USD",
                        children: "$ (US DOLLAR)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "GBP",
                        children: "\xa3 (BRITISH POUND)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "JPY",
                        children: "\xa5 (JAPANESE YEN)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "INR",
                        children: "₹ (INDIAN RUPEE)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "CAD",
                        children: "$ (CANADIAN DOLLAR)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "CHF",
                        children: "CHf (SWISS FRANC)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "DKK",
                        children: "kr (DANISH KRONE)"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SelectCurrency = (SelectCurrency);

// EXTERNAL MODULE: ./node_modules/@tremor/react/dist/esm/index.js
var react_dist_esm = __webpack_require__(4206);
;// CONCATENATED MODULE: ./src/components/SelectBudget.tsx









var SelectBudget = function(param) {
    var changeValue = param.changeValue, disabled = param.disabled, value = param.value, categoriesData = param.categoriesData, isInvalid = param.isInvalid, session = param.session, api_url = param.api_url, invoiceDate = param.invoiceDate;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)({
        spending: {},
        totalSpending: 0.0
    }), budgetSpendingData = ref[0], setBudgetSpendingData = ref[1];
    var loadBudgetSpending = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(categoryId) {
            var fetchDataCategory, dataCategory;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(categoryId == undefined)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchDataCategory = axios_default().get("".concat(api_url, "/invoices/spendingPerCategory/").concat(categoryId), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchDataCategory;
                    case 6:
                        dataCategory = _ctx.sent;
                        if (dataCategory.status != 403 && dataCategory.status != 500) {
                            setBudgetSpendingData((0,_object_spread/* default */.Z)({}, dataCategory.data));
                        }
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    10
                ]
            ]);
        }));
        return function loadBudgetSpending(categoryId) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        loadBudgetSpending(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: "4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: "smaller",
                        mb: "1",
                        fontWeight: "bold",
                        children: t("selectBudgetElement.budget")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                        disabled: disabled,
                        value: value,
                        onChange: function(e) {
                            changeValue("category", e.target.value);
                        },
                        isInvalid: isInvalid,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "",
                                disabled: true,
                                selected: true,
                                children: t("selectBudgetElement.selectBudget")
                            }),
                            categoriesData.map(function(singleCategory) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: singleCategory._id,
                                    children: singleCategory.title
                                }, singleCategory._id + "-select");
                            })
                        ]
                    })
                ]
            }),
            categoriesData.map(function(singleCategory) {
                var monthlyBudget = "∞", annualBudget = "∞", totalBudget = "∞", budgetCurrency = "€", monthlySpending = Number(0).toFixed(0), annualSpending = Number(0).toFixed(0);
                var totalSpending = Number(0).toFixed(0);
                try {
                    totalSpending = budgetSpendingData.totalSpending.toFixed(0);
                } catch (error) {}
                var monthNew = new Date(invoiceDate).getMonth().toString();
                var yearNew = new Date(invoiceDate).getFullYear().toString();
                if (yearNew in budgetSpendingData.spending) {
                    annualSpending = Number(budgetSpendingData.spending[yearNew].totalSpending).toFixed(0);
                    if (monthNew in budgetSpendingData.spending[yearNew].monthlySpending) {
                        monthlySpending = Number(budgetSpendingData.spending[yearNew].monthlySpending[monthNew]).toFixed(0);
                    }
                }
                var percentageMonthly = 0, percentageAnnual = 0, percentageTotal = 0;
                if ("monthlyBudget" in singleCategory) {
                    monthlyBudget = Number(singleCategory.monthlyBudget).toFixed(0);
                    var percentageMonthlyTemp = Number((Number(monthlySpending) / singleCategory.monthlyBudget).toFixed(2)) * 100;
                    percentageMonthly = Number(percentageMonthlyTemp.toFixed(0));
                }
                if ("annualBudget" in singleCategory) {
                    annualBudget = Number(singleCategory.annualBudget).toFixed(0);
                    var percentageAnnualTemp = Number((Number(annualSpending) / Number(singleCategory.annualBudget)).toFixed(2)) * 100;
                    percentageAnnual = Number(percentageAnnualTemp.toFixed(0));
                }
                if ("totalBudget" in singleCategory) {
                    totalBudget = Number(singleCategory.totalBudget).toFixed(0);
                    var percentageTotalTemp = Number((Number(totalSpending) / Number(singleCategory.totalBudget)).toFixed(2)) * 100;
                    percentageTotal = Number(percentageTotalTemp.toFixed(0));
                }
                if ("currency" in singleCategory) {
                    if (singleCategory.currency == "EUR") {
                        budgetCurrency = "€";
                    } else if (singleCategory.currency == "USD") {
                        budgetCurrency = "$";
                    } else {
                        budgetCurrency = singleCategory.currency;
                    }
                }
                if (singleCategory._id == value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                        columns: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                mt: "2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "xs",
                                        children: t("selectBudgetElement.monthly")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    monthlySpending,
                                                    " ",
                                                    budgetCurrency,
                                                    " • ",
                                                    percentageMonthly,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    monthlyBudget,
                                                    " ",
                                                    budgetCurrency
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist_esm/* ProgressBar */.ko, {
                                        percentageValue: percentageMonthly,
                                        color: "orange"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                ml: "3",
                                mt: "2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "xs",
                                        children: t("selectBudgetElement.annual")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    annualSpending,
                                                    " ",
                                                    budgetCurrency,
                                                    " • ",
                                                    percentageAnnual,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    annualBudget,
                                                    " ",
                                                    budgetCurrency
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist_esm/* ProgressBar */.ko, {
                                        percentageValue: percentageAnnual,
                                        color: "orange"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                ml: "3",
                                mt: "2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "xs",
                                        children: t("selectBudgetElement.total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    totalSpending,
                                                    " ",
                                                    budgetCurrency,
                                                    " • ",
                                                    percentageTotal,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                children: [
                                                    totalBudget,
                                                    " ",
                                                    budgetCurrency
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dist_esm/* ProgressBar */.ko, {
                                        percentageValue: percentageTotal,
                                        color: "orange"
                                    })
                                ]
                            })
                        ]
                    }, singleCategory._id + "-data");
                }
            })
        ]
    });
};
/* harmony default export */ var components_SelectBudget = (SelectBudget);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 8 modules
var accordion_dist_index_esm = __webpack_require__(95070);
;// CONCATENATED MODULE: ./src/components/ChangeLogElement.tsx






var ChangeLogElement = function(param) {
    var value = param.value, userData = param.userData, _compact = param.compact, compact = _compact === void 0 ? false : _compact, _withAccordion = param.withAccordion, withAccordion = _withAccordion === void 0 ? true : _withAccordion;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var badgeProps = {
        variant: "subtle",
        colorScheme: "gray",
        fontSize: compact ? "2xs" : "xs",
        px: compact ? 1.5 : 2,
        py: 0.5,
        borderRadius: "md",
        lineHeight: "short"
    };
    var labelFontSize = compact ? "sm" : "md";
    var metaFontSize = compact ? "xs" : "sm";
    var cardPx = compact ? 3 : 4;
    var cardPy = compact ? 2 : 3;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        pt: withAccordion ? 0 : compact ? 0 : 4,
        children: Array.isArray(value) && value.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
            align: "stretch",
            spacing: compact ? 2 : 3,
            children: value.sort(function(a, b) {
                return b.date - a.date;
            }).map(function(changelogElement) {
                var ref, ref1;
                var userName = userData === null || userData === void 0 ? void 0 : (ref = userData.find) === null || ref === void 0 ? void 0 : (ref1 = ref.call(userData, function(obj) {
                    return (obj === null || obj === void 0 ? void 0 : obj._id) === changelogElement.user;
                })) === null || ref1 === void 0 ? void 0 : ref1.username;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    borderWidth: 1,
                    borderRadius: "md",
                    mt: 0,
                    px: cardPx,
                    py: cardPy,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                        align: "stretch",
                        spacing: compact ? 1 : 1.5,
                        children: [
                            changelogElement.updates.map(function(singleUpdate) {
                                var isCreated = singleUpdate.field == "created";
                                var _oldValue, _newValue;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    wrap: "wrap",
                                    align: "center",
                                    rowGap: 1,
                                    columnGap: 2,
                                    children: isCreated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, badgeProps), {
                                                children: String(singleUpdate.field).toUpperCase()
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: labelFontSize,
                                                children: t("changeLogelement.thisInvoice")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: labelFontSize,
                                                children: t("changeLogelement.changed")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, badgeProps), {
                                                children: singleUpdate.field
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: labelFontSize,
                                                children: t("changeLogelement.from")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, badgeProps), {
                                                maxW: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                children: String((_oldValue = singleUpdate.oldValue) !== null && _oldValue !== void 0 ? _oldValue : "")
                                            })),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: labelFontSize,
                                                children: t("changeLogelement.to")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, badgeProps), {
                                                maxW: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                children: String((_newValue = singleUpdate.newValue) !== null && _newValue !== void 0 ? _newValue : "")
                                            }))
                                        ]
                                    })
                                }, singleUpdate._id + "update");
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                spacing: 2,
                                wrap: "wrap",
                                children: [
                                    userName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontWeight: "600",
                                        fontSize: metaFontSize,
                                        children: userName
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        fontSize: metaFontSize,
                                        color: "gray.500",
                                        children: [
                                            new Date(changelogElement.date).toLocaleDateString(),
                                            " ",
                                            new Date(changelogElement.date).toLocaleTimeString()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, changelogElement._id + "-change");
            })
        })
    });
    if (!withAccordion) {
        return content;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
        mt: compact ? 0 : "8",
        pb: compact ? 0 : 10,
        borderBottom: "0px solid white",
        allowToggle: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                    className: "without-highligt",
                    pt: compact ? 2 : 4,
                    pb: compact ? 2 : 4,
                    paddingLeft: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            as: "h3",
                            size: compact ? "sm" : "md",
                            children: t("changeLogelement.changeHistory")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                    pb: compact ? 2 : 4,
                    pl: 0,
                    pr: 0,
                    children: content
                })
            ]
        })
    });
};
/* harmony default export */ var components_ChangeLogElement = (ChangeLogElement);

;// CONCATENATED MODULE: ./src/components/InvoiceStatusElement.tsx





var InvoiceStatusElement = function(param) {
    var changeValue = param.changeValue, typeName = param.typeName, invoiceType = param.invoiceType, invoiceStatus = param.invoiceStatus, invoiceTypesData = param.invoiceTypesData, nextStepAllowed = param.nextStepAllowed, createInvoice = param.createInvoice;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                    templateColumns: "repeat(8, 1fr)",
                    gap: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                            colSpan: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                as: "h3",
                                size: "md",
                                children: [
                                    typeName,
                                    " ",
                                    t("invoiceStatusElement.status")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                            colSpan: 6,
                            children: [
                                nextStepAllowed && createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                    size: "sm",
                                    float: "right",
                                    colorScheme: "green",
                                    onClick: function() {
                                        changeValue("approve");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
                                            fontSize: "20px",
                                            style: {
                                                marginRight: "5px"
                                            }
                                        }),
                                        t("invoiceStatusElement.approveSave")
                                    ]
                                }),
                                nextStepAllowed && createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                    size: "sm",
                                    float: "right",
                                    mr: "4",
                                    colorScheme: "red",
                                    onClick: function() {
                                        changeValue("reject");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloseCircle */.R5A, {
                                            fontSize: "20px",
                                            style: {
                                                marginRight: "5px"
                                            }
                                        }),
                                        t("invoiceStatusElement.rejectSave")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                width: "100%",
                className: "Test",
                mt: "1",
                children: invoiceType != undefined && invoiceType != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    mt: "3",
                    children: invoiceTypesData.find(function(e) {
                        return e._id == invoiceType;
                    }) != undefined && invoiceTypesData.find(function(e) {
                        return e._id == invoiceType;
                    }).steps.map(function(singleStep, singleStepIndex) {
                        var spacerElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                            mt: "2",
                            ml: "1",
                            mr: "1"
                        }, singleStep._id + "-divider");
                        if (singleStepIndex == invoiceTypesData.find(function(e) {
                            return e._id == invoiceType;
                        }).steps.length - 1) {
                            spacerElement = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
                        }
                        var colorSchemeButton = "#E2E8F0";
                        if (invoiceStatus == singleStep._id) {
                            colorSchemeButton = singleStep.color;
                        }
                        return [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                    label: singleStep.description,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
                                            borderRadius: "full",
                                            px: "2",
                                            pr: "28px",
                                            backgroundColor: colorSchemeButton,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
                                                    style: {
                                                        float: "left",
                                                        marginTop: "2px",
                                                        marginRight: "3px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    children: singleStep.title
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, singleStep._id + "edit-inv"),
                            spacerElement
                        ];
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                mt: 5
            })
        ]
    });
};
/* harmony default export */ var components_InvoiceStatusElement = (InvoiceStatusElement);

;// CONCATENATED MODULE: ./src/components/SelectInvoiceType.tsx




var SelectInvoiceType = function(param) {
    var changeValue = param.changeValue, disabled = param.disabled, isInvalid = param.isInvalid, value = param.value, invoiceTypesData = param.invoiceTypesData;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mt: "2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "smaller",
                mb: "1",
                fontWeight: "bold",
                children: t("selectInvoiceTypeElement.flowType")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                value: value,
                onChange: function(e) {
                    changeValue("invoiceType", e.target.value);
                },
                disabled: disabled,
                isInvalid: isInvalid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "",
                        disabled: true,
                        selected: true,
                        children: t("selectInvoiceTypeElement.pleaseSelect")
                    }),
                    invoiceTypesData.map(function(singleCategory) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: singleCategory._id,
                            children: singleCategory.title
                        }, singleCategory._id + "edit-inv");
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SelectInvoiceType = (SelectInvoiceType);

// EXTERNAL MODULE: ./node_modules/react-google-places-autocomplete/build/index.es.js
var index_es = __webpack_require__(86594);
;// CONCATENATED MODULE: ./src/components/TravelExpenseElement.tsx








var TravelExpensesElement = function(param) {
    var changeText = param.changeText, countryListAllowance = param.countryListAllowance, travelExpense = param.travelExpense, readOnlyAdminFields = param.readOnlyAdminFields, editInvoiceErrorArray = param.editInvoiceErrorArray, updateMeals = param.updateMeals, changeTravelExpenseLocation = param.changeTravelExpenseLocation, invoiceTypeNextStepAllowed = param.invoiceTypeNextStepAllowed, invoiceData = param.invoiceData;
    var ref = (0,react.useState)({
        from: null,
        to: null
    }), selectedDayRange = ref[0], setSelectedDayRange = ref[1];
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var ref1 = (0,react.useState)(0), countTravelDays = ref1[0], setCountTravelDays = ref1[1];
    var ref2 = (0,react.useState)("08:00"), startTime = ref2[0], setStartTime = ref2[1];
    var ref3 = (0,react.useState)("18:00"), endTime = ref3[0], setEndTime = ref3[1];
    var ref4 = (0,react.useState)(0), durationDays = ref4[0], setDurationDays = ref4[1];
    react.useEffect(function() {
        var startDate = null, endDate = null;
        if (travelExpense.startDate !== null) {
            var utcDateStart = new Date(travelExpense.startDate);
            var localDateStart = utcDateStart.toLocaleDateString(); // Format: MM/DD/YYYY (may vary based on locale)
            var localTimeStart = utcDateStart.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            }); // Format: HH:mm (24-hour format)
            startDate = {
                year: utcDateStart.getFullYear(),
                month: utcDateStart.getMonth() + 1,
                day: utcDateStart.getDate()
            };
            setStartTime(localTimeStart);
        }
        if (travelExpense.endDate !== null) {
            var utcDateEnd = new Date(travelExpense.endDate);
            var localDateEnd = utcDateEnd.toLocaleDateString(); // Format: MM/DD/YYYY (may vary based on locale)
            var localTimeEnd = utcDateEnd.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            }); // Format: HH:mm (24-hour format)
            endDate = {
                year: utcDateEnd.getFullYear(),
                month: utcDateEnd.getMonth() + 1,
                day: utcDateEnd.getDate()
            };
            setEndTime(localTimeEnd);
        }
        setSelectedDayRange({
            from: startDate,
            to: endDate
        });
        console.log("Here we go:");
        console.log(startDate, endDate);
        console.log(travelExpense.startDate);
    }, [
        travelExpense
    ]);
    /*
    React.useEffect(() => {
        updateFromToDate()
    }, [isTravelExpenseOpen] )
    */ var calculateDaysBetweenDates = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(startDateStr, endDateStr) {
            var startDate, endDate, differenceInTime, differenceInDays;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        startDate = new Date(startDateStr);
                        endDate = new Date(endDateStr);
                        differenceInTime = endDate.getTime() - startDate.getTime();
                        differenceInDays = differenceInTime / (1000 * 3600 * 24);
                        return _ctx.abrupt("return", differenceInDays + 1);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function calculateDaysBetweenDates(startDateStr, endDateStr) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeTime = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e, key) {
            var time, startDate;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log(e.currentTarget.value);
                        time = e.currentTarget.value.split(":");
                        ;
                        if (key == "startDate") {
                            startDate = new Date(Date.UTC(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day));
                            setStartTime(e.currentTarget.value);
                        } else {
                            startDate = new Date(Date.UTC(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day));
                            setEndTime(e.currentTarget.value);
                        }
                        startDate.setHours(time[0]);
                        startDate.setMinutes(time[1]);
                        changeText(key, startDate.toUTCString());
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeTime(e, key) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeInvoiceDate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(newDate) {
            var utcDateEnd, utcDateStart, oneDayInMilliseconds, differenceInMilliseconds, numberOfDays, mealsArray, i;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log(newDate);
                        if (newDate.from != null && newDate.to != null) {
                            utcDateEnd = new Date(Date.UTC(newDate.to.year, newDate.to.month - 1, newDate.to.day));
                            utcDateStart = new Date(Date.UTC(newDate.from.year, newDate.from.month - 1, newDate.from.day));
                            changeText("startDate", utcDateStart.toISOString());
                            changeText("endDate", utcDateEnd.toISOString());
                            oneDayInMilliseconds = 1000 * 60 * 60 * 24; // 1000 milliseconds * 60 seconds * 60 minutes * 24 hours
                            differenceInMilliseconds = utcDateEnd.getTime() - utcDateStart.getTime();
                            numberOfDays = Math.round(differenceInMilliseconds / oneDayInMilliseconds) + 1;
                            setCountTravelDays(numberOfDays);
                            mealsArray = [];
                            for(i = 0; i < numberOfDays; i++){
                                mealsArray.push({
                                    breakfast: false,
                                    lunch: false,
                                    dinner: false
                                });
                            }
                            changeText("meals", mealsArray);
                        }
                        setSelectedDayRange(newDate);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        /*
        const invoiceDate = new Date(newDate.year, newDate.month -1, newDate.day);
        invoiceDate.setHours(12);
        let openInvoiceData = newInvoice;
        if(createInvoice == false){
          openInvoiceData = rekeningData[selectedInvoice];
        }
        openInvoiceData.date = invoiceDate.toUTCString();
        saveInvoiceData(openInvoiceData);
        */ }));
        return function changeInvoiceDate(newDate) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderCustomInput = function(param) {
        var ref = param.ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
            readOnly: true,
            ref: ref,
            style: {
                width: "100%"
            },
            placeholder: t("travelExpenseElement.selectDateRange"),
            value: selectedDayRange.from && selectedDayRange.to ? "".concat(selectedDayRange.from.day, ".").concat(selectedDayRange.from.month, ".").concat(selectedDayRange.from.year, " - ").concat(selectedDayRange.to.day, ".").concat(selectedDayRange.to.month, ".").concat(selectedDayRange.to.year) : ""
        });
    };
    console.log("travel Expense", travelExpense);
    var invoiceCurrency = invoiceData.currency;
    if (invoiceCurrency == "EUR" || invoiceCurrency == "" || invoiceCurrency == undefined) {
        invoiceCurrency = "€";
    } else if (invoiceCurrency == "USD") {
        invoiceCurrency = "$";
    } else if (invoiceCurrency == "JPY") {
        invoiceCurrency = "\xa5";
    } else if (invoiceCurrency == "GBP") {
        invoiceCurrency = "\xa3";
    } else if (invoiceCurrency == "INR") {
        invoiceCurrency = "₹";
    } else if (invoiceCurrency == "CAD") {
        invoiceCurrency = "$";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mt: "2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                mt: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                mt: "4",
                as: "h3",
                size: "md",
                children: [
                    t("travelExpenseElement.details"),
                    " ",
                    countTravelDays,
                    " ",
                    t("travelExpenseElement.days")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                templateColumns: "repeat(4, 1fr)",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.startEnd")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                    renderInput: renderCustomInput,
                                    value: selectedDayRange,
                                    onChange: changeInvoiceDate,
                                    colorPrimary: "#1a5f3f"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.startTime")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                    value: startTime,
                                    onChange: function(e) {
                                        onChangeTime(e, "startDate");
                                    },
                                    className: "rekening-time-picker",
                                    type: "time",
                                    isInvalid: editInvoiceErrorArray.includes("startDate")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.endTime")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                    value: endTime,
                                    onChange: function(e) {
                                        onChangeTime(e, "endDate");
                                    },
                                    className: "rekening-time-picker",
                                    type: "time",
                                    isInvalid: editInvoiceErrorArray.includes("endDate")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                templateColumns: "repeat(2, 1fr)",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.startPoint")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                    apiKey: "AIzaSyDXHKiEW7UtIE2o21UDOCPMfunsIQUa3fA",
                                    selectProps: {
                                        value: {
                                            label: travelExpense.locationFrom,
                                            value: {
                                                place_id: travelExpense.locationFromPlaceId,
                                                reference: "",
                                                description: travelExpense.locationFrom
                                            }
                                        },
                                        onChange: function(value) {
                                            return changeTravelExpenseLocation("locationFrom", value);
                                        },
                                        placeholder: "Please type"
                                    },
                                    apiOptions: {
                                        language: "en"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.destination")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                    apiKey: "AIzaSyDXHKiEW7UtIE2o21UDOCPMfunsIQUa3fA",
                                    selectProps: {
                                        value: {
                                            label: travelExpense.locationTo,
                                            value: {
                                                place_id: travelExpense.locationToPlaceId,
                                                reference: "",
                                                description: travelExpense.locationTo
                                            }
                                        },
                                        onChange: function(value) {
                                            return changeTravelExpenseLocation("locationTo", value);
                                        }
                                    },
                                    apiOptions: {
                                        language: "en"
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                templateColumns: "repeat(2, 1fr)",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.transportation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                    value: travelExpense.transportation,
                                    onChange: function(evt) {
                                        return changeText("transportation", evt.target.value);
                                    },
                                    isInvalid: editInvoiceErrorArray.includes("transportation"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "train",
                                            children: t("travelExpenseElement.train")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "plain",
                                            children: t("travelExpenseElement.plane")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: "own car",
                                            children: [
                                                t("travelExpenseElement.plane"),
                                                "Own Car"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: "business car",
                                            children: [
                                                t("travelExpenseElement.businessCar"),
                                                "Business Car"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.distance")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                    placeholder: t("travelExpenseElement.typeHere"),
                                    value: travelExpense.transportationDistance,
                                    onChange: function(evt) {
                                        return changeText("transportationDistance", evt.target.value);
                                    },
                                    isInvalid: editInvoiceErrorArray.includes("transportationDistance")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                templateColumns: "repeat(4, 1fr)",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "smaller",
                                    mb: "1",
                                    fontWeight: "bold",
                                    children: t("travelExpenseElement.county")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                                    value: travelExpense.country,
                                    onChange: function(evt) {
                                        return changeText("country", evt.target.value);
                                    },
                                    children: countryListAllowance.map(function(country) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: country.code,
                                            children: country.name
                                        }, country.code);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        mt: "4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "smaller",
                                mb: "1",
                                fontWeight: "bold",
                                children: t("travelExpenseElement.arrivalDeparture")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                readOnly: readOnlyAdminFields,
                                onChange: function(evt) {
                                    return changeText("allowanceSmall", evt.target.value);
                                },
                                type: "number",
                                value: travelExpense.allowanceSmall
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        mt: "4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "smaller",
                                mb: "1",
                                fontWeight: "bold",
                                children: t("travelExpenseElement.fullDay")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                readOnly: readOnlyAdminFields,
                                onChange: function(evt) {
                                    return changeText("allowanceBig", evt.target.value);
                                },
                                type: "number",
                                value: travelExpense.allowanceBig
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                mt: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                mt: "4",
                as: "h3",
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                    label: "The meals payed by your company",
                    "aria-label": "The meals payed by your company",
                    children: t("travelExpenseElement.meals")
                })
            }),
            "meals" in travelExpense && travelExpense.meals.map(function(singleMeal, dayIndex) {
                // Create a Date object from the startDate
                var mealDate = new Date(travelExpense.startDate);
                // Increase the date by 1 day
                mealDate.setDate(mealDate.getDate() + dayIndex);
                // Format the new date in 'de-DE' format and append "1 Tag"
                var formattedMealDate = mealDate.toLocaleDateString("de-DE");
                var marginTop = 3;
                var deductionBreakfast = parseFloat(travelExpense.allowanceBig) * 0.2;
                var deductionLunch = parseFloat(travelExpense.allowanceBig) * 0.4;
                var deductionDinner = parseFloat(travelExpense.allowanceBig) * 0.4;
                var allowance = parseFloat(travelExpense.allowanceBig);
                if (dayIndex == 0 || dayIndex == travelExpense.meals.length - 1) {
                    allowance = parseFloat(travelExpense.allowanceSmall);
                }
                if (singleMeal.breakfast == false) {
                    deductionBreakfast = 0;
                }
                if (singleMeal.lunch == false) {
                    deductionLunch = 0;
                }
                if (singleMeal.dinner == false) {
                    deductionDinner = 0;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                            templateColumns: "repeat(5, 1fr)",
                            gap: 3,
                            marginTop: "1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                        mt: "4",
                                        as: "h5",
                                        size: "sm",
                                        children: formattedMealDate
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                        mt: marginTop,
                                        size: "md",
                                        colorScheme: "orange",
                                        isChecked: singleMeal.breakfast,
                                        onChange: function(e) {
                                            return updateMeals(dayIndex, "breakfast", e.target.checked);
                                        },
                                        children: t("travelExpenseElement.breakfast")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                        mt: marginTop,
                                        size: "md",
                                        colorScheme: "orange",
                                        isChecked: singleMeal.lunch,
                                        onChange: function(e) {
                                            return updateMeals(dayIndex, "lunch", e.target.checked);
                                        },
                                        children: t("travelExpenseElement.lunch")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                        mt: marginTop,
                                        size: "md",
                                        colorScheme: "orange",
                                        isChecked: singleMeal.dinner,
                                        onChange: function(e) {
                                            return updateMeals(dayIndex, "dinner", e.target.checked);
                                        },
                                        children: t("travelExpenseElement.dinner")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                            templateColumns: "repeat(5, 1fr)",
                            gap: 3,
                            marginTop: "0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    mt: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        children: [
                                            allowance,
                                            "€"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: deductionBreakfast != 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        ml: "6",
                                        children: [
                                            "- ",
                                            deductionBreakfast.toFixed(2),
                                            invoiceCurrency
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: deductionLunch != 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        ml: "6",
                                        children: [
                                            "- ",
                                            deductionLunch.toFixed(2),
                                            invoiceCurrency
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: deductionDinner != 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        ml: "6",
                                        children: [
                                            "- ",
                                            deductionDinner.toFixed(2),
                                            invoiceCurrency
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                    colSpan: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        children: [
                                            "= ",
                                            Math.max(allowance - deductionBreakfast - deductionLunch - deductionDinner, 0).toFixed(2),
                                            invoiceCurrency
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                });
            }),
            "meals" in travelExpense && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                className: "travelExpenseTotal",
                templateColumns: "repeat(5, 1fr)",
                gap: 3,
                marginTop: "2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        mt: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                children: t("travelExpenseElement.total")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                        colSpan: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                children: [
                                    "= ",
                                    invoiceData.total,
                                    invoiceCurrency
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelExpenseElement = (TravelExpensesElement);

// EXTERNAL MODULE: ./src/components/DeleteModal.tsx
var DeleteModal = __webpack_require__(47894);
// EXTERNAL MODULE: ./src/components/CreditorManager.tsx
var CreditorManager = __webpack_require__(51355);
// EXTERNAL MODULE: ./src/components/comments/commentModel.ts
var commentModel = __webpack_require__(32520);
// EXTERNAL MODULE: ./src/components/comments/CommentThread.tsx
var CommentThread = __webpack_require__(3770);
// EXTERNAL MODULE: ./src/components/comments/MentionTextarea.tsx
var MentionTextarea = __webpack_require__(62179);
// EXTERNAL MODULE: ./src/components/comments/mentionUtils.ts
var mentionUtils = __webpack_require__(90507);
;// CONCATENATED MODULE: ./src/components/comments/InvoiceCommentsSection.tsx










function apiCall(apiUrl, path, accessToken, method, body) {
    return _apiCall.apply(this, arguments);
}
function _apiCall() {
    _apiCall = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(apiUrl, path, accessToken, method, body) {
        var res, text, json, ref, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat(apiUrl).concat(path), {
                        method: method,
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json"
                        },
                        body: body ? JSON.stringify(body) : undefined
                    });
                case 2:
                    res = _ctx.sent;
                    _ctx.next = 5;
                    return res.text().catch(function() {
                        return "";
                    });
                case 5:
                    text = _ctx.sent;
                    json = text ? function() {
                        try {
                            return JSON.parse(text);
                        } catch (e) {
                            return undefined;
                        }
                    }() : undefined;
                    if (res.ok) {
                        _ctx.next = 11;
                        break;
                    }
                    ;
                    msg = json && (((ref = json.message) === null || ref === void 0 ? void 0 : ref[0]) || json.message || json.error) || text || "".concat(res.status, " ").concat(res.statusText);
                    throw new Error(String(msg));
                case 11:
                    return _ctx.abrupt("return", json);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _apiCall.apply(this, arguments);
}
function InvoiceCommentsSection(param) {
    var apiUrl = param.apiUrl, invoice = param.invoice, invoiceId = param.invoiceId, session = param.session, userData = param.userData, onRefresh = param.onRefresh, isDisabled = param.isDisabled;
    var ref, ref1;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var ref2 = (0,react.useState)(""), text = ref2[0], setText = ref2[1];
    var ref3 = (0,react.useState)(false), isBusy = ref3[0], setIsBusy = ref3[1];
    var ref4 = (0,react.useState)([]), localComments = ref4[0], setLocalComments = ref4[1];
    var candidates = (0,react.useMemo)(function() {
        return (0,mentionUtils/* normalizeMentionCandidates */.X0)(userData);
    }, [
        userData
    ]);
    var byId = (0,react.useMemo)(function() {
        var m = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var u = _step.value;
                m.set(u._id, u);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return m;
    }, [
        candidates
    ]);
    (0,react.useEffect)(function() {
        var initial = Array.isArray(invoice === null || invoice === void 0 ? void 0 : invoice.comments) && invoice.comments || Array.isArray(invoice === null || invoice === void 0 ? void 0 : invoice.comment) && invoice.comment || Array.isArray(invoice === null || invoice === void 0 ? void 0 : invoice.commentThreads) && invoice.commentThreads || [];
        setLocalComments(initial);
    }, [
        invoiceId,
        invoice
    ]);
    var comments = (0,react.useMemo)(function() {
        return (0,commentModel/* normalizeCommentsFromInvoice */.B)({
            comments: localComments
        });
    }, [
        localComments
    ]);
    var canMutate = Boolean(!isDisabled && invoiceId && (session === null || session === void 0 ? void 0 : session.accessToken));
    var extractComments = function(inv) {
        if (Array.isArray(inv === null || inv === void 0 ? void 0 : inv.comments)) return inv.comments;
        if (Array.isArray(inv === null || inv === void 0 ? void 0 : inv.comment)) return inv.comment;
        if (Array.isArray(inv === null || inv === void 0 ? void 0 : inv.commentThreads)) return inv.commentThreads;
        return [];
    };
    var reloadComments = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return fetch("".concat(apiUrl, "/invoices/").concat(invoiceId), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 4:
                        res = _ctx.sent;
                        if (res.ok) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("".concat(res.status, " ").concat(res.statusText));
                    case 7:
                        _ctx.next = 9;
                        return res.json().catch(function() {
                            return {};
                        });
                    case 9:
                        json = _ctx.sent;
                        setLocalComments(extractComments(json));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reloadComments() {
            return _ref.apply(this, arguments);
        };
    }();
    var refresh = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return reloadComments();
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                        try {
                            void (onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh());
                        } catch (e) {
                        // ignore
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function refresh() {
            return _ref.apply(this, arguments);
        };
    }();
    var addComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var prepared, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        prepared = (0,mentionUtils/* formatMentionsForApi */.z4)(text.trim(), candidates);
                        payload = {
                            text: prepared.text,
                            mentionedUserIds: prepared.mentionedUserIds
                        };
                        setIsBusy(true);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return apiCall(apiUrl, "/invoices/".concat(invoiceId, "/comments"), session.accessToken, "POST", payload);
                    case 8:
                        setText("");
                        _ctx.next = 11;
                        return refresh();
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](5);
                        toast({
                            title: t("comments.errorTitle"),
                            description: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || t("comments.errorGeneric"),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 16:
                        _ctx.prev = 16;
                        setIsBusy(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    13,
                    16,
                    19
                ]
            ]);
        }));
        return function addComment() {
            return _ref.apply(this, arguments);
        };
    }();
    var reply = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commentId, replyText) {
            var prepared, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        prepared = (0,mentionUtils/* formatMentionsForApi */.z4)(replyText.trim(), candidates);
                        payload = {
                            text: prepared.text,
                            mentionedUserIds: prepared.mentionedUserIds
                        };
                        setIsBusy(true);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return apiCall(apiUrl, "/invoices/".concat(invoiceId, "/comments/").concat(commentId, "/replies"), session.accessToken, "POST", payload);
                    case 8:
                        _ctx.next = 10;
                        return refresh();
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        toast({
                            title: t("comments.errorTitle"),
                            description: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || t("comments.errorGeneric"),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 15:
                        _ctx.prev = 15;
                        setIsBusy(false);
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12,
                    15,
                    18
                ]
            ]);
        }));
        return function reply(commentId, replyText) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commentId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setIsBusy(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return apiCall(apiUrl, "/invoices/".concat(invoiceId, "/comments/").concat(commentId), session.accessToken, "DELETE");
                    case 6:
                        _ctx.next = 8;
                        return refresh();
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        toast({
                            title: t("comments.errorTitle"),
                            description: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || t("comments.errorGeneric"),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 13:
                        _ctx.prev = 13;
                        setIsBusy(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10,
                    13,
                    16
                ]
            ]);
        }));
        return function deleteComment(commentId) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteReply = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commentId, replyId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setIsBusy(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return apiCall(apiUrl, "/invoices/".concat(invoiceId, "/comments/").concat(commentId, "/replies/").concat(replyId), session.accessToken, "DELETE");
                    case 6:
                        _ctx.next = 8;
                        return refresh();
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        toast({
                            title: t("comments.errorTitle"),
                            description: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || t("comments.errorGeneric"),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 13:
                        _ctx.prev = 13;
                        setIsBusy(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10,
                    13,
                    16
                ]
            ]);
        }));
        return function deleteReply(commentId, replyId) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleDone = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commentId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!invoiceId || !(session === null || session === void 0 ? void 0 : session.accessToken))) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setIsBusy(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return apiCall(apiUrl, "/invoices/".concat(invoiceId, "/comments/").concat(commentId, "/status"), session.accessToken, "PUT");
                    case 6:
                        _ctx.next = 8;
                        return refresh();
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        toast({
                            title: t("comments.errorTitle"),
                            description: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || t("comments.errorGeneric"),
                            status: "error",
                            duration: 6000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 13:
                        _ctx.prev = 13;
                        setIsBusy(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10,
                    13,
                    16
                ]
            ]);
        }));
        return function toggleDone(commentId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        align: "stretch",
        spacing: 4,
        children: [
            !invoiceId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "sm",
                color: "gray.600",
                children: t("comments.notAvailable")
            }) : null,
            comments.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "sm",
                color: "gray.600",
                children: t("comments.empty")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentThread/* default */.Z, {
                comments: comments,
                candidates: candidates,
                getUser: function(id) {
                    return byId.get(id);
                },
                currentUserId: (ref = session) === null || ref === void 0 ? void 0 : (ref1 = ref.user_data) === null || ref1 === void 0 ? void 0 : ref1._id,
                isBusy: isBusy,
                canMutate: canMutate,
                onReply: reply,
                onDeleteComment: deleteComment,
                onDeleteReply: deleteReply,
                onToggleDone: toggleDone
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                pt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionTextarea/* default */.Z, {
                    value: text,
                    onChange: setText,
                    candidates: candidates,
                    placeholder: t("comments.placeholder"),
                    isDisabled: !canMutate || isBusy,
                    onSubmit: addComment,
                    actionLabel: t("comments.send"),
                    onAction: addComment,
                    isActionLoading: isBusy,
                    isActionDisabled: !text.trim()
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/TransactionSelectorDrawer.tsx











var TransactionSelectorDrawer = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onSelect = param.onSelect, apiUrl = param.apiUrl, session = param.session, excludeTransactionId = param.excludeTransactionId, _excludeTransactionIds = param.excludeTransactionIds, excludeTransactionIds = _excludeTransactionIds === void 0 ? [] : _excludeTransactionIds, _showLinkedOnly = param.showLinkedOnly, showLinkedOnly = _showLinkedOnly === void 0 ? false : _showLinkedOnly, _showUnlinkedOnly = param.showUnlinkedOnly, showUnlinkedOnly = _showUnlinkedOnly === void 0 ? false : _showUnlinkedOnly;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var ref = (0,react.useState)([]), transactions = ref[0], setTransactions = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(""), searchText = ref2[0], setSearchText = ref2[1];
    var ref3 = (0,react.useState)(""), appliedSearchText = ref3[0], setAppliedSearchText = ref3[1];
    var ref4 = (0,react.useState)(1), currentPage = ref4[0], setCurrentPage = ref4[1];
    var ref5 = (0,react.useState)(true), hasMore = ref5[0], setHasMore = ref5[1];
    var ref6 = (0,react.useState)(false), isLoadingMore = ref6[0], setIsLoadingMore = ref6[1];
    var scrollContainerRef = (0,react.useRef)(null);
    // Load transactions
    var loadTransactions = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var pageNumber, searchQuery, queryString, response, fetchedTransactions, allExcluded, transactionsWithLinks, ref, ref1, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    pageNumber = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 1, searchQuery = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "";
                    if (session === null || session === void 0 ? void 0 : session.accessToken) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    if (pageNumber === 1) {
                        setIsLoading(true);
                    } else {
                        setIsLoadingMore(true);
                    }
                    _ctx.prev = 4;
                    queryString = "?page=".concat(pageNumber, "&pageSize=25");
                    // Add search filter
                    if (searchQuery) {
                        queryString += "&counterparty=".concat(encodeURIComponent(searchQuery));
                    }
                    // Add link status filter
                    if (showLinkedOnly) {
                        queryString += "&linkStatus=linked";
                    } else if (showUnlinkedOnly) {
                        queryString += "&linkStatus=unlinked";
                    }
                    _ctx.next = 10;
                    return axios_default().get("".concat(apiUrl, "/transactions").concat(queryString), {
                        headers: {
                            Authorization: "Bearer ".concat(session.accessToken)
                        }
                    });
                case 10:
                    response = _ctx.sent;
                    fetchedTransactions = response.data || [];
                    allExcluded = (0,_to_consumable_array/* default */.Z)(excludeTransactionIds);
                    if (excludeTransactionId) allExcluded.push(excludeTransactionId);
                    if (allExcluded.length > 0) {
                        fetchedTransactions = fetchedTransactions.filter(function(tx) {
                            return !allExcluded.includes(tx._id);
                        });
                    }
                    transactionsWithLinks = fetchedTransactions.map(function(transaction) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transaction), {
                            linkedToInvoice: !!transaction.linkedToInvoice
                        });
                    });
                    if (pageNumber === 1) {
                        setTransactions(transactionsWithLinks);
                    } else {
                        setTransactions(function(prev) {
                            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(transactionsWithLinks));
                        });
                    }
                    setHasMore(fetchedTransactions.length === 25);
                    setCurrentPage(pageNumber);
                    _ctx.next = 26;
                    break;
                case 21:
                    _ctx.prev = 21;
                    _ctx.t0 = _ctx["catch"](4);
                    ;
                    console.error("Error loading transactions:", _ctx.t0);
                    toast({
                        title: t("components.transactions.errors.loadError") || "Error loading transactions",
                        description: ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || t("components.transactions.errors.loadErrorDescription") || "Could not load transactions",
                        status: "error",
                        duration: 5000,
                        isClosable: true
                    });
                case 26:
                    _ctx.prev = 26;
                    setIsLoading(false);
                    setIsLoadingMore(false);
                    return _ctx.finish(26);
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                21,
                26,
                30
            ]
        ]);
    })), [
        session,
        apiUrl,
        excludeTransactionId,
        excludeTransactionIds,
        showLinkedOnly,
        showUnlinkedOnly,
        toast,
        t
    ]);
    // Handle search on Enter key
    var handleSearch = function() {
        setAppliedSearchText(searchText);
        setCurrentPage(1);
        loadTransactions(1, searchText);
    };
    // Handle scroll for infinite loading
    var handleScroll = (0,react.useCallback)(function() {
        var container = scrollContainerRef.current;
        if (!container || isLoadingMore || !hasMore) return;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var clientHeight = container.clientHeight;
        // Load more when user scrolls to 80% of the content
        if (scrollTop + clientHeight >= scrollHeight * 0.8) {
            loadTransactions(currentPage + 1, appliedSearchText);
        }
    }, [
        currentPage,
        appliedSearchText,
        hasMore,
        isLoadingMore,
        loadTransactions
    ]);
    // Load transactions when drawer opens
    (0,react.useEffect)(function() {
        if (isOpen) {
            setSearchText("");
            setAppliedSearchText("");
            setCurrentPage(1);
            loadTransactions(1, "");
        }
    }, [
        isOpen,
        loadTransactions
    ]);
    // Setup scroll listener
    (0,react.useEffect)(function() {
        var container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll
    ]);
    // Handle transaction selection
    var handleSelectTransaction = function(transaction) {
        onSelect(transaction);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
        isOpen: isOpen,
        placement: "right",
        size: "md",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
                        borderBottomWidth: "1px",
                        children: t("components.transactions.selectTransaction") || "Select Transaction"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerBody */.Ng, {
                        p: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                p: 4,
                                borderBottomWidth: "1px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* InputGroup */.BZ, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* InputLeftElement */.Z8, {
                                                pointerEvents: "none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearch */.eaK, {
                                                    color: "gray.300"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                placeholder: t("components.transactions.searchPlaceholder") || "Search by counterparty name...",
                                                value: searchText,
                                                onChange: function(e) {
                                                    return setSearchText(e.target.value);
                                                },
                                                onKeyDown: function(e) {
                                                    if (e.key === "Enter") {
                                                        handleSearch();
                                                    }
                                                },
                                                bg: "white",
                                                borderColor: "gray.300",
                                                _hover: {
                                                    borderColor: "gray.400"
                                                },
                                                _focus: {
                                                    borderColor: "green.500",
                                                    boxShadow: "0 0 0 1px rgb(49, 206, 167)"
                                                }
                                            })
                                        ]
                                    }),
                                    searchText && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        mt: 2,
                                        size: "sm",
                                        colorScheme: "rekening",
                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearch */.eaK, {}),
                                        onClick: handleSearch,
                                        width: "full",
                                        children: t("components.transactions.filter") || "Search"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                ref: scrollContainerRef,
                                overflowY: "auto",
                                maxH: "calc(100vh - 200px)",
                                p: 4,
                                children: isLoading && transactions.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    h: "200px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                                size: "xl"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                children: t("components.transactions.loadingTransactions") || "Loading transactions..."
                                            })
                                        ]
                                    })
                                }) : transactions.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    h: "200px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: "gray.500",
                                        children: appliedSearchText ? t("components.transactions.noTransactions") || "No transactions found" : t("components.transactions.noTransactions") || "No transactions available"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                    spacing: 2,
                                    align: "stretch",
                                    children: [
                                        transactions.map(function(transaction) {
                                            var ref, ref1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                p: 3,
                                                borderWidth: "1px",
                                                borderRadius: "md",
                                                cursor: "pointer",
                                                _hover: {
                                                    bg: "gray.50",
                                                    borderColor: "blue.300",
                                                    transform: "translateY(-1px)",
                                                    boxShadow: "sm"
                                                },
                                                transition: "all 0.2s",
                                                onClick: function() {
                                                    return handleSelectTransaction(transaction);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    spacing: 3,
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                            size: "sm",
                                                            name: transaction.counterparty
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                            flex: 1,
                                                            minW: 0,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                    spacing: 2,
                                                                    mb: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                            fontWeight: "bold",
                                                                            fontSize: "sm",
                                                                            noOfLines: 1,
                                                                            children: transaction.counterparty
                                                                        }),
                                                                        transaction.linkedToInvoice && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "green",
                                                                            size: "sm",
                                                                            children: t("components.transactions.linked") || "Linked"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                    fontSize: "xs",
                                                                    color: "gray.600",
                                                                    mb: 1,
                                                                    children: new Date(transaction.transactionDate).toLocaleDateString("de-DE")
                                                                }),
                                                                transaction.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                    fontSize: "xs",
                                                                    color: "gray.500",
                                                                    noOfLines: 1,
                                                                    children: transaction.reference
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                    spacing: 2,
                                                                    mt: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                            fontWeight: "bold",
                                                                            fontSize: "sm",
                                                                            color: "green.600",
                                                                            children: [
                                                                                (ref = transaction.amount) === null || ref === void 0 ? void 0 : ref.toFixed(2),
                                                                                " ",
                                                                                transaction.currency || "€"
                                                                            ]
                                                                        }),
                                                                        ((ref1 = transaction.clearingAccount) === null || ref1 === void 0 ? void 0 : ref1.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "xs",
                                                                                    color: "gray.400",
                                                                                    children: "•"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "xs",
                                                                                    color: "gray.500",
                                                                                    children: transaction.clearingAccount.name
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
                                                            size: 20,
                                                            color: "gray.300",
                                                            style: {
                                                                flexShrink: 0,
                                                                marginTop: "4px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            }, transaction._id);
                                        }),
                                        isLoadingMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
                                            py: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                                    size: "sm"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    ml: 2,
                                                    fontSize: "sm",
                                                    color: "gray.500",
                                                    children: t("components.transactions.loadingMore") || "Loading more..."
                                                })
                                            ]
                                        }),
                                        !hasMore && transactions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            py: 4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "sm",
                                                color: "gray.500",
                                                children: t("components.transactions.noMoreTransactions") || "No more transactions"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerFooter */.ze, {
                        borderTopWidth: "1px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "outline",
                            mr: 3,
                            onClick: onClose,
                            children: t("components.transactions.close") || "Close"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TransactionSelectorDrawer = (TransactionSelectorDrawer);

// EXTERNAL MODULE: ./src/components/TradingPartnerSelectorDrawer.tsx
var TradingPartnerSelectorDrawer = __webpack_require__(1104);
;// CONCATENATED MODULE: ./src/components/InvoiceDetailDrawer.tsx





























var containerStyle = {
    width: "100%",
    height: "500px"
};
function toCents(val) {
    if (val == null) return 0;
    if (typeof val === "number") return Number.isFinite(val) ? Math.round(val * 100) : 0;
    if (typeof val !== "string") return 0;
    var raw = val.trim().replace(/\s/g, "");
    var hasComma = raw.includes(",");
    var hasDot = raw.includes(".");
    // If there's a comma, assume DE format: '.' thousands, ',' decimals.
    // If there's only a dot, assume dot is decimal separator (EN/ISO).
    var normalized = hasComma ? raw.replace(/\./g, "").replace(",", ".") : hasDot ? raw : raw;
    var cleaned = normalized.replace(/[^0-9.-]/g, "");
    var n = parseFloat(cleaned);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100);
}
var center = {
    lat: 52.52,
    lng: 13.405
};
function InvoiceDrawerSection(param) {
    var title = param.title, description = param.description, rightElement = param.rightElement, icon = param.icon, hideHeader = param.hideHeader, _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? true : _collapsible, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? true : _defaultOpen, children = param.children;
    var ref = (0,hooks_dist_index_esm/* useDisclosure */.qY)({
        defaultIsOpen: defaultOpen
    }), isOpen = ref.isOpen, onToggle = ref.onToggle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        borderWidth: "1px",
        borderColor: "gray.200",
        borderRadius: "lg",
        bg: "white",
        p: 3,
        children: [
            !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                onClick: collapsible ? onToggle : undefined,
                cursor: collapsible ? "pointer" : "default",
                userSelect: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    gap: 2,
                    align: "flex-start",
                    mb: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            spacing: 2,
                            flex: "1",
                            minW: 0,
                            align: "flex-start",
                            children: [
                                icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    mt: 0.5,
                                    color: "gray.600",
                                    children: icon
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                    flex: "1",
                                    minW: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            as: "h3",
                                            size: "sm",
                                            noOfLines: 1,
                                            children: title
                                        }),
                                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            mt: 0.5,
                                            fontSize: "sm",
                                            color: "gray.500",
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            spacing: 2,
                            onClick: function(e) {
                                return e.stopPropagation();
                            },
                            align: "center",
                            children: [
                                rightElement,
                                collapsible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    color: "gray.600",
                                    mt: 0.5,
                                    children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronUp */.AZg, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {})
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            collapsible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: true,
                children: children
            }) : children
        ]
    });
}
var InvoiceDetailDrawer = function(param) {
    var createInvoiceType = param.createInvoiceType, setBulkUploadCounterFinished = param.setBulkUploadCounterFinished, bulkUploadSettings = param.bulkUploadSettings, setBulkInsertData = param.setBulkInsertData, bulkInsertData = param.bulkInsertData, uploadInProgress = param.uploadInProgress, categoriesData = param.categoriesData, userData = param.userData, setUploadInProgress = param.setUploadInProgress, editInvoiceReadonly = param.editInvoiceReadonly, previewBackwards = param.previewBackwards, previewForwards = param.previewForwards, editInvoiceReadonlyReason = param.editInvoiceReadonlyReason, loadInvoices = param.loadInvoices, invoiceTypesData = param.invoiceTypesData, loadBudgetSpending = param.loadBudgetSpending, loadSingleInvoices = param.loadSingleInvoices, scroller = param.scroller, rekeningData = param.rekeningData, setRekeningData = param.setRekeningData, invoiceIsOpen = param.invoiceIsOpen, session = param.session, setChangedInvoices = param.setChangedInvoices, invoiceOnClose = param.invoiceOnClose, setSelectedInvoice = param.setSelectedInvoice, selectedInvoice = param.selectedInvoice, userNotification = param.userNotification, createInvoice = param.createInvoice, setCreateInvoice = param.setCreateInvoice, setIsDuplicateModalOpen = param.setIsDuplicateModalOpen, setDuplicateCurrentFile = param.setDuplicateCurrentFile, setDuplicateUserDecision = param.setDuplicateUserDecision;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var t = (0,dist_esm/* useTranslation */.$G)("common").t;
    var ref13 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isCloseEditWithoutSave = ref13.isOpen, onCloseEditWithoutSaveOpen = ref13.onOpen, onCloseEditWithoutSaveClose = ref13.onClose;
    var ref14 = (0,react.useState)({
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getUTCDate()
    }), selectedDay = ref14[0], setSelectedDay = ref14[1];
    var ref15 = (0,react.useState)("settings"), drawerMainTab = ref15[0], setDrawerMainTab = ref15[1];
    var ref16;
    var openedInvoiceKey = createInvoice ? "new" : String((ref16 = rekeningData === null || rekeningData === void 0 ? void 0 : (ref = rekeningData[selectedInvoice]) === null || ref === void 0 ? void 0 : ref._id) !== null && ref16 !== void 0 ? ref16 : "idx-".concat(selectedInvoice));
    (0,react.useEffect)(function() {
        if (!invoiceIsOpen) return;
        setDrawerMainTab("settings");
    }, [
        invoiceIsOpen,
        openedInvoiceKey,
        createInvoice
    ]);
    var countryListAllowance = [
        {
            name: "Afghanistan",
            small: 20,
            large: 30,
            code: "AF"
        },
        {
            name: "Albania",
            small: 18,
            large: 27,
            code: "AL"
        },
        {
            name: "Algeria",
            small: 20,
            large: 30,
            code: "DZ"
        },
        {
            name: "Andorra",
            small: 33,
            large: 50,
            code: "AD"
        },
        {
            name: "Angola",
            small: 26,
            large: 39,
            code: "AO"
        },
        {
            name: "Argentina",
            small: 32,
            large: 47,
            code: "AR"
        },
        {
            name: "Armenia",
            small: 24,
            large: 36,
            code: "AM"
        },
        {
            name: "Australia - Canberra",
            small: 31,
            large: 46,
            code: "AU-CBR"
        },
        {
            name: "Australia - Sydney",
            small: 36,
            large: 52,
            code: "AU-SYD"
        },
        {
            name: "Australia",
            small: 31,
            large: 46,
            code: "AU"
        },
        {
            name: "Austria",
            small: 33,
            large: 50,
            code: "AT"
        },
        {
            name: "Belgium",
            small: 34,
            large: 51,
            code: "BE"
        },
        {
            name: "Brazil - Rio de Janeiro",
            small: 28,
            large: 41,
            code: "BR-RIO"
        },
        {
            name: "Brazil - Sao Paulo",
            small: 35,
            large: 52,
            code: "BR-SP"
        },
        {
            name: "Brazil",
            small: 24,
            large: 36,
            code: "BR"
        },
        {
            name: "Canada - Ottawa",
            small: 36,
            large: 54,
            code: "CA-OTT"
        },
        {
            name: "Canada - Toronto",
            small: 42,
            large: 63,
            code: "CA-TOR"
        },
        {
            name: "Canada - Vancouver",
            small: 42,
            large: 63,
            code: "CA-VAN"
        },
        {
            name: "Canada",
            small: 31,
            large: 46,
            code: "CA"
        },
        {
            name: "China - Beijing",
            small: 32,
            large: 48,
            code: "CN-PEK"
        },
        {
            name: "China - Shanghai",
            small: 39,
            large: 58,
            code: "CN-SHA"
        },
        {
            name: "China",
            small: 32,
            large: 48,
            code: "CN"
        },
        {
            name: "Denmark",
            small: 33,
            large: 50,
            code: "DK"
        },
        {
            name: "Egypt",
            small: 20,
            large: 30,
            code: "EG"
        },
        {
            name: "Finland",
            small: 36,
            large: 54,
            code: "FI"
        },
        {
            name: "France - Paris",
            small: 39,
            large: 58,
            code: "FR-PAR"
        },
        {
            name: "France",
            small: 36,
            large: 53,
            code: "FR"
        },
        {
            name: "Germany",
            small: 16,
            large: 24,
            code: "DE"
        },
        {
            name: "Greece",
            small: 35,
            large: 52,
            code: "GR-ATH"
        },
        {
            name: "Greece",
            small: 27,
            large: 40,
            code: "GR"
        },
        {
            name: "Hungary",
            small: 23,
            large: 34,
            code: "HU"
        },
        {
            name: "India - Mumbai",
            small: 33,
            large: 50,
            code: "IN-BOM"
        },
        {
            name: "India - New Delhi",
            small: 33,
            large: 50,
            code: "IN-DEL"
        },
        {
            name: "India",
            small: 21,
            large: 32,
            code: "IN"
        },
        {
            name: "Indonesia",
            small: 24,
            large: 36,
            code: "ID"
        },
        {
            name: "Ireland",
            small: 39,
            large: 58,
            code: "IE"
        },
        {
            name: "Israel",
            small: 44,
            large: 66,
            code: "IL"
        },
        {
            name: "Italy - Milan",
            small: 32,
            large: 48,
            code: "IT-MIL"
        },
        {
            name: "Italy - Rome",
            small: 39,
            large: 58,
            code: "IT-ROM"
        },
        {
            name: "Italy",
            small: 29,
            large: 44,
            code: "IT"
        },
        {
            name: "Japan - Tokyo",
            small: 52,
            large: 78,
            code: "JP-TYO"
        },
        {
            name: "Japan",
            small: 38,
            large: 57,
            code: "JP"
        },
        {
            name: "Kenya",
            small: 32,
            large: 48,
            code: "KE"
        },
        {
            name: "Malaysia",
            small: 24,
            large: 36,
            code: "MY"
        },
        {
            name: "Mexico",
            small: 31,
            large: 46,
            code: "MX"
        },
        {
            name: "Netherlands",
            small: 32,
            large: 47,
            code: "NL"
        },
        {
            name: "New Zealand",
            small: 39,
            large: 58,
            code: "NZ"
        },
        {
            name: "Nigeria",
            small: 31,
            large: 46,
            code: "NG"
        },
        {
            name: "Norway",
            small: 50,
            large: 75,
            code: "NO"
        },
        {
            name: "Poland - Breslau",
            small: 27,
            large: 33,
            code: "PL-WRO"
        },
        {
            name: "Poland - Danzig",
            small: 27,
            large: 33,
            code: "PL-GDN"
        },
        {
            name: "Poland - Krakau",
            small: 27,
            large: 33,
            code: "PL-KRK"
        },
        {
            name: "Poland - Warsaw",
            small: 29,
            large: 34,
            code: "PL-WAW"
        },
        {
            name: "Poland",
            small: 20,
            large: 29,
            code: "PL"
        },
        {
            name: "Portugal - Lisbon",
            small: 32,
            large: 47,
            code: "PT-LIS"
        },
        {
            name: "Portugal",
            small: 29,
            large: 44,
            code: "PT"
        },
        {
            name: "Russia - Moscow",
            small: 40,
            large: 60,
            code: "RU-MOW"
        },
        {
            name: "Russia",
            small: 30,
            large: 45,
            code: "RU"
        },
        {
            name: "Saudi Arabia",
            small: 28,
            large: 42,
            code: "SA"
        },
        {
            name: "South Africa - Johannesburg",
            small: 31,
            large: 46,
            code: "ZA-JNB"
        },
        {
            name: "South Africa - Cape Town",
            small: 31,
            large: 46,
            code: "ZA-CPT"
        },
        {
            name: "South Africa",
            small: 30,
            large: 45,
            code: "ZA"
        },
        {
            name: "Spain - Madrid",
            small: 44,
            large: 66,
            code: "ES-MAD"
        },
        {
            name: "Spain - Barcelona",
            small: 44,
            large: 66,
            code: "ES-BCN"
        },
        {
            name: "Spain",
            small: 34,
            large: 51,
            code: "ES"
        },
        {
            name: "Sweden",
            small: 35,
            large: 52,
            code: "SE"
        },
        {
            name: "Switzerland - Geneva",
            small: 43,
            large: 65,
            code: "CH-GVA"
        },
        {
            name: "Switzerland",
            small: 33,
            large: 50,
            code: "CH"
        },
        {
            name: "Turkey - Istanbul",
            small: 29,
            large: 44,
            code: "TR-IST"
        },
        {
            name: "Turkey",
            small: 24,
            large: 36,
            code: "TR"
        },
        {
            name: "United Arab Emirates",
            small: 32,
            large: 48,
            code: "AE"
        },
        {
            name: "UK - London",
            small: 44,
            large: 66,
            code: "UK-LON"
        },
        {
            name: "UK",
            small: 35,
            large: 52,
            code: "UK"
        },
        {
            name: "USA - New York City",
            small: 44,
            large: 66,
            code: "US-NYC"
        },
        {
            name: "USA - Washington, D.C.",
            small: 44,
            large: 66,
            code: "US-WDC"
        },
        {
            name: "USA - Atlanta",
            small: 52,
            large: 77,
            code: "US-ATL"
        },
        {
            name: "USA - Boston",
            small: 42,
            large: 63,
            code: "US-BOS"
        },
        {
            name: "USA - Chicago",
            small: 44,
            large: 66,
            code: "US-CHI"
        },
        {
            name: "USA - Houston",
            small: 41,
            large: 62,
            code: "US-HOU"
        },
        {
            name: "USA - Los Angeles",
            small: 43,
            large: 64,
            code: "US-LAX"
        },
        {
            name: "USA - Miami",
            small: 44,
            large: 65,
            code: "US-MIA"
        },
        {
            name: "USA - San Francisco",
            small: 40,
            large: 59,
            code: "US-SFO"
        },
        {
            name: "USA",
            small: 40,
            large: 60,
            code: "US"
        }
    ];
    var emptyInvoice = {
        _id: undefined,
        status: "",
        invoiceKind: "invoice",
        category: "",
        tradingPartner: "",
        clearingAccount: "",
        // legacy (was per invoice) - do not rely on it anymore
        bookingAccountSkr3: "",
        // new: booking records per invoice (Buchungssätze) - backend uses `bookingRecords`
        bookingRecords: [],
        uuid: "",
        shop: "",
        invoiceNumber: "",
        total: "0",
        tax: "0",
        totalNet: "0",
        mwst: "0",
        date: new Date().toUTCString(),
        items: [],
        scanAttached: "",
        scanAttachedMD5: "",
        location: {},
        paymentType: "",
        invoiceText: "",
        author: "",
        authorData: [
            {
                name: ""
            }
        ],
        currency: "EUR",
        changelog: [],
        travelExpense: {},
        transactionType: "incoming",
        taxPositions: [
            {
                taxRate: "19",
                value: "0",
                valueNet: "0",
                valueTax: ""
            }
        ],
        invoiceType: undefined,
        invoiceStatus: undefined
    };
    var emptyTravelExpense = {
        locationFrom: "",
        locationTo: "",
        transportation: "train",
        transportationDistance: "0",
        breakfasts: 0,
        lunches: 0,
        dinners: 0,
        startDate: null,
        endDate: null,
        country: "DE",
        allowanceSmall: "14",
        allowanceBig: "28",
        meals: []
    };
    var ref17 = (0,react.useState)(emptyInvoice), newInvoice = ref17[0], setNewInvoice = ref17[1];
    var ref18 = (0,react.useState)(false), isDeleteOpen = ref18[0], setIsDeleteOpen = ref18[1];
    var ref19 = (0,react.useState)(false), editInvoiceModified = ref19[0], setEditInvoiceModified = ref19[1];
    var ref20 = (0,react.useState)(false), saveInvoiceLoading = ref20[0], setSaveInvoiceLoading = ref20[1];
    var ref21 = (0,react.useState)([]), editInvoiceErrorArray = ref21[0], setEditInvoiceErrorArray = ref21[1];
    var ref22 = (0,react.useState)([]), linkedTransactions = ref22[0], setLinkedTransactions = ref22[1];
    var ref23 = (0,react.useState)(false), isTransactionSelectorOpen = ref23[0], setIsTransactionSelectorOpen = ref23[1];
    var ref24 = (0,react.useState)(false), isTradingPartnerSelectorOpen = ref24[0], setIsTradingPartnerSelectorOpen = ref24[1];
    // Trading Partner management state
    var ref25 = (0,react.useState)([]), tradingPartnersData = ref25[0], setTradingPartnersData = ref25[1];
    var ref26 = (0,react.useState)(false), isOpenTradingPartnerManager = ref26[0], setIsOpenTradingPartnerManager = ref26[1];
    var ref27 = (0,react.useState)([]), clearingAccountsData = ref27[0], setClearingAccountsData = ref27[1];
    var ref28 = (0,react.useState)({
        _id: "",
        creditorNumber: "",
        debitorNumber: "",
        name: "",
        address: {
            street: "",
            zipCode: "",
            city: "",
            country: "Germany"
        },
        vatId: "",
        accountType: "TradingPartner",
        openItemAccount: true,
        expenseAccount: "",
        bankDetails: {
            iban: "",
            bic: "",
            bankName: ""
        },
        paymentTerms: 30,
        email: "",
        phone: "",
        costCenter: "",
        department: ""
    }), updateTradingPartnerData = ref28[0], setUpdateTradingPartnerData = ref28[1];
    var ref29 = (0,react.useState)(false), isInsertTradingPartner = ref29[0], setIsInsertTradingPartner = ref29[1];
    var api_url = "https://api.rekening.de";
    var fileInputRef = (0,react.useRef)(null);
    //MAP FOR TRAVEL EXPENSE
    var ref30 = (0,react.useState)(null), startLocation = ref30[0], setStartLocation = ref30[1];
    var ref31 = (0,react.useState)(null), endLocation = ref31[0], setEndLocation = ref31[1];
    var ref32 = (0,react.useState)(null), map = ref32[0], setMap = ref32[1];
    react.useEffect(function() {
        var currentDate = new Date().toUTCString();
        var emptyInvoiceTemp = emptyInvoice;
        if (createInvoiceType == "travel-expense") {
            emptyInvoiceTemp.invoiceKind = "travel-expense";
            emptyInvoiceTemp.travelExpense = emptyTravelExpense;
            console.log("UPADET NEW INVOICE");
        } else {
            delete emptyInvoiceTemp.travelExpense;
        }
        setNewInvoice(emptyInvoiceTemp);
        // Set selectedDay based on invoice date or current date
        var dateToUse = currentDate;
        if (!createInvoice && rekeningData.length > 0 && selectedInvoice < rekeningData.length) {
            dateToUse = rekeningData[selectedInvoice].date;
        }
        setSelectedDay({
            year: new Date(dateToUse).getFullYear(),
            month: new Date(dateToUse).getMonth() + 1,
            day: new Date(dateToUse).getUTCDate()
        });
        // Load trading partners when drawer opens
        if (invoiceIsOpen) {
            loadTradingPartners();
            loadClearingAccounts();
        // loadUnmatchedTransactions(); // No longer needed - TransactionSelectorDrawer handles this
        }
    }, [
        invoiceIsOpen,
        createInvoiceType
    ]);
    // Separate useEffect to update selectedDay when selectedInvoice changes
    react.useEffect(function() {
        if (!createInvoice && rekeningData.length > 0 && selectedInvoice < rekeningData.length) {
            var ref;
            var invoiceDate = new Date(rekeningData[selectedInvoice].date);
            setSelectedDay({
                year: invoiceDate.getFullYear(),
                month: invoiceDate.getMonth() + 1,
                day: invoiceDate.getUTCDate()
            });
            var currentInvoice = rekeningData[selectedInvoice];
            if ((currentInvoice === null || currentInvoice === void 0 ? void 0 : (ref = currentInvoice.linkedTransactions) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                setLinkedTransactions(currentInvoice.linkedTransactions);
            } else {
                setLinkedTransactions([]);
            }
        }
    }, [
        selectedInvoice,
        rekeningData,
        createInvoice
    ]);
    react.useEffect(function() {
        if (bulkInsertData.length != 0) {
            bulkInsert(bulkInsertData);
        }
    }, [
        bulkInsertData
    ]);
    var renderCustomInput = function(param) {
        var ref = param.ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
            readOnly: true,
            ref: ref,
            style: {
                width: "100%"
            },
            placeholder: "I'm a custom input",
            value: selectedDay ? "".concat(selectedDay.day, ".").concat(selectedDay.month, ".").concat(selectedDay.year) : ""
        });
    };
    var closeInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCreateInvoice(true);
                        setEditInvoiceErrorArray([]);
                        setEditInvoiceModified(false);
                        invoiceOnClose();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function closeInvoice() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteCurrentInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        deleteInvoice(rekeningData[selectedInvoice]._id, false);
                        setCreateInvoice(true);
                        setSelectedInvoice(0);
                        invoiceOnClose();
                        setIsDeleteOpen(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        //calculateMonthlyCost()
        //setRekeningData([...rekeningDataTemp])
        }));
        return function deleteCurrentInvoice() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, bulkDelete) {
            var fetchData, rekeningDataTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("".concat(api_url, "/invoices/").concat(id), {
                            method: "DELETE",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 2:
                        fetchData = _ctx.sent;
                        rekeningDataTemp = rekeningData.filter(function(e) {
                            return e._id != id;
                        });
                        if (!bulkDelete) {
                            setRekeningData(rekeningDataTemp);
                        }
                        setEditInvoiceModified(false);
                        userNotification(t("invoiceDetails.deleteSuccessfull"), t("invoiceDetails.invDeletedSuccess"), "success");
                        setChangedInvoices([]);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteInvoice(id, bulkDelete) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkInvoiceDuplicate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(scanAttachedMD5) {
            var fetchData, fetchDataJson;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("".concat(api_url, "/invoices/checkDuplicate?scanAttachedMD5=").concat(scanAttachedMD5), {
                            credentials: "include",
                            method: "GET",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            }
                        });
                    case 2:
                        fetchData = _ctx.sent;
                        _ctx.next = 5;
                        return fetchData.json();
                    case 5:
                        fetchDataJson = _ctx.sent;
                        console.log("RESPONSE: ", fetchDataJson);
                        if (!("statusCode" in fetchDataJson && fetchDataJson["message"] == "Internal server error")) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", []);
                    case 11:
                        return _ctx.abrupt("return", fetchDataJson);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkInvoiceDuplicate(scanAttachedMD5) {
            return _ref.apply(this, arguments);
        };
    }();
    var createNewInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var bulkUpload, body, fetchData, fetchDataJson, errorTypes, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        bulkUpload = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        body = (0,_object_spread/* default */.Z)({}, data);
                        if (!(data == undefined)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        delete body.authorData;
                        // Removed fields (legacy) - never send
                        delete body.debitAccount;
                        delete body.debitAccountSkr3;
                        delete body.creditorAccount;
                        delete body.creditorAccountSkr3;
                        delete body.bookingAccountSkr3;
                        delete body.bookingEntries;
                        _ctx.next = 13;
                        return fetch("".concat(api_url, "/invoices"), {
                            credentials: "include",
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 13:
                        fetchData = _ctx.sent;
                        _ctx.next = 16;
                        return fetchData.json();
                    case 16:
                        fetchDataJson = _ctx.sent;
                        if (!("statusCode" in fetchDataJson && fetchDataJson["message"] == "Internal server error")) {
                            _ctx.next = 21;
                            break;
                        }
                        {
                            userNotification(t("invoiceDetails.errorCreateInv"), "error");
                        }
                        _ctx.next = 37;
                        break;
                    case 21:
                        if (!("statusCode" in fetchDataJson)) {
                            _ctx.next = 25;
                            break;
                        }
                        {
                            console.log(fetchDataJson);
                            userNotification("Creation Error", fetchDataJson["message"][0], "error");
                            errorTypes = [];
                            fetchDataJson["message"].map(function(singleError) {
                                if (singleError == "invoiceType should not be empty") {
                                    errorTypes.push("invoiceType");
                                } else if (singleError == "shop should not be empty") {
                                    errorTypes.push("shop");
                                } else if (singleError == "taxPositions.0.value should not be empty" || singleError == "taxPositions.1.value should not be empty" || singleError == "taxPositions.2.value should not be empty" || singleError == "taxPositions.3.value should not be empty") {
                                    errorTypes.push("amount");
                                } else if (singleError == "taxPositions.0.valueNet should not be empty" || singleError == "taxPositions.1.valueNet should not be empty" || singleError == "taxPositions.2.valueNet should not be empty" || singleError == "taxPositions.3.valueNet should not be empty") {
                                    errorTypes.push("amountNet");
                                } else if (singleError == "taxPositions.0.taxRate should not be empty" || singleError == "taxPositions.1.taxRate should not be empty" || singleError == "taxPositions.2.taxRate should not be empty" || singleError == "taxPositions.3.taxRate should not be empty") {
                                    errorTypes.push("taxRate");
                                } else if (singleError == "category should not be empty") {
                                    errorTypes.push("category");
                                } else if (singleError == "travelExpense.locationFrom should not be empty") {
                                    errorTypes.push("locationFrom");
                                } else if (singleError == "travelExpense.locationTo should not be empty") {
                                    errorTypes.push("locationTo");
                                } else if (singleError == "travelExpense.transportationDistance should not be empty") {
                                    errorTypes.push("transportationDistance");
                                } else if (singleError == "travelExpense.startDate must be a Date instance") {
                                    errorTypes.push("startDate");
                                } else if (singleError == "travelExpense.endDate must be a Date instance") {
                                    errorTypes.push("endDate");
                                }
                            });
                            setEditInvoiceErrorArray(errorTypes);
                        }
                        _ctx.next = 37;
                        break;
                    case 25:
                        userNotification(t("invoiceDetails.createSucces"), t("invoiceDetails.invSuccessCreate"), "success");
                        invoiceOnClose();
                        setEditInvoiceErrorArray([]);
                        _ctx.next = 30;
                        return setNewInvoice(emptyInvoice);
                    case 30:
                        _ctx.next = 32;
                        return setCreateInvoice(false);
                    case 32:
                        _ctx.next = 34;
                        return setRekeningData([]);
                    case 34:
                        _ctx.next = 36;
                        return loadInvoices();
                    case 36:
                        if (!bulkUpload && "statusCode" in fetchDataJson == false) {
                            setChangedInvoices([
                                fetchDataJson._id
                            ]);
                            setTimeout(function() {
                                scroller.scrollTo(fetchDataJson._id, {
                                    duration: 500,
                                    delay: 0,
                                    smooth: true,
                                    offset: -100
                                });
                            }, 200);
                        }
                    case 37:
                        return _ctx.abrupt("return", fetchDataJson);
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createNewInvoice(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var saveInvoiceData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(openInvoiceData) {
            var rekeningDataTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setEditInvoiceModified(true);
                        if (createInvoice == true) {
                            setNewInvoice((0,_object_spread/* default */.Z)({}, openInvoiceData));
                        } else {
                            rekeningDataTemp = rekeningData;
                            rekeningDataTemp[selectedInvoice] = openInvoiceData;
                            setRekeningData((0,_to_consumable_array/* default */.Z)(rekeningDataTemp));
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function saveInvoiceData(openInvoiceData) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var body, fetchData, fetchDataJson, errorTypes;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = (0,_object_spread/* default */.Z)({}, data);
                        // Removed fields (legacy) - never send
                        delete body.debitAccount;
                        delete body.debitAccountSkr3;
                        delete body.creditorAccount;
                        delete body.creditorAccountSkr3;
                        delete body.bookingAccountSkr3;
                        delete body.bookingEntries;
                        delete body.linkedTransactionId;
                        delete body.linkedTransactions;
                        delete body.linkedTransactionCount;
                        delete body.linkedTransactionAmountSum;
                        delete body.remainingAmount;
                        if (!(data == undefined)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        _ctx.next = 16;
                        return fetch("".concat(api_url, "/invoices/").concat(data._id), {
                            method: "PATCH",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 16:
                        fetchData = _ctx.sent;
                        _ctx.next = 19;
                        return fetchData.json();
                    case 19:
                        fetchDataJson = _ctx.sent;
                        if (!("statusCode" in fetchDataJson)) {
                            _ctx.next = 28;
                            break;
                        }
                        userNotification(t("invoiceDetails.updateError"), fetchDataJson["message"][0], "error");
                        errorTypes = [];
                        fetchDataJson["message"].map(function(singleError) {
                            if (singleError == "invoiceType should not be empty") {
                                errorTypes.push("invoiceType");
                            } else if (singleError == "shop should not be empty") {
                                errorTypes.push("shop");
                            } else if (singleError == "taxPositions.0.value should not be empty" || singleError == "taxPositions.1.value should not be empty" || singleError == "taxPositions.2.value should not be empty" || singleError == "taxPositions.3.value should not be empty") {
                                errorTypes.push("amount");
                            } else if (singleError == "taxPositions.0.valueNet should not be empty" || singleError == "taxPositions.1.valueNet should not be empty" || singleError == "taxPositions.2.valueNet should not be empty" || singleError == "taxPositions.3.valueNet should not be empty") {
                                errorTypes.push("amountNet");
                            } else if (singleError == "taxPositions.0.taxRate should not be empty" || singleError == "taxPositions.1.taxRate should not be empty" || singleError == "taxPositions.2.taxRate should not be empty" || singleError == "taxPositions.3.taxRate should not be empty") {
                                errorTypes.push("taxRate");
                            } else if (singleError == "category should not be empty") {
                                errorTypes.push("category");
                            }
                        });
                        setEditInvoiceErrorArray(errorTypes);
                        return _ctx.abrupt("return", false);
                    case 28:
                        userNotification(t("invoiceDetails.updateSuccess"), t("invoiceDetails.invUpdateSuccessfully"), "success");
                        setChangedInvoices([
                            fetchDataJson["_id"]
                        ]);
                        closeInvoice();
                        setEditInvoiceModified(false);
                        setEditInvoiceErrorArray([]);
                        _ctx.next = 35;
                        return loadSingleInvoices(data._id);
                    case 35:
                        return _ctx.abrupt("return", true);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateInvoice(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadTradingPartners = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios_default().get("".concat(api_url, "/trading-partners"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 3:
                        fetchData = _ctx.sent;
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 10;
                            break;
                        }
                        setTradingPartnersData(data.data.tradingPartners || data.data);
                        return _ctx.abrupt("return", data.data.tradingPartners || data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function loadTradingPartners() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadClearingAccounts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios_default().get("".concat(api_url, "/clearing-accounts"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 3:
                        fetchData = _ctx.sent;
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 10;
                            break;
                        }
                        setClearingAccountsData(data.data);
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function loadClearingAccounts() {
            return _ref.apply(this, arguments);
        };
    }();
    var openTradingPartnerManager = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tradingPartner) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setUpdateTradingPartnerData({
                            _id: tradingPartner._id,
                            creditorNumber: tradingPartner.creditorNumber,
                            debitorNumber: tradingPartner.debitorNumber || "",
                            name: tradingPartner.name,
                            address: tradingPartner.address || {
                                street: "",
                                zipCode: "",
                                city: "",
                                country: "Germany"
                            },
                            vatId: tradingPartner.vatId || "",
                            accountType: tradingPartner.accountType,
                            openItemAccount: tradingPartner.openItemAccount,
                            expenseAccount: tradingPartner.expenseAccount || "",
                            bankDetails: tradingPartner.bankDetails || {
                                iban: "",
                                bic: "",
                                bankName: ""
                            },
                            paymentTerms: tradingPartner.paymentTerms || 30,
                            email: tradingPartner.email || "",
                            phone: tradingPartner.phone || "",
                            costCenter: tradingPartner.costCenter || "",
                            department: tradingPartner.department || ""
                        });
                    case 2:
                        _ctx.next = 4;
                        return setIsInsertTradingPartner(false);
                    case 4:
                        setIsOpenTradingPartnerManager(true);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openTradingPartnerManager(tradingPartner) {
            return _ref.apply(this, arguments);
        };
    }();
    var openCreateTradingPartner = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setUpdateTradingPartnerData({
                            _id: "",
                            creditorNumber: "",
                            debitorNumber: "",
                            name: "",
                            address: {
                                street: "",
                                zipCode: "",
                                city: "",
                                country: "Germany"
                            },
                            vatId: "",
                            accountType: "TradingPartner",
                            openItemAccount: true,
                            expenseAccount: "",
                            bankDetails: {
                                iban: "",
                                bic: "",
                                bankName: ""
                            },
                            paymentTerms: 30,
                            email: "",
                            phone: "",
                            costCenter: "",
                            department: ""
                        });
                    case 2:
                        _ctx.next = 4;
                        return setIsInsertTradingPartner(true);
                    case 4:
                        setIsOpenTradingPartnerManager(true);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openCreateTradingPartner() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeTextOpenInvoice = function(key, val) {
        var openInvoiceData = newInvoice;
        if (createInvoice == false) {
            openInvoiceData = rekeningData[selectedInvoice];
        }
        if (key == "total") {
            val = val.replace(",", ".");
        }
        if (key == "mwst") {
            if (val <= 0) {
                val = 0;
            }
            if (val >= 100) {
                val = 100;
            }
        }
        openInvoiceData[key] = val;
        if (key === "linkedTransactionIds") {
            if (!val || Array.isArray(val) && val.length === 0) {
                setLinkedTransactions([]);
                openInvoiceData.link = null;
            }
        }
        if (key == "total" || key == "mwst") {
            var vat;
            var total = Number(openInvoiceData.total);
            vat = total * (1 - parseInt(openInvoiceData.mwst) / 100);
            vat = vat.toFixed(2);
            openInvoiceData.tax = vat;
        }
        if (key == "category") {
            loadBudgetSpending(val);
        }
        if (key == "invoiceType") {
            var invTypeTemp = invoiceTypesData.find(function(e) {
                return e._id == val;
            });
            openInvoiceData["invoiceStatus"] = invTypeTemp.steps[0]._id;
        }
        //SAVE
        saveInvoiceData(openInvoiceData);
    };
    var editInvoiceStatusUpdate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(update) {
            var invoiceTypeStatusIndex, invoiceTypeTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        invoiceTypeTemp = invoiceTypesData.find(function(e) {
                            return e._id == editInvoice.invoiceType;
                        });
                        if (invoiceTypeTemp != undefined) {
                            invoiceTypeStatusIndex = invoiceTypeTemp.steps.findIndex(function(e) {
                                return e._id == editInvoice.invoiceStatus;
                            });
                        }
                        if (!(invoiceTypeTemp == undefined || invoiceTypeStatusIndex == undefined)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (update == "approve" && invoiceTypeStatusIndex < invoiceTypeTemp.steps.length - 1) {
                            onChangeTextOpenInvoice("invoiceStatus", invoiceTypeTemp.steps[invoiceTypeStatusIndex + 1]._id);
                        } else if (update == "reject" && invoiceTypeStatusIndex > 0) {
                            onChangeTextOpenInvoice("invoiceStatus", invoiceTypeTemp.steps[invoiceTypeStatusIndex - 1]._id);
                        }
                        saveInvoice();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editInvoiceStatusUpdate(update) {
            return _ref.apply(this, arguments);
        };
    }();
    var calculateTravelExpenseCost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
            var travelExpenseTemp, fetchData, fetchDataJson, tempInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        travelExpenseTemp = editInvoice.travelExpense;
                        if (!(travelExpenseTemp["title"] == "" || travelExpenseTemp["allowanceBig"] == "" || travelExpenseTemp["allowanceSmall"] == "" || travelExpenseTemp["breakfasts"] == "" || travelExpenseTemp["lunches"] == "" || travelExpenseTemp["dinners"] == "" || travelExpenseTemp["startDate"] == "" || travelExpenseTemp["endDate"] == "" || travelExpenseTemp["description"] == "" || travelExpenseTemp["locationTo"] == "" || travelExpenseTemp["transportationDistance"] == "")) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return fetch("".concat(api_url, "/travelExpense/calculate"), {
                            credentials: "include",
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 5:
                        fetchData = _ctx.sent;
                        _ctx.next = 8;
                        return fetchData.json();
                    case 8:
                        fetchDataJson = _ctx.sent;
                        if ("statusCode" in fetchDataJson) {
                        //userNotification("Creation Error", fetchDataJson["message"][0], "error");
                        } else {
                            travelExpenseTemp["compensation"] = fetchDataJson.cost;
                            tempInvoiceData = editInvoice;
                            tempInvoiceData.travelExpense = travelExpenseTemp;
                            saveInvoiceData(tempInvoiceData);
                        //userNotification("New Travel Expense Created","Your new travel expense has been successfully created","success");
                        //onTravelExpenseClose()
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function calculateTravelExpenseCost(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeTravelExpenseLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(key, value) {
            var location, locationPlaceId, country, locationFrom, locationTo, distance;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log("UPDATE TRAVEL", key, value);
                        location = value.label;
                        locationPlaceId = value.value.place_id;
                        _ctx.next = 5;
                        return onChangeTextTravelExpense(key, location);
                    case 5:
                        _ctx.next = 7;
                        return onChangeTextTravelExpense(key + "PlaceId", locationPlaceId);
                    case 7:
                        if (!(key == "locationTo")) {
                            _ctx.next = 11;
                            break;
                        }
                        country = value.value.terms;
                        _ctx.next = 11;
                        return onChangeTextTravelExpense("country", country);
                    case 11:
                        locationFrom = editInvoice.travelExpense["locationFrom"], locationTo = editInvoice.travelExpense["locationTo"];
                        console.log("UPDATE LOCATION.");
                        if (!(locationFrom != "" && locationTo != "")) {
                            _ctx.next = 19;
                            break;
                        }
                        console.log("Check Distance");
                        _ctx.next = 17;
                        return updateDistance(locationFrom, locationTo);
                    case 17:
                        distance = _ctx.sent;
                        onChangeTextTravelExpense("transportationDistance", distance);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        /*

    MAP Visualization for travel not working

    const { lat, lng } = value.value.geometry.location;
    const selectedLocation = { lat: lat(), lng: lng() };

    if (key === "locationFrom") {
      setStartLocation(selectedLocation);
    } else if (key === "locationTo") {
      setEndLocation(selectedLocation);
    }*/ }));
        return function changeTravelExpenseLocation(key, value) {
            return _ref.apply(this, arguments);
        };
    }();
    /*
  useEffect(() => {
    if (map && startLocation && endLocation) {
      const bounds = {
        north: Math.max(startLocation.lat, endLocation.lat),
        south: Math.min(startLocation.lat, endLocation.lat),
        east: Math.max(startLocation.lng, endLocation.lng),
        west: Math.min(startLocation.lng, endLocation.lng),
      };
      map.fitBounds(bounds);
    }
  }, [startLocation, endLocation, map]);*/ var onChangeTextTravelExpense = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(key, value) {
            var invoiceDataTemp, country, region, city, countryAllowance;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        invoiceDataTemp = editInvoice;
                        if (key == "country") {
                            country = value.pop().value;
                            region = value.length != 0 && value.pop().value;
                            city = value.length != 0 && value.pop().value;
                            countryAllowance = undefined;
                            //Check for country + region
                            countryAllowance = countryListAllowance.find(function(e) {
                                return e.name == country + " - " + region;
                            });
                            //Check for country + city
                            if (countryAllowance == undefined) {
                                countryAllowance = countryListAllowance.find(function(e) {
                                    return e.name == country + " - " + city;
                                });
                            }
                            //Check just for country
                            if (countryAllowance == undefined) {
                                countryAllowance = countryListAllowance.find(function(e) {
                                    return e.name == country;
                                });
                            }
                            if (countryAllowance == undefined) {
                                invoiceDataTemp.travelExpense["allowanceSmall"] = "";
                                invoiceDataTemp.travelExpense["allowanceBig"] = "";
                                invoiceDataTemp.travelExpense[key] = value;
                            } else {
                                invoiceDataTemp.travelExpense["allowanceSmall"] = countryAllowance.small.toString();
                                invoiceDataTemp.travelExpense["allowanceBig"] = countryAllowance.large.toString();
                                invoiceDataTemp.travelExpense[key] = countryAllowance.code;
                            }
                        } else {
                            invoiceDataTemp.travelExpense[key] = value;
                        }
                        try {
                            updateMeals(0, "breakfast", editInvoice.travelExpense["meals"][0]["breakfast"]);
                        } catch (error) {
                            console.log(error);
                        }
                        saveInvoiceData(invoiceDataTemp);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        //calculateTravelExpenseCost(invoiceDataTemp.travelExpense)
        }));
        return function onChangeTextTravelExpense(key, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDistance = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(origin, destination) {
            var apiKey, url, response, result, distanceInMeters;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        apiKey = "AIzaSyAAmYYPOLxV94MyxnuATvQj93Y0Lik0FwE";
                        url = "https://maps.googleapis.com/maps/api/distancematrix/json?origins=".concat(origin, "&destinations=").concat(destination, "&key=").concat(apiKey);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return axios_default().get(url);
                    case 5:
                        response = _ctx.sent;
                        result = response.data;
                        distanceInMeters = (result.rows[0].elements[0].distance.value / 1000).toFixed(0);
                        return _ctx.abrupt("return", distanceInMeters);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return", 0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function updateDistance(origin, destination) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateMeals = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(index, mealType, value) {
            var invoiceDataTemp, totalAllowance, allowanceBig, allowanceSmall;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        invoiceDataTemp = editInvoice;
                        invoiceDataTemp.travelExpense["meals"][index][mealType] = value;
                        totalAllowance = 0, allowanceBig = invoiceDataTemp.travelExpense["allowanceBig"], allowanceSmall = invoiceDataTemp.travelExpense["allowanceSmall"];
                        invoiceDataTemp.travelExpense["meals"].map(function(singleMeal, dayIndex) {
                            var deductionBreakfast = parseFloat(allowanceBig) * 0.2;
                            var deductionLunch = parseFloat(allowanceBig) * 0.4;
                            var deductionDinner = parseFloat(allowanceBig) * 0.4;
                            var allowance = parseFloat(allowanceBig);
                            if (dayIndex == 0 || dayIndex == invoiceDataTemp.travelExpense["meals"].length - 1) {
                                allowance = parseFloat(allowanceSmall);
                            }
                            if (singleMeal.breakfast == false) {
                                deductionBreakfast = 0;
                            }
                            if (singleMeal.lunch == false) {
                                deductionLunch = 0;
                            }
                            if (singleMeal.dinner == false) {
                                deductionDinner = 0;
                            }
                            totalAllowance += Math.max(allowance - deductionBreakfast - deductionLunch - deductionDinner, 0);
                        });
                        console.log("TOTAL:", totalAllowance.toFixed(2));
                        console.log("TOTAL:", invoiceDataTemp);
                        saveInvoiceData(invoiceDataTemp);
                        _ctx.next = 9;
                        return onChangeTotalOpenInvoice("taxRate", "0", 0);
                    case 9:
                        _ctx.next = 11;
                        return onChangeTotalOpenInvoice("value", totalAllowance, 0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateMeals(index, mealType, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeTotalOpenInvoice = function(key, val, ind) {
        var openInvoiceData = newInvoice;
        if (createInvoice == false) {
            openInvoiceData = rekeningData[selectedInvoice];
        }
        var tax = parseFloat("0.0"), total = parseFloat("0.0"), totalNet = parseFloat("0.0");
        console.log("VAL: ", val);
        openInvoiceData.taxPositions[ind][key] = val;
        var indValue = openInvoiceData.taxPositions[ind]["value"], indValueNet = openInvoiceData.taxPositions[ind]["valueNet"], indTaxRate = openInvoiceData.taxPositions[ind]["taxRate"];
        openInvoiceData.taxPositions.map(function(singlePosition, i) {
            if (key == "value") {
                if (i == ind && indValue != "" && indTaxRate != "") {
                    openInvoiceData.taxPositions[ind]["valueNet"] = (parseFloat(indValue) / (1 + parseInt(indTaxRate) / 100)).toFixed(2).toString();
                /*openInvoiceData.taxPositions[ind]["value"] = indValue;
          openInvoiceData.taxPositions[ind]["taxRate"] = (1 - (parseFloat(indValue) / parseFloat(indValueNet)) * 100).toFixed(0).toString();
          */ }
            }
            if (key == "valueNet") {
                if (i == ind) {
                    indValueNet = val;
                }
            }
            if (key == "valueTax") {
                if (i == ind) {
                    // valueTax can be empty or a number, just store it
                    openInvoiceData.taxPositions[ind]["valueTax"] = val != null ? val.toString() : "";
                }
            }
            if (key == "taxRate") {
                if (val <= 0) {
                    val = 0;
                }
                if (val >= 100) {
                    val = 100;
                }
                if (i == ind) {
                    indTaxRate = val;
                }
            }
            total += Number(singlePosition.value);
            /*totalNet += parseFloat(singlePosition.value) / (1 + parseInt(singlePosition.taxRate) / 100);
      tax += parseFloat(singlePosition.value) - (parseFloat(singlePosition.value) / (1 + parseInt(singlePosition.taxRate) / 100));
      */ totalNet += parseFloat(singlePosition.valueNet);
            tax += parseFloat(singlePosition.value) - parseFloat(singlePosition.valueNet);
        });
        openInvoiceData.total = total.toFixed(2).toString();
        openInvoiceData.tax = tax.toFixed(2).toString();
        openInvoiceData.totalNet = totalNet.toFixed(2).toString();
        //SAVE
        saveInvoiceData(openInvoiceData);
    };
    var editInvoiceAddTaxRate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var openInvoiceData, tempDataPosition;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        if (openInvoiceData.taxPositions == undefined) {
                            openInvoiceData.taxPositions = [];
                            tempDataPosition = {
                                taxRate: openInvoiceData.mwst,
                                value: openInvoiceData.total,
                                valueNet: openInvoiceData.totalNet,
                                valueTax: ""
                            };
                            openInvoiceData.taxPositions.push(tempDataPosition);
                        }
                        openInvoiceData.taxPositions.push({
                            taxRate: "0",
                            value: "",
                            valueNet: "",
                            valueTax: ""
                        });
                        saveInvoiceData(openInvoiceData);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editInvoiceAddTaxRate() {
            return _ref.apply(this, arguments);
        };
    }();
    var editInvoiceRemoveTaxRate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(index) {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        openInvoiceData.taxPositions.splice(index, 1);
                        saveInvoiceData(openInvoiceData);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editInvoiceRemoveTaxRate(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var editInvoiceAddBookingEntry = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var openInvoiceData, defaults;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        if (!Array.isArray(openInvoiceData.bookingRecords)) {
                            openInvoiceData.bookingRecords = [];
                        }
                        defaults = {
                            amount: "",
                            baseAmount: "",
                            account: "",
                            buSchluessel: "",
                            documentField1: openInvoiceData.invoiceNumber || "",
                            documentField2: "",
                            bookingText: openInvoiceData.shop || "",
                            euTaxRate: "",
                            taxRate: openInvoiceData.mwst || "",
                            performanceDate: "",
                            dueDate: ""
                        };
                        openInvoiceData.bookingRecords.push(defaults);
                        saveInvoiceData(openInvoiceData);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editInvoiceAddBookingEntry() {
            return _ref.apply(this, arguments);
        };
    }();
    var editInvoiceRemoveBookingEntry = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(index) {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        if (!Array.isArray(openInvoiceData.bookingRecords)) {
                            openInvoiceData.bookingRecords = [];
                        }
                        openInvoiceData.bookingRecords.splice(index, 1);
                        saveInvoiceData(openInvoiceData);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editInvoiceRemoveBookingEntry(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeBookingEntry = function(index, key, val) {
        var openInvoiceData = newInvoice;
        if (createInvoice == false) {
            openInvoiceData = rekeningData[selectedInvoice];
        }
        if (!Array.isArray(openInvoiceData.bookingRecords)) {
            openInvoiceData.bookingRecords = [];
        }
        if (!openInvoiceData.bookingRecords[index]) {
            openInvoiceData.bookingRecords[index] = {};
        }
        openInvoiceData.bookingRecords[index][key] = val;
        saveInvoiceData(openInvoiceData);
    };
    var removeImageFromInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        openInvoiceData.scanAttached = "";
                        openInvoiceData.scanAttachedMD5 = "";
                        saveInvoiceData(openInvoiceData);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeImageFromInvoice() {
            return _ref.apply(this, arguments);
        };
    }();
    var changeInvoiceDate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(newDate) {
            var invoiceDate, openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSelectedDay(newDate);
                        invoiceDate = new Date(newDate.year, newDate.month - 1, newDate.day);
                        invoiceDate.setHours(12);
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        openInvoiceData.date = invoiceDate.toUTCString();
                        saveInvoiceData(openInvoiceData);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeInvoiceDate(newDate) {
            return _ref.apply(this, arguments);
        };
    }();
    var refund = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(status) {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        openInvoiceData.status = status;
                        saveInvoiceData(openInvoiceData);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refund(status) {
            return _ref.apply(this, arguments);
        };
    }();
    var saveInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSaveInvoiceLoading(true);
                        console.log("NEW INVOICE Data:", newInvoice);
                        openInvoiceData = newInvoice;
                        if (!(createInvoice == false && !editInvoiceReadonly)) {
                            _ctx.next = 9;
                            break;
                        }
                        openInvoiceData = rekeningData[selectedInvoice];
                        _ctx.next = 7;
                        return updateInvoice(openInvoiceData);
                    case 7:
                        _ctx.next = 15;
                        break;
                    case 9:
                        if (!(createInvoice == true)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 12;
                        return createNewInvoice(openInvoiceData);
                    case 12:
                        _ctx.next = 15;
                        break;
                    case 14:
                        {
                            userNotification("Saving not possible", editInvoiceReadonlyReason, "error");
                        }
                    case 15:
                        //setRekeningDataOriginal([...rekeningData])
                        setSaveInvoiceLoading(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function saveInvoice() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeProduct = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(index) {
            var openInvoiceData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        openInvoiceData = newInvoice;
                        if (createInvoice == false) {
                            openInvoiceData = rekeningData[selectedInvoice];
                        }
                        openInvoiceData.items.splice(index, 1);
                        saveInvoiceData(openInvoiceData);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeProduct(index) {
            return _ref.apply(this, arguments);
        };
    }();
    //Bulk Upload:
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var returnOnlyData, aiDisabled, formData, fetchData, response, invoiceData, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        returnOnlyData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, aiDisabled = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false;
                        console.log("AI DISABLED");
                        if (returnOnlyData == false) {
                            setUploadInProgress(true);
                        }
                        formData = new FormData();
                        formData.append("file", data);
                        _ctx.next = 7;
                        return fetch((0,url/* withInvoiceQueueConsumerTarget */.r)("".concat(api_url, "/files/upload/?disableAi=").concat(aiDisabled, "&useOpenAI=true")), {
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken)
                            },
                            credentials: "include",
                            method: "Post",
                            body: formData
                        });
                    case 7:
                        fetchData = _ctx.sent;
                        _ctx.next = 10;
                        return fetchData.json();
                    case 10:
                        response = _ctx.sent;
                        console.log(response);
                        if (!(response.statusCode == 400 || response.statusCode == 500)) {
                            _ctx.next = 16;
                            break;
                        }
                        userNotification(t("invoiceDetails.processingError"), t("invoiceDetails.processingErrorDetails"), "error");
                        setUploadInProgress(false);
                        return _ctx.abrupt("return");
                    case 16:
                        if (!(returnOnlyData == true)) {
                            _ctx.next = 18;
                            break;
                        }
                        return _ctx.abrupt("return", response);
                    case 18:
                        if ("data" in response) {
                            invoiceData = rekeningData[selectedInvoice];
                            invoiceData.scanAttached = response.imageUrl;
                            saveInvoiceData(invoiceData);
                        } else {
                            onChangeTextOpenInvoice("scanAttached", response.imageUrl);
                            onChangeTextOpenInvoice("scanAttachedMD5", response.scanAttachedMD5);
                        }
                        setUploadInProgress(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function uploadFile(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var bulkInsert = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(acceptedFiles) {
            var counter, newInvoiceIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, uploadData, checkDuplicate, decision, creatInvoice;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        counter = 0;
                        newInvoiceIds = [];
                        setBulkUploadCounterFinished(0);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 4;
                        _iterator = acceptedFiles[Symbol.iterator]();
                    case 6:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _ctx.next = 45;
                            break;
                        }
                        file = _step.value;
                        console.log("FILE:", file);
                        _ctx.next = 11;
                        return uploadFile(file, true);
                    case 11:
                        uploadData = _ctx.sent;
                        console.log("UPLOAD DATA:", uploadData);
                        if (!(uploadData != undefined && "data" in uploadData)) {
                            _ctx.next = 41;
                            break;
                        }
                        console.log("Upload Data:", uploadData);
                        _ctx.next = 17;
                        return checkInvoiceDuplicate(uploadData.scanAttachedMD5);
                    case 17:
                        checkDuplicate = _ctx.sent;
                        console.log("DUPLICATE CHEHCK", checkDuplicate);
                        if (!(checkDuplicate != undefined && checkDuplicate.length != 0)) {
                            _ctx.next = 30;
                            break;
                        }
                        console.log("DUPLICATE", checkDuplicate);
                        // Show the modal and wait for the user's decision
                        setDuplicateCurrentFile(file);
                        setIsDuplicateModalOpen(true);
                        _ctx.next = 25;
                        return new Promise(function(resolve) {
                            var handleDecision = function(decision) {
                                setIsDuplicateModalOpen(false);
                                resolve(decision);
                            };
                            setDuplicateUserDecision(function() {
                                return handleDecision;
                            });
                        });
                    case 25:
                        decision = _ctx.sent;
                        if (!(decision === "skip")) {
                            _ctx.next = 30;
                            break;
                        }
                        counter++;
                        setBulkUploadCounterFinished(counter);
                        return _ctx.abrupt("continue", 42);
                    case 30:
                        // Only assign category if it's selected, otherwise let AI analysis determine it
                        if (bulkUploadSettings.category) {
                            uploadData.data.category = bulkUploadSettings.category;
                        }
                        uploadData.data.invoiceType = bulkUploadSettings.invoiceType;
                        uploadData.data.invoiceStatus = invoiceTypesData.find(function(e) {
                            return e._id == bulkUploadSettings.invoiceType;
                        }).steps[0]._id;
                        _ctx.next = 35;
                        return createNewInvoice(uploadData.data, true);
                    case 35:
                        creatInvoice = _ctx.sent;
                        newInvoiceIds.push(creatInvoice["_id"]);
                        counter++;
                        setBulkUploadCounterFinished(counter);
                        _ctx.next = 42;
                        break;
                    case 41:
                        {
                            counter++;
                            setBulkUploadCounterFinished(counter);
                            userNotification(t("invoiceDetails.uploadError"), t("invoiceDetails.uploadErrorDetails"), "error");
                        }
                    case 42:
                        _iteratorNormalCompletion = true;
                        _ctx.next = 6;
                        break;
                    case 45:
                        _ctx.next = 51;
                        break;
                    case 47:
                        _ctx.prev = 47;
                        _ctx.t0 = _ctx["catch"](4);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 51:
                        _ctx.prev = 51;
                        _ctx.prev = 52;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 54:
                        _ctx.prev = 54;
                        if (!_didIteratorError) {
                            _ctx.next = 57;
                            break;
                        }
                        throw _iteratorError;
                    case 57:
                        return _ctx.finish(54);
                    case 58:
                        return _ctx.finish(51);
                    case 59:
                        setChangedInvoices(newInvoiceIds);
                        setBulkInsertData([]);
                    case 61:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    47,
                    51,
                    59
                ],
                [
                    52,
                    ,
                    54,
                    58
                ]
            ]);
        }));
        return function bulkInsert(acceptedFiles) {
            return _ref.apply(this, arguments);
        };
    }();
    /*
  const bulkInsert = async (acceptedFiles) =>{
    let counter = 0;
    let newInvoiceIds = []
    setBulkUploadCounterFinished(0);
    for (const file of acceptedFiles) {
      console.log("FILE:", file);
        let uploadData = await uploadFile(file, true);
        if("data" in uploadData){
          console.log("Upload DAta:", uploadData);
          let checkDuplicate = await checkInvoiceDuplicate(uploadData.scanAttachedMD5);
          
          if(checkDuplicate != undefined && checkDuplicate.length != 0){
            //show 2 buttons in Frontend and wait fpr decision
          }
          
          uploadData.data.category = bulkUploadSettings.category;
          uploadData.data.invoiceType = bulkUploadSettings.invoiceType;
          uploadData.data.invoiceStatus = invoiceTypesData.find(e => e._id == bulkUploadSettings.invoiceType).steps[0]._id;
          
          let creatInvoice = await createNewInvoice(uploadData.data, true);

          newInvoiceIds.push(creatInvoice["_id"])
          counter = counter + 1;
          setBulkUploadCounterFinished(counter);
        }else{
          counter = counter + 1;
          setBulkUploadCounterFinished(counter);
          userNotification("Upload Error","One document could not be imported", "error")
        }
    }
    setChangedInvoices(newInvoiceIds);
    setBulkInsertData([])
  }*/ var printTravelExpense = function(id) {
        window.open("/travelExpensePrint/" + id, "_blank").focus();
    };
    var invoiceTypeNextStepAllowed = false;
    var invoiceTypeBackStepAllowed = false;
    //Data for drawer
    var editInvoice = newInvoice;
    if (createInvoice == true || rekeningData.length == 0) {
        editInvoice = newInvoice;
    } else {
        editInvoice = rekeningData[selectedInvoice];
    }
    // Guard against transient undefined (e.g. index out of bounds while list refreshes)
    if (!editInvoice) {
        editInvoice = newInvoice || emptyInvoice;
    }
    var bookingValidationActive = (editInvoice === null || editInvoice === void 0 ? void 0 : editInvoice.invoiceKind) !== "travel-expense";
    var bookingEntries = Array.isArray((ref1 = editInvoice) === null || ref1 === void 0 ? void 0 : ref1.bookingRecords) ? editInvoice.bookingRecords : Array.isArray((ref2 = editInvoice) === null || ref2 === void 0 ? void 0 : ref2.bookingEntries) ? editInvoice.bookingEntries : [];
    var invoiceTotalCents = toCents((ref3 = editInvoice) === null || ref3 === void 0 ? void 0 : ref3.total);
    var bookingEntriesSumCents = bookingEntries.reduce(function(sum, e) {
        return sum + toCents(e === null || e === void 0 ? void 0 : e.amount);
    }, 0);
    var bookingEntriesSumValid = !bookingValidationActive ? true : bookingEntries.length > 0 && bookingEntriesSumCents === invoiceTotalCents;
    // Prefer signed URL from the invoice list for any preview/open of attachments.
    // Fallback to the legacy `scanAttached` field when the signed URL isn't present.
    var attachmentUrl = ((ref4 = editInvoice) === null || ref4 === void 0 ? void 0 : ref4.scanAttachedSignedUrl) || ((ref5 = editInvoice) === null || ref5 === void 0 ? void 0 : ref5.scanAttached) || "";
    // When the PDF preview is open, prevent background (body) scrolling.
    // Otherwise wheel events over the embedded <object> can scroll the underlying page.
    var isPdfPreviewOpen = invoiceIsOpen === true && typeof attachmentUrl === "string" && attachmentUrl !== "" && function() {
        try {
            return new URL(attachmentUrl).pathname.toLowerCase().endsWith(".pdf");
        } catch (e) {
            return attachmentUrl.split("?")[0].toLowerCase().endsWith(".pdf");
        }
    }();
    (0,react.useEffect)(function() {
        if (!isPdfPreviewOpen) return;
        var prevBodyOverflow = document.body.style.overflow;
        var prevHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = prevBodyOverflow;
            document.documentElement.style.overflow = prevHtmlOverflow;
        };
    }, [
        isPdfPreviewOpen
    ]);
    try {
        var invoiceTypeTemp = invoiceTypesData.find(function(e) {
            return e._id == editInvoice.invoiceType;
        });
        if (invoiceTypeTemp != undefined) {
            var ref33;
            var invoiceTypeStatus = invoiceTypeTemp.steps.find(function(e) {
                return e._id == editInvoice.invoiceStatus;
            });
            var invoiceTypeStatusIndex = invoiceTypeTemp.steps.findIndex(function(e) {
                return e._id == editInvoice.invoiceStatus;
            });
            // Check if approval exists and user_data.groups exists before accessing
            var userGroups = session === null || session === void 0 ? void 0 : (ref33 = session.user_data) === null || ref33 === void 0 ? void 0 : ref33.groups;
            var approvalArray = (invoiceTypeStatus === null || invoiceTypeStatus === void 0 ? void 0 : invoiceTypeStatus.approval) || [];
            console.log("USER Data:", session === null || session === void 0 ? void 0 : session.user_data);
            console.log("APPROVAL ARRAY:", approvalArray);
            // If no approval groups are defined, allow access
            // If approval groups exist, check if user is in one of them
            var invoiceTypeStepApproval = false;
            if (approvalArray.length === 0) {
                // No approval required
                invoiceTypeStepApproval = true;
            } else if (userGroups && Array.isArray(userGroups)) {
                // Check if user is in any of the approval groups
                invoiceTypeStepApproval = approvalArray.some(function(item) {
                    return userGroups.includes(item);
                });
            }
            // If userGroups is undefined/null and approval groups exist, deny access
            console.log("INVOICE TYPE STEP APPROVAL:", invoiceTypeStepApproval);
            invoiceTypeNextStepAllowed = invoiceTypeStepApproval && invoiceTypeStatusIndex < invoiceTypeTemp.steps.length - 1;
            invoiceTypeBackStepAllowed = invoiceTypeStepApproval && invoiceTypeStatusIndex > 0;
        } else {
            invoiceTypeNextStepAllowed = true;
        }
    } catch (error) {
        console.log(error);
    }
    var currencyInputConfig = {
        "locale": "de",
        "currency": ((ref6 = editInvoice) === null || ref6 === void 0 ? void 0 : ref6.currency) || "EUR"
    };
    var deleteInvoiceHeaderLabel = (editInvoice === null || editInvoice === void 0 ? void 0 : editInvoice.invoiceKind) == "travel-expense" ? t("invoiceDetails.deleteTravelExpense") : t("invoiceDetails.deleteInvoice");
    var modalContent = invoiceIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
                isOpen: invoiceIsOpen,
                placement: "right",
                size: "lg",
                // Don't lock page scroll; otherwise embedded PDF preview (outside DrawerContent) may not receive wheel events reliably.
                blockScrollOnMount: false,
                onClose: function() {
                    console.log("editInvoiceModified", editInvoiceModified);
                    console.log("invoiceTypeNextStepAllowed", invoiceTypeNextStepAllowed);
                    console.log("newInvoice", newInvoice);
                    if (editInvoiceModified == true && invoiceTypeNextStepAllowed && !createInvoice) {
                        onCloseEditWithoutSaveOpen();
                    } else {
                        closeInvoice();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {
                        zIndex: 1200
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
                        zIndex: 1250,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
                                zIndex: 3,
                                top: "12px",
                                right: "12px",
                                size: "sm",
                                variant: "outline",
                                colorScheme: "rekening",
                                bg: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                bg: "white",
                                borderBottom: "1px solid",
                                borderColor: "gray.200",
                                pr: "64px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    gap: 3,
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                            spacing: "6px",
                                            children: [
                                                "authorData" in editInvoice && editInvoice.authorData.length != 0 && ("profilePicture" in editInvoice.authorData[0] == false || editInvoice.authorData[0]["profilePicture"] == "") && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                    marginRight: 2,
                                                    borderRadius: 10,
                                                    height: 45,
                                                    width: 45,
                                                    className: "rekening-invoice-avatar",
                                                    name: editInvoice["authorData"][0]["username"]
                                                }),
                                                "authorData" in editInvoice && editInvoice.authorData.length != 0 && "profilePicture" in editInvoice.authorData[0] && editInvoice.authorData[0]["profilePicture"] != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                    marginRight: 2,
                                                    borderRadius: 10,
                                                    height: 45,
                                                    width: 45,
                                                    className: "rekening-invoice-avatar",
                                                    src: String(((ref7 = editInvoice["authorData"]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8["profilePictureSignedUrl"]) || ((ref9 = editInvoice["authorData"]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10["profilePicture"]) || "")
                                                }),
                                                "authorData" in editInvoice && editInvoice.authorData.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                    marginRight: 2,
                                                    borderRadius: 10,
                                                    height: 45,
                                                    width: 45,
                                                    className: "rekening-invoice-avatar",
                                                    name: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "rekening-invoice-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBriefcase */.BRz, {
                                                        fontSize: "35px"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            flex: "1",
                                            minW: 0,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                            as: "h4",
                                                            size: "md",
                                                            noOfLines: 1,
                                                            children: editInvoice.shop
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                            colorScheme: "gray",
                                                            variant: "subtle",
                                                            children: editInvoice.invoiceKind == "travel-expense" ? t("invoiceDetails.travelExpense") : t("invoiceDetails.invoice")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    color: "gray.500",
                                                    fontWeight: "semibold",
                                                    fontSize: "sm",
                                                    children: new Date(editInvoice.date).toLocaleDateString()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            textAlign: "right",
                                            minW: 0,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                    as: "h4",
                                                    size: "md",
                                                    children: [
                                                        editInvoice.total,
                                                        " ",
                                                        editInvoice.currency
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                    color: "gray.500",
                                                    fontWeight: "semibold",
                                                    fontSize: "sm",
                                                    children: [
                                                        editInvoice.totalNet,
                                                        " (",
                                                        editInvoice.tax,
                                                        ") ",
                                                        editInvoice.currency
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal/* default */.Z, {
                                isOpen: isDeleteOpen,
                                onCancel: function() {
                                    return setIsDeleteOpen(false);
                                },
                                onConfirm: deleteCurrentInvoice,
                                headerMessage: editInvoice.invoiceKind == "travel-expense" ? t("invoiceDetails.deleteTravelExpense") : t("invoiceDetails.deleteInvoice"),
                                bodyMessage: t("invoiceDetails.sureToDelete"),
                                details: {
                                    title: t("deleteModalElement.detailsTitle"),
                                    items: [
                                        {
                                            label: t("invoiceDetails.name"),
                                            value: editInvoice.shop || "-"
                                        },
                                        {
                                            label: t("invoiceDetails.date"),
                                            value: new Date(editInvoice.date).toLocaleDateString("de-DE")
                                        },
                                        {
                                            label: t("invoiceDetails.totalAmount"),
                                            value: "".concat(editInvoice.total, " ").concat(editInvoice.currency)
                                        }, 
                                    ]
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerBody */.Ng, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                    spacing: 5,
                                    align: "stretch",
                                    mt: 4,
                                    children: [
                                        invoiceTypeNextStepAllowed == false && createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dist_index_esm/* Alert */.bZ, {
                                            status: "warning",
                                            borderRadius: "md",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dist_index_esm/* AlertIcon */.zM, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            fontWeight: "bold",
                                                            children: t("invoiceDetails.readonlyTitle")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            fontSize: "sm",
                                                            color: "gray.700",
                                                            children: t("invoiceDetails.readonlyDescription")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            bg: "gray.100",
                                            p: 1,
                                            borderRadius: "lg",
                                            display: "inline-flex",
                                            mb: 4,
                                            flexWrap: "wrap",
                                            gap: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    size: "sm",
                                                    h: "32px",
                                                    px: 3,
                                                    borderRadius: "md",
                                                    fontWeight: drawerMainTab === "settings" ? "600" : "500",
                                                    bg: drawerMainTab === "settings" ? "white" : "transparent",
                                                    boxShadow: drawerMainTab === "settings" ? "sm" : "none",
                                                    color: drawerMainTab === "settings" ? "gray.800" : "gray.600",
                                                    _hover: drawerMainTab !== "settings" ? {
                                                        bg: "white",
                                                        boxShadow: "sm",
                                                        color: "gray.800"
                                                    } : {},
                                                    onClick: function() {
                                                        return setDrawerMainTab("settings");
                                                    },
                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        as: io5_index_esm/* IoSettingsOutline */.Fuo,
                                                        boxSize: 3.5,
                                                        color: drawerMainTab === "settings" ? "rekening.600" : "gray.500"
                                                    }),
                                                    transition: "all 0.15s ease",
                                                    children: t("invoiceDetails.drawerTabSettings")
                                                }),
                                                createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                            size: "sm",
                                                            h: "32px",
                                                            px: 3,
                                                            borderRadius: "md",
                                                            fontWeight: drawerMainTab === "comments" ? "600" : "500",
                                                            bg: drawerMainTab === "comments" ? "white" : "transparent",
                                                            boxShadow: drawerMainTab === "comments" ? "sm" : "none",
                                                            color: drawerMainTab === "comments" ? "gray.800" : "gray.600",
                                                            _hover: drawerMainTab !== "comments" ? {
                                                                bg: "white",
                                                                boxShadow: "sm",
                                                                color: "gray.800"
                                                            } : {},
                                                            onClick: function() {
                                                                return setDrawerMainTab("comments");
                                                            },
                                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                                as: io5_index_esm/* IoChatbubbleEllipsesOutline */.rIi,
                                                                boxSize: 3.5,
                                                                color: drawerMainTab === "comments" ? "rekening.600" : "gray.500"
                                                            }),
                                                            transition: "all 0.15s ease",
                                                            children: t("invoiceDetails.drawerTabComments")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                            size: "sm",
                                                            h: "32px",
                                                            px: 3,
                                                            borderRadius: "md",
                                                            fontWeight: drawerMainTab === "activity" ? "600" : "500",
                                                            bg: drawerMainTab === "activity" ? "white" : "transparent",
                                                            boxShadow: drawerMainTab === "activity" ? "sm" : "none",
                                                            color: drawerMainTab === "activity" ? "gray.800" : "gray.600",
                                                            _hover: drawerMainTab !== "activity" ? {
                                                                bg: "white",
                                                                boxShadow: "sm",
                                                                color: "gray.800"
                                                            } : {},
                                                            onClick: function() {
                                                                return setDrawerMainTab("activity");
                                                            },
                                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                                as: io5_index_esm/* IoTimer */.o6T,
                                                                boxSize: 3.5,
                                                                color: drawerMainTab === "activity" ? "rekening.600" : "gray.500"
                                                            }),
                                                            transition: "all 0.15s ease",
                                                            children: t("invoiceDetails.drawerTabActivityFeed")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        drawerMainTab === "settings" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                            spacing: 5,
                                            align: "stretch",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionBasic"),
                                                    description: t("invoiceDetails.sectionBasicDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoInformationCircle */.gOU, {}),
                                                    collapsible: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                        spacing: 3,
                                                        align: "stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "smaller",
                                                                        mb: "1",
                                                                        fontWeight: "bold",
                                                                        children: t("invoiceDetails.name")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                        autoFocus: createInvoice,
                                                                        placeholder: t("invoiceDetails.typeHere"),
                                                                        value: editInvoice.shop,
                                                                        disabled: !invoiceTypeNextStepAllowed,
                                                                        onChange: function(evt) {
                                                                            return onChangeTextOpenInvoice("shop", evt.target.value);
                                                                        },
                                                                        isInvalid: editInvoiceErrorArray.includes("shop")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "smaller",
                                                                        mb: "1",
                                                                        fontWeight: "bold",
                                                                        children: t("invoiceDetails.invoiceNumber")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                        placeholder: t("invoiceDetails.typeHere"),
                                                                        value: editInvoice.invoiceNumber || "",
                                                                        disabled: !invoiceTypeNextStepAllowed,
                                                                        onChange: function(evt) {
                                                                            return onChangeTextOpenInvoice("invoiceNumber", evt.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                                                                templateColumns: "repeat(2, 1fr)",
                                                                gap: 3,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "smaller",
                                                                                    mb: "1",
                                                                                    fontWeight: "bold",
                                                                                    children: t("invoiceDetails.date")
                                                                                }),
                                                                                invoiceTypeNextStepAllowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                                                                    renderInput: renderCustomInput,
                                                                                    value: selectedDay,
                                                                                    onChange: changeInvoiceDate,
                                                                                    colorPrimary: "#1a5f3f"
                                                                                }),
                                                                                !invoiceTypeNextStepAllowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                                    placeholder: t("invoiceDetails.typeHere"),
                                                                                    value: selectedDay.day + "." + selectedDay.month + "." + selectedDay.year,
                                                                                    disabled: !invoiceTypeNextStepAllowed
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectCurrency, {
                                                                        value: editInvoice.currency,
                                                                        disabled: !invoiceTypeNextStepAllowed,
                                                                        changeValue: onChangeTextOpenInvoice
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionWorkflowBudget"),
                                                    description: t("invoiceDetails.sectionWorkflowBudgetDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {}),
                                                    collapsible: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                        spacing: 3,
                                                        align: "stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectInvoiceType, {
                                                                changeValue: onChangeTextOpenInvoice,
                                                                value: editInvoice.invoiceType,
                                                                disabled: editInvoice.invoiceType != undefined && editInvoice.invoiceType != "" && createInvoice == false,
                                                                isInvalid: editInvoiceErrorArray.includes("invoiceType"),
                                                                invoiceTypesData: invoiceTypesData
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectBudget, {
                                                                changeValue: onChangeTextOpenInvoice,
                                                                disabled: !invoiceTypeNextStepAllowed,
                                                                value: editInvoice.category,
                                                                categoriesData: categoriesData,
                                                                isInvalid: editInvoiceErrorArray.includes("category"),
                                                                session: session,
                                                                api_url: api_url,
                                                                invoiceDate: editInvoice.date
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionPartnerTransaction"),
                                                    description: t("invoiceDetails.sectionPartnerTransactionDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonCircleSharp */.umg, {}),
                                                    collapsible: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                        spacing: 4,
                                                        align: "stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "smaller",
                                                                        mb: "1",
                                                                        fontWeight: "bold",
                                                                        children: t("invoiceDetails.tradingPartner")
                                                                    }),
                                                                    function() {
                                                                        var partnerData = editInvoice.tradingPartnerData;
                                                                        var partnerId = editInvoice.tradingPartner;
                                                                        if (partnerData || partnerId) {
                                                                            var displayPartner = partnerData || tradingPartnersData.find(function(p) {
                                                                                return p._id === partnerId;
                                                                            });
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                                p: 3,
                                                                                borderWidth: 1,
                                                                                borderRadius: "md",
                                                                                borderColor: "blue.300",
                                                                                bg: "blue.50",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                    gap: 3,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                                            spacing: 3,
                                                                                            minW: 0,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                                                    size: "sm",
                                                                                                    name: displayPartner === null || displayPartner === void 0 ? void 0 : displayPartner.name,
                                                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPersonCircleSharp */.umg, {})
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                                    minW: 0,
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                            fontWeight: "bold",
                                                                                                            noOfLines: 1,
                                                                                                            children: (displayPartner === null || displayPartner === void 0 ? void 0 : displayPartner.name) || t("invoiceDetails.loadingPartner")
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                            fontSize: "xs",
                                                                                                            color: "gray.600",
                                                                                                            children: (displayPartner === null || displayPartner === void 0 ? void 0 : displayPartner.creditorNumber) || (displayPartner === null || displayPartner === void 0 ? void 0 : displayPartner.debitorNumber) || ""
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        invoiceTypeNextStepAllowed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                                            spacing: 1,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                                                                                    label: t("common.change") || "Change",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                                                                                        "aria-label": "Change trading partner",
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRefresh */.e8N, {}),
                                                                                                        size: "sm",
                                                                                                        variant: "ghost",
                                                                                                        colorScheme: "blue",
                                                                                                        onClick: function() {
                                                                                                            return setIsTradingPartnerSelectorOpen(true);
                                                                                                        }
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                                                                                                    label: t("common.delete") || "Delete",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                                                                                        "aria-label": "Remove trading partner",
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloseCircle */.R5A, {}),
                                                                                                        size: "sm",
                                                                                                        variant: "ghost",
                                                                                                        colorScheme: "red",
                                                                                                        onClick: function() {
                                                                                                            onChangeTextOpenInvoice("tradingPartner", "");
                                                                                                            editInvoice.tradingPartnerData = null;
                                                                                                        }
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            });
                                                                        }
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                            width: "full",
                                                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                                            onClick: function() {
                                                                                return setIsTradingPartnerSelectorOpen(true);
                                                                            },
                                                                            isDisabled: !invoiceTypeNextStepAllowed,
                                                                            variant: "outline",
                                                                            colorScheme: "rekening",
                                                                            children: t("invoiceDetails.selectTradingPartner") || "Select Trading Partner"
                                                                        });
                                                                    }()
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                                        alignItems: "center",
                                                                        mb: "1",
                                                                        gap: 2,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                fontSize: "smaller",
                                                                                fontWeight: "bold",
                                                                                children: t("invoiceDetails.linkedTransactions")
                                                                            }),
                                                                            linkedTransactions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                                colorScheme: "green",
                                                                                fontSize: "2xs",
                                                                                children: t("invoiceDetails.paymentCount", {
                                                                                    count: linkedTransactions.length
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    linkedTransactions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                                        spacing: 2,
                                                                        align: "stretch",
                                                                        mb: 2,
                                                                        children: [
                                                                            linkedTransactions.map(function(lt) {
                                                                                var txd = lt.transactionDetails;
                                                                                if (!txd) return null;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                                    p: 3,
                                                                                    borderWidth: 1,
                                                                                    borderRadius: "md",
                                                                                    borderColor: "green.300",
                                                                                    bg: "green.50",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        gap: 3,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                                minW: 0,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                                        fontWeight: "bold",
                                                                                                        color: "green.700",
                                                                                                        noOfLines: 1,
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
                                                                                                                style: {
                                                                                                                    display: "inline",
                                                                                                                    marginRight: "8px",
                                                                                                                    verticalAlign: "middle"
                                                                                                                }
                                                                                                            }),
                                                                                                            t("invoiceDetails.linkedTransaction")
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                                        fontSize: "sm",
                                                                                                        mt: 1,
                                                                                                        noOfLines: 1,
                                                                                                        children: [
                                                                                                            new Date(txd.transactionDate).toLocaleDateString("de-DE"),
                                                                                                            " -",
                                                                                                            " ",
                                                                                                            txd.counterparty,
                                                                                                            " - ",
                                                                                                            typeof txd.amount === "number" ? txd.amount.toFixed(2) : txd.amount,
                                                                                                            " ",
                                                                                                            txd.currency || "€"
                                                                                                        ]
                                                                                                    }),
                                                                                                    txd.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                        fontSize: "xs",
                                                                                                        color: "gray.600",
                                                                                                        mt: 1,
                                                                                                        noOfLines: 2,
                                                                                                        children: txd.reference
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            invoiceTypeNextStepAllowed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                                                                size: "sm",
                                                                                                variant: "ghost",
                                                                                                colorScheme: "red",
                                                                                                onClick: function() {
                                                                                                    var newIds = linkedTransactions.map(function(l) {
                                                                                                        return l.transaction;
                                                                                                    }).filter(function(id) {
                                                                                                        return id !== lt.transaction;
                                                                                                    });
                                                                                                    var nextLinked = linkedTransactions.filter(function(l) {
                                                                                                        return l.transaction !== lt.transaction;
                                                                                                    });
                                                                                                    setLinkedTransactions(nextLinked);
                                                                                                    var openInvoiceData = newInvoice;
                                                                                                    if (createInvoice == false) {
                                                                                                        openInvoiceData = rekeningData[selectedInvoice];
                                                                                                    }
                                                                                                    openInvoiceData.linkedTransactionIds = newIds;
                                                                                                    openInvoiceData.linkedTransactions = nextLinked;
                                                                                                    saveInvoiceData(openInvoiceData);
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloseCircle */.R5A, {
                                                                                                        style: {
                                                                                                            marginRight: "4px"
                                                                                                        }
                                                                                                    }),
                                                                                                    t("invoiceDetails.unlinkTransaction")
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, lt._id);
                                                                            }),
                                                                            function() {
                                                                                var inv = editInvoice;
                                                                                var invoiceTotal = parseFloat(editInvoice.total) || 0;
                                                                                var paidSum = inv.linkedTransactionAmountSum != null ? Math.abs(inv.linkedTransactionAmountSum) : linkedTransactions.reduce(function(sum, lt) {
                                                                                    var ref;
                                                                                    return sum + Math.abs(((ref = lt.transactionDetails) === null || ref === void 0 ? void 0 : ref.amount) || 0);
                                                                                }, 0);
                                                                                var remaining = inv.remainingAmount != null ? inv.remainingAmount : Math.max(0, invoiceTotal - paidSum);
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                    p: 2,
                                                                                    borderRadius: "md",
                                                                                    bg: "gray.50",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                            fontSize: "xs",
                                                                                            color: "gray.600",
                                                                                            children: t("invoiceDetails.paidAmount", {
                                                                                                paid: paidSum.toFixed(2),
                                                                                                total: invoiceTotal.toFixed(2),
                                                                                                currency: editInvoice.currency || "EUR"
                                                                                            })
                                                                                        }),
                                                                                        remaining > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                            fontSize: "xs",
                                                                                            color: "orange.600",
                                                                                            fontWeight: "bold",
                                                                                            children: [
                                                                                                t("invoiceDetails.remainingAmount"),
                                                                                                ": ",
                                                                                                remaining.toFixed(2),
                                                                                                " ",
                                                                                                editInvoice.currency || "EUR"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            }()
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                        width: "full",
                                                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                                        onClick: function() {
                                                                            return setIsTransactionSelectorOpen(true);
                                                                        },
                                                                        isDisabled: !invoiceTypeNextStepAllowed,
                                                                        variant: "outline",
                                                                        colorScheme: "rekening",
                                                                        size: linkedTransactions.length > 0 ? "sm" : "md",
                                                                        children: t("invoiceDetails.selectTransaction") || "Link Transaction"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionAccounting"),
                                                    description: t("invoiceDetails.sectionAccountingDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCash */.SG6, {}),
                                                    collapsible: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                        spacing: 4,
                                                        align: "stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "smaller",
                                                                        mb: "1",
                                                                        fontWeight: "bold",
                                                                        children: t("invoiceDetails.transactionType")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* default */.Z, {
                                                                        placeholder: t("invoiceDetails.transactionType"),
                                                                        value: editInvoice.transactionType ? {
                                                                            label: editInvoice.transactionType === "incoming" ? t("invoiceDetails.incoming") : t("invoiceDetails.outgoing"),
                                                                            value: editInvoice.transactionType
                                                                        } : null,
                                                                        isDisabled: !invoiceTypeNextStepAllowed,
                                                                        onChange: function(selectedOption) {
                                                                            return onChangeTextOpenInvoice("transactionType", (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "incoming");
                                                                        },
                                                                        options: [
                                                                            {
                                                                                label: t("invoiceDetails.incoming"),
                                                                                value: "incoming"
                                                                            },
                                                                            {
                                                                                label: t("invoiceDetails.outgoing"),
                                                                                value: "outgoing"
                                                                            }, 
                                                                        ],
                                                                        isSearchable: false,
                                                                        isClearable: false,
                                                                        size: "md",
                                                                        menuPortalTarget:  true ? document.body : 0,
                                                                        menuPosition: "fixed",
                                                                        styles: {
                                                                            menuPortal: function(base) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                                                                                    zIndex: 2000
                                                                                });
                                                                            }
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                                        align: "center",
                                                                        justify: "space-between",
                                                                        mb: "1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                fontSize: "smaller",
                                                                                fontWeight: "bold",
                                                                                children: t("invoiceDetails.bookingEntries") || "Buchungss\xe4tze"
                                                                            }),
                                                                            invoiceTypeNextStepAllowed == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                                size: "xs",
                                                                                variant: "outline",
                                                                                onClick: editInvoiceAddBookingEntry,
                                                                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                                                children: t("invoiceDetails.addBookingEntry") || "Hinzuf\xfcgen"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    bookingEntries.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "sm",
                                                                        color: "gray.500",
                                                                        children: t("invoiceDetails.noBookingEntries") || "Noch keine Buchungss\xe4tze angelegt."
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                        children: bookingEntries.map(function(entry, index) {
                                                                            var ref;
                                                                            var canRemove = invoiceTypeNextStepAllowed == true;
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                mt: index === 0 ? 0 : 3,
                                                                                p: 3,
                                                                                bg: "gray.50",
                                                                                borderWidth: 1,
                                                                                borderColor: "gray.200",
                                                                                borderRadius: "md",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                                                                                        templateColumns: {
                                                                                            base: "1fr",
                                                                                            md: "repeat(14, 1fr)"
                                                                                        },
                                                                                        gap: 3,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                                                colSpan: {
                                                                                                    base: 14,
                                                                                                    md: 8
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                        fontSize: "smaller",
                                                                                                        mb: "1",
                                                                                                        fontWeight: "bold",
                                                                                                        children: t("invoiceDetails.grossAmount") || "Brutto"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_currency_input_field_dist_index_esm/* default */.ZP, {
                                                                                                        className: "like-chakra-input",
                                                                                                        placeholder: t("invoiceDetails.enterNumber"),
                                                                                                        defaultValue: (entry === null || entry === void 0 ? void 0 : entry.amount) || "",
                                                                                                        decimalsLimit: 2,
                                                                                                        allowNegativeValue: false,
                                                                                                        intlConfig: currencyInputConfig,
                                                                                                        step: 1,
                                                                                                        onValueChange: function(value, name, values) {
                                                                                                            return onChangeBookingEntry(index, "amount", (values === null || values === void 0 ? void 0 : values.float) != null ? values.float.toFixed(2).toString() : "");
                                                                                                        },
                                                                                                        disabled: !invoiceTypeNextStepAllowed
                                                                                                    }, "".concat(openedInvoiceKey, "-booking-").concat(index, "-amount"))
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                                                colSpan: {
                                                                                                    base: 14,
                                                                                                    md: 6
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                        fontSize: "smaller",
                                                                                                        mb: "1",
                                                                                                        fontWeight: "bold",
                                                                                                        children: t("invoiceDetails.buSchluessel") || "BU-Schl\xfcssel"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuKeySelect, {
                                                                                                        value: (entry === null || entry === void 0 ? void 0 : entry.buSchluessel) || "",
                                                                                                        isDisabled: !invoiceTypeNextStepAllowed,
                                                                                                        placeholder: t("invoiceDetails.selectBuKey") || "BU-Schl\xfcssel ausw\xe4hlen...",
                                                                                                        onChange: function(next) {
                                                                                                            return onChangeBookingEntry(index, "buSchluessel", next);
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                        mt: 3,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                fontSize: "smaller",
                                                                                                mb: "1",
                                                                                                fontWeight: "bold",
                                                                                                children: t("invoiceDetails.bookingAccountSkr3") || "Buchungskonto (SKR03)"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingAccountSkr3Select/* BookingAccountSkr3Select */._, {
                                                                                                value: (entry === null || entry === void 0 ? void 0 : entry.account) || "",
                                                                                                isDisabled: !invoiceTypeNextStepAllowed,
                                                                                                placeholder: t("invoiceDetails.selectBookingAccount"),
                                                                                                onChange: function(next) {
                                                                                                    return onChangeBookingEntry(index, "account", next);
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                        mt: 3,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                                fontSize: "smaller",
                                                                                                mb: "1",
                                                                                                fontWeight: "bold",
                                                                                                children: t("invoiceDetails.bookingText") || "Buchungstext"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                                                                gap: 2,
                                                                                                align: "center",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                                                        placeholder: t("invoiceDetails.typeHere"),
                                                                                                        value: (entry === null || entry === void 0 ? void 0 : entry.bookingText) || "",
                                                                                                        onChange: function(evt) {
                                                                                                            return onChangeBookingEntry(index, "bookingText", evt.target.value);
                                                                                                        },
                                                                                                        disabled: !invoiceTypeNextStepAllowed
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                                                                                        "aria-label": t("invoiceDetails.remove") || "Entfernen",
                                                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTrash */.VOs, {
                                                                                                            fontSize: "18px"
                                                                                                        }),
                                                                                                        variant: "outline",
                                                                                                        colorScheme: "red",
                                                                                                        size: "sm",
                                                                                                        onClick: function() {
                                                                                                            return editInvoiceRemoveBookingEntry(index);
                                                                                                        },
                                                                                                        isDisabled: !canRemove
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }, ((ref = entry) === null || ref === void 0 ? void 0 : ref._id) || "".concat(index, "-booking-entry"));
                                                                        })
                                                                    }),
                                                                    bookingValidationActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dist_index_esm/* Alert */.bZ, {
                                                                        mt: 4,
                                                                        status: bookingEntriesSumValid ? "success" : "error",
                                                                        variant: "left-accent",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dist_index_esm/* AlertIcon */.zM, {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        fontSize: "sm",
                                                                                        children: bookingEntriesSumValid ? t("invoiceDetails.bookingEntriesSumOk") || "Summe der Buchungss\xe4tze ist korrekt." : t("invoiceDetails.bookingEntriesSumError") || "Summe der Buchungss\xe4tze muss dem Bruttobetrag der Rechnung entsprechen."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                        fontSize: "xs",
                                                                                        color: "gray.600",
                                                                                        children: [
                                                                                            (t("invoiceDetails.bookingEntriesSumHint") || "Buchungss\xe4tze: {{bookings}} / Brutto: {{gross}}").replace("{{bookings}}", (bookingEntriesSumCents / 100).toFixed(2)).replace("{{gross}}", (invoiceTotalCents / 100).toFixed(2)),
                                                                                            " ",
                                                                                            editInvoice.currency
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                        fontSize: "smaller",
                                                                        mb: "1",
                                                                        fontWeight: "bold",
                                                                        children: t("invoiceDetails.clearingAccount")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* default */.Z, {
                                                                        placeholder: t("invoiceDetails.selectClearingAccount"),
                                                                        value: editInvoice.clearingAccount ? {
                                                                            label: "".concat(((ref11 = clearingAccountsData.find(function(account) {
                                                                                return account._id === editInvoice.clearingAccount;
                                                                            })) === null || ref11 === void 0 ? void 0 : ref11.accountNumber) || "", " - ").concat(((ref12 = clearingAccountsData.find(function(account) {
                                                                                return account._id === editInvoice.clearingAccount;
                                                                            })) === null || ref12 === void 0 ? void 0 : ref12.name) || ""),
                                                                            value: editInvoice.clearingAccount
                                                                        } : null,
                                                                        isDisabled: !invoiceTypeNextStepAllowed,
                                                                        onChange: function(selectedOption) {
                                                                            return onChangeTextOpenInvoice("clearingAccount", (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                                                                        },
                                                                        options: clearingAccountsData.map(function(account) {
                                                                            return {
                                                                                label: "".concat(account.accountNumber, " - ").concat(account.name),
                                                                                value: account._id
                                                                            };
                                                                        }),
                                                                        isSearchable: true,
                                                                        isClearable: true,
                                                                        size: "md",
                                                                        menuPortalTarget:  true ? document.body : 0,
                                                                        menuPosition: "fixed",
                                                                        styles: {
                                                                            menuPortal: function(base) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                                                                                    zIndex: 2000
                                                                                });
                                                                            }
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                "travelExpense" in editInvoice && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionTravelExpense"),
                                                    description: t("invoiceDetails.sectionTravelExpenseDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoBriefcase */.BRz, {}),
                                                    collapsible: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelExpenseElement, {
                                                        changeTravelExpenseLocation: changeTravelExpenseLocation,
                                                        invoiceData: editInvoice,
                                                        updateMeals: updateMeals,
                                                        invoiceTypeNextStepAllowed: invoiceTypeNextStepAllowed,
                                                        editInvoiceErrorArray: editInvoiceErrorArray,
                                                        countryListAllowance: countryListAllowance,
                                                        travelExpense: editInvoice.travelExpense,
                                                        readOnlyAdminFields: false,
                                                        changeText: onChangeTextTravelExpense
                                                    })
                                                }),
                                                editInvoice.invoiceKind != "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionAmounts"),
                                                    description: t("invoiceDetails.sectionAmountsDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCash */.SG6, {}),
                                                    collapsible: false,
                                                    rightElement: invoiceTypeNextStepAllowed == true && editInvoice.invoiceKind != "travel-expense" && editInvoice.taxPositions != undefined && editInvoice.taxPositions.length != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                        size: "sm",
                                                        variant: "outline",
                                                        onClick: editInvoiceAddTaxRate,
                                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                        children: t("invoiceDetails.taxRates")
                                                    }) : null,
                                                    children: [
                                                        (editInvoice.taxPositions == undefined || editInvoice.taxPositions.length == 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                                                                templateColumns: "repeat(2, 1fr)",
                                                                gap: 3,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                fontSize: "smaller",
                                                                                mb: "1",
                                                                                fontWeight: "bold",
                                                                                children: [
                                                                                    t("invoiceDetails.amountIn"),
                                                                                    editInvoice.currency
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                                placeholder: "0",
                                                                                value: editInvoice.total,
                                                                                onChange: function(evt) {
                                                                                    return onChangeTotalOpenInvoice("value", evt.target.value, 0);
                                                                                },
                                                                                type: "number",
                                                                                min: "0",
                                                                                disabled: !invoiceTypeNextStepAllowed,
                                                                                isInvalid: editInvoiceErrorArray.includes("amount")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                fontSize: "smaller",
                                                                                mb: "1",
                                                                                fontWeight: "bold",
                                                                                children: t("invoiceDetails.vatIn")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                                placeholder: t("invoiceDetails.typeHere"),
                                                                                value: editInvoice.mwst,
                                                                                onChange: function(evt) {
                                                                                    return onChangeTotalOpenInvoice("taxRate", evt.target.value, 0);
                                                                                },
                                                                                type: "number",
                                                                                min: "0",
                                                                                max: "100",
                                                                                disabled: !invoiceTypeNextStepAllowed
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        editInvoice.taxPositions != undefined && editInvoice.taxPositions.length != 0 && editInvoice.invoiceKind != "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                            children: editInvoice.taxPositions.map(function(singleTaxPosition, index) {
                                                                var addRemoveButton = false;
                                                                if (index > 0) {
                                                                    addRemoveButton = true;
                                                                }
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                                                                    mt: "2",
                                                                    templateColumns: {
                                                                        base: "1fr",
                                                                        md: "repeat(14, 1fr)"
                                                                    },
                                                                    gap: 3,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                            colSpan: {
                                                                                base: 14,
                                                                                md: 4
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "smaller",
                                                                                    mb: "1",
                                                                                    fontWeight: "bold",
                                                                                    children: t("invoiceDetails.grossAmount")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_currency_input_field_dist_index_esm/* default */.ZP, {
                                                                                    className: "like-chakra-input" + (editInvoiceErrorArray.includes("amount") ? " invalid" : ""),
                                                                                    placeholder: t("invoiceDetails.enterNumber"),
                                                                                    defaultValue: singleTaxPosition.value,
                                                                                    decimalsLimit: 2,
                                                                                    allowNegativeValue: false,
                                                                                    intlConfig: currencyInputConfig,
                                                                                    step: 1,
                                                                                    onValueChange: function(value, name, values) {
                                                                                        return onChangeTotalOpenInvoice("value", values.float, index);
                                                                                    }
                                                                                }, "".concat(openedInvoiceKey, "-tax-").concat(index, "-value"))
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                            colSpan: {
                                                                                base: 14,
                                                                                md: 4
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "smaller",
                                                                                    mb: "1",
                                                                                    fontWeight: "bold",
                                                                                    children: t("invoiceDetails.netAmount")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_currency_input_field_dist_index_esm/* default */.ZP, {
                                                                                    className: "like-chakra-input" + (editInvoiceErrorArray.includes("amountNet") ? " invalid" : ""),
                                                                                    placeholder: t("invoiceDetails.enterNumber"),
                                                                                    defaultValue: singleTaxPosition.valueNet,
                                                                                    decimalsLimit: 2,
                                                                                    allowNegativeValue: false,
                                                                                    intlConfig: currencyInputConfig,
                                                                                    step: 1,
                                                                                    onValueChange: function(value, name, values) {
                                                                                        return onChangeTotalOpenInvoice("valueNet", values.float, index);
                                                                                    },
                                                                                    disabled: !invoiceTypeNextStepAllowed || editInvoice.invoiceKind == "travel-expense"
                                                                                }, "".concat(openedInvoiceKey, "-tax-").concat(index, "-valueNet"))
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                            colSpan: {
                                                                                base: 14,
                                                                                md: 4
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "smaller",
                                                                                    mb: "1",
                                                                                    fontWeight: "bold",
                                                                                    children: t("invoiceDetails.taxAmount")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_currency_input_field_dist_index_esm/* default */.ZP, {
                                                                                    className: "like-chakra-input" + (editInvoiceErrorArray.includes("amount") ? " invalid" : ""),
                                                                                    placeholder: t("invoiceDetails.enterNumber"),
                                                                                    defaultValue: singleTaxPosition.valueTax,
                                                                                    decimalsLimit: 2,
                                                                                    allowNegativeValue: false,
                                                                                    intlConfig: currencyInputConfig,
                                                                                    step: 1,
                                                                                    onValueChange: function(value, name, values) {
                                                                                        return onChangeTotalOpenInvoice("valueTax", values.float, index);
                                                                                    }
                                                                                }, "".concat(openedInvoiceKey, "-tax-").concat(index, "-valueTax"))
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                            colSpan: {
                                                                                base: 14,
                                                                                md: 2
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                    fontSize: "smaller",
                                                                                    mb: "1",
                                                                                    fontWeight: "bold",
                                                                                    children: t("invoiceDetails.vatIn")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_currency_input_field_dist_index_esm/* default */.ZP, {
                                                                                    className: "like-chakra-input" + (editInvoiceErrorArray.includes("taxRate") ? " invalid" : ""),
                                                                                    placeholder: t("invoiceDetails.enterNumber"),
                                                                                    defaultValue: singleTaxPosition.taxRate,
                                                                                    decimalsLimit: 2,
                                                                                    allowNegativeValue: false,
                                                                                    intlConfig: currencyInputConfig,
                                                                                    step: 1,
                                                                                    maxLength: 2,
                                                                                    onValueChange: function(value, name, values) {
                                                                                        return onChangeTotalOpenInvoice("taxRate", values.float, index);
                                                                                    },
                                                                                    disabled: !invoiceTypeNextStepAllowed || editInvoice.invoiceKind == "travel-expense",
                                                                                    suffix: " %"
                                                                                }, "".concat(openedInvoiceKey, "-tax-").concat(index, "-taxRate"))
                                                                            ]
                                                                        }),
                                                                        addRemoveButton && invoiceTypeNextStepAllowed == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                                            colSpan: {
                                                                                base: 12,
                                                                                md: 12
                                                                            },
                                                                            display: "flex",
                                                                            justifyContent: "flex-end",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                                mt: {
                                                                                    base: 0,
                                                                                    md: 2
                                                                                },
                                                                                onClick: function(e) {
                                                                                    return editInvoiceRemoveTaxRate(index);
                                                                                },
                                                                                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRemoveCircle */.fE4, {
                                                                                    fontSize: "18px"
                                                                                }),
                                                                                size: "sm",
                                                                                variant: "outline",
                                                                                children: t("invoiceDetails.remove")
                                                                            })
                                                                        })
                                                                    ]
                                                                }, index + "-tax");
                                                            })
                                                        })
                                                    ]
                                                }),
                                                editInvoice.invoiceKind === "invoice" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvoiceDrawerSection, {
                                                    title: t("invoiceDetails.sectionDocument"),
                                                    description: t("invoiceDetails.sectionDocumentDesc"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoDocumentAttachOutline */.tJY, {}),
                                                    collapsible: false,
                                                    rightElement: invoiceTypeNextStepAllowed == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                        size: "sm",
                                                        variant: "outline",
                                                        isLoading: uploadInProgress,
                                                        onClick: function() {
                                                            return fileInputRef.current && fileInputRef.current.click();
                                                        },
                                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {
                                                            fontSize: "18px"
                                                        }),
                                                        isDisabled: attachmentUrl !== "",
                                                        children: t("invoiceDetails.uploadInvoice")
                                                    }) : null,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            ref: fileInputRef,
                                                            style: {
                                                                display: "none"
                                                            },
                                                            type: "file",
                                                            id: "file-upload",
                                                            onChange: function(e) {
                                                                var ref;
                                                                var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
                                                                if (!file) return;
                                                                if (attachmentUrl !== "") {
                                                                    userNotification(t("invoiceDetails.documentAlreadyAttachedTitle"), t("invoiceDetails.documentAlreadyAttachedDesc"), "warning");
                                                                    return;
                                                                }
                                                                uploadFile(file, false, true);
                                                            }
                                                        }),
                                                        attachmentUrl !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            fontSize: "sm",
                                                            color: "gray.600",
                                                            children: t("invoiceDetails.documentManagedInPreviewHint")
                                                        }),
                                                        attachmentUrl === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            fontSize: "smaller",
                                                            mb: "1",
                                                            fontWeight: "bold",
                                                            children: t("invoiceDetails.noDocument")
                                                        })
                                                    ]
                                                }),
                                                createInvoice == false && invoiceTypeNextStepAllowed == true && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                                    justify: "flex-end",
                                                    pt: 4,
                                                    mt: 1,
                                                    borderTopWidth: "1px",
                                                    borderColor: "gray.200",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                        size: "sm",
                                                        variant: "outline",
                                                        colorScheme: "red",
                                                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTrash */.VOs, {}),
                                                        onClick: function() {
                                                            return setIsDeleteOpen(true);
                                                        },
                                                        children: deleteInvoiceHeaderLabel
                                                    })
                                                })
                                            ]
                                        }),
                                        drawerMainTab === "comments" && createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                                            spacing: 5,
                                            align: "stretch",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                title: t("comments.sectionTitle"),
                                                description: t("comments.sectionDesc"),
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChatbubbleEllipsesOutline */.rIi, {}),
                                                defaultOpen: true,
                                                collapsible: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceCommentsSection, {
                                                    apiUrl: api_url,
                                                    invoice: editInvoice,
                                                    invoiceId: editInvoice === null || editInvoice === void 0 ? void 0 : editInvoice._id,
                                                    session: session,
                                                    userData: userData,
                                                    onRefresh: function() {
                                                        return loadSingleInvoices(editInvoice._id);
                                                    }
                                                })
                                            })
                                        }),
                                        drawerMainTab === "activity" && createInvoice == false && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                                            spacing: 5,
                                            align: "stretch",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceDrawerSection, {
                                                title: t("invoiceDetails.sectionChangelog"),
                                                description: t("invoiceDetails.sectionChangelogOpen"),
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTimer */.o6T, {}),
                                                collapsible: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChangeLogElement, {
                                                    userData: userData,
                                                    value: editInvoice.changelog,
                                                    compact: true,
                                                    withAccordion: false
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerFooter */.ze, {
                                style: {
                                    borderTop: "1px solid #e2e8f0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                    width: "100%",
                                    columns: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InvoiceStatusElement, {
                                            typeName: "Invoice",
                                            createInvoice: createInvoice,
                                            nextStepAllowed: invoiceTypeNextStepAllowed,
                                            invoiceTypesData: invoiceTypesData,
                                            invoiceType: editInvoice.invoiceType,
                                            invoiceStatus: editInvoice.invoiceStatus,
                                            changeValue: editInvoiceStatusUpdate
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                            mt: 5,
                                            children: [
                                                createInvoice != true && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    mr: 3,
                                                    onClick: previewBackwards,
                                                    variant: "outline",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronBack */.dUf, {})
                                                }),
                                                createInvoice != true && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    mr: 3,
                                                    onClick: previewForwards,
                                                    variant: "outline",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronForwardOutline */.nQU, {})
                                                }),
                                                createInvoice != true && editInvoice.invoiceKind == "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                    mr: "3",
                                                    variant: "outline",
                                                    onClick: function() {
                                                        return printTravelExpense(editInvoice._id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoPrint */.EY5, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            ml: "2",
                                                            children: t("invoiceDetails.print")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    mr: 3,
                                                    onClick: closeInvoice,
                                                    variant: "outline",
                                                    children: t("invoiceDetails.cancelClose")
                                                }),
                                                createInvoice == false && invoiceTypeNextStepAllowed == true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                    onClick: saveInvoice,
                                                    isLoading: saveInvoiceLoading,
                                                    isDisabled: !editInvoiceModified || !bookingEntriesSumValid,
                                                    colorScheme: "rekening",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSave */.qaA, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            ml: "2",
                                                            children: t("invoiceDetails.saveChanges")
                                                        })
                                                    ]
                                                }),
                                                createInvoice == true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                                    onClick: saveInvoice,
                                                    isLoading: saveInvoiceLoading,
                                                    isDisabled: !bookingEntriesSumValid,
                                                    colorScheme: "rekening",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSave */.qaA, {}),
                                                        editInvoice.invoiceKind == "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            ml: "2",
                                                            children: t("invoiceDetails.addTravelExpense")
                                                        }),
                                                        editInvoice.invoiceKind == "invoice" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            ml: "2",
                                                            children: t("invoiceDetails.addInvoice")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    invoiceIsOpen && attachmentUrl !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(InvoiceAttachmentPreviewPanel, {
                        invoiceId: editInvoice === null || editInvoice === void 0 ? void 0 : editInvoice._id,
                        attachmentUrl: attachmentUrl,
                        isPdf: isPdfPreviewOpen,
                        invoiceKind: editInvoice.invoiceKind,
                        shop: editInvoice.shop,
                        dateIso: editInvoice.date,
                        invoiceNumber: editInvoice.invoiceNumber || "",
                        total: String(editInvoice.total),
                        totalNet: String(editInvoice.totalNet),
                        tax: String(editInvoice.tax),
                        currency: editInvoice.currency,
                        canEditAttachment: invoiceTypeNextStepAllowed == true && editInvoice.invoiceKind == "invoice",
                        onRemoveAttachment: removeImageFromInvoice
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isCloseEditWithoutSave,
                onClose: onCloseEditWithoutSaveClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("invoiceDetails.closeWithoutSaving")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    children: t("invoiceDetails.sureToClose")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: function() {
                                            onCloseEditWithoutSaveClose();
                                            closeInvoice();
                                        },
                                        mr: 3,
                                        variant: "outline",
                                        children: t("invoiceDetails.cancelClose")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                        onClick: function() {
                                            saveInvoice();
                                            onCloseEditWithoutSaveClose();
                                        },
                                        mr: 3,
                                        colorScheme: "rekening",
                                        isDisabled: !bookingEntriesSumValid,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneCircleSharp */.w_p, {
                                                style: {
                                                    fontSize: "1.2em",
                                                    marginRight: "5px"
                                                }
                                            }),
                                            t("invoiceDetails.saveAndClose")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditorManager/* default */.Z, {
                isOpen: isOpenTradingPartnerManager,
                onClose: function() {
                    return setIsOpenTradingPartnerManager(false);
                },
                updateTradingPartnerData: updateTradingPartnerData,
                setUpdateTradingPartnerData: setUpdateTradingPartnerData,
                insertTradingPartner: isInsertTradingPartner,
                session: session,
                loadTradingPartners: loadTradingPartners
            }),
            session && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TransactionSelectorDrawer, {
                isOpen: isTransactionSelectorOpen,
                onClose: function() {
                    return setIsTransactionSelectorOpen(false);
                },
                onSelect: function(tx) {
                    var currentIds = linkedTransactions.map(function(lt) {
                        return lt.transaction;
                    });
                    if (currentIds.includes(tx._id)) return;
                    var newIds = (0,_to_consumable_array/* default */.Z)(currentIds).concat([
                        tx._id
                    ]);
                    var newLink = {
                        _id: "local-".concat(tx._id, "-").concat(Date.now()),
                        transaction: tx._id,
                        transactionDetails: {
                            transactionDate: tx.transactionDate,
                            counterparty: tx.counterparty,
                            amount: tx.amount,
                            currency: tx.currency,
                            reference: tx.reference
                        }
                    };
                    var nextLinked = (0,_to_consumable_array/* default */.Z)(linkedTransactions).concat([
                        newLink
                    ]);
                    setLinkedTransactions(nextLinked);
                    var openInvoiceData = newInvoice;
                    if (createInvoice == false) {
                        openInvoiceData = rekeningData[selectedInvoice];
                    }
                    openInvoiceData.linkedTransactionIds = newIds;
                    openInvoiceData.linkedTransactions = nextLinked;
                    saveInvoiceData(openInvoiceData);
                },
                apiUrl: api_url,
                session: session,
                excludeTransactionIds: linkedTransactions.map(function(lt) {
                    return lt.transaction;
                })
            }),
            session && /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingPartnerSelectorDrawer/* default */.Z, {
                isOpen: isTradingPartnerSelectorOpen,
                onClose: function() {
                    return setIsTradingPartnerSelectorOpen(false);
                },
                onSelect: function(partner) {
                    onChangeTextOpenInvoice("tradingPartner", partner._id);
                    editInvoice.tradingPartnerData = partner;
                },
                apiUrl: api_url,
                session: session,
                onCreateNew: openCreateTradingPartner
            })
        ]
    }) : null;
    return modalContent;
};
/* harmony default export */ var components_InvoiceDetailDrawer = (InvoiceDetailDrawer);

// EXTERNAL MODULE: ./src/components/QueueProgressOverlay.tsx
var QueueProgressOverlay = __webpack_require__(43949);
// EXTERNAL MODULE: ./node_modules/react-ga4/dist/index.js
var dist = __webpack_require__(49089);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./src/constants/AllIcons.tsx
var AllIcons = __webpack_require__(86181);
;// CONCATENATED MODULE: ./src/pages/index.tsx































dist/* default.initialize */.ZP.initialize("G-0GRPP85B5D");





var mainContainer = {
    maxWidth: "1200px",
    display: "block",
    margin: "auto"
};
var CustomCard = function(data) {
    var item = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        padding: "3",
        backgroundColor: "white",
        borderWidth: "1px",
        borderRadius: "lg",
        mb: "2",
        style: {
            transition: "all 0.2s"
        },
        _hover: {
            cursor: "pointer",
            backgroundColor: "#f4f4f4"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                as: "h4",
                size: "sm",
                children: item.shop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                display: "flex",
                alignItems: "baseline",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    color: "gray.500",
                    fontWeight: "semibold",
                    letterSpacing: "wide",
                    textTransform: "uppercase",
                    ml: "0",
                    children: item.date
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                as: "h4",
                size: "sm",
                children: item.shop
            })
        ]
    });
};
var NewCardForm = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(NewCardForm, Component);
    var _super = (0,_create_super/* default */.Z)(NewCardForm);
    function NewCardForm() {
        (0,_class_call_check/* default */.Z)(this, NewCardForm);
        return _super.apply(this, arguments);
    }
    var _proto = NewCardForm.prototype;
    //handleAdd = () => this.props.onAdd({title: this.titleRef.value, description: this.descRef.value})
    //setTitleRef = (ref) => this.titleRef = ref
    //setDescRef = (ref) => this.descRef = ref
    _proto.render = function render() {
        //const {onCancel} = this.props
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {})
        });
    };
    return NewCardForm;
}(react.Component);
var menuWrapper = {
    maxWidth: "1240px",
    position: "relative",
    display: "block",
    margin: "auto"
};
var Index = function(param) {
    var sessionServerSide = param.sessionServerSide, checkSubscription = param.checkSubscription, tabIndexMenu = param.tabIndexMenu;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)([]), rekeningData = ref4[0], setRekeningData = ref4[1];
    var ref5 = (0,react.useState)("Kanban"), viewStyle = ref5[0], setViewStyle = ref5[1];
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var ref6 = (0,dist_esm/* useTranslation */.$G)("common"), t = ref6.t, i18n = ref6.i18n;
    var ref7 = (0,react.useState)([]), rekeningDataOriginal = ref7[0], setRekeningDataOriginal = ref7[1];
    var ref8 = (0,react.useState)([]), travelExpenseData = ref8[0], setTravelExpenseData = ref8[1];
    var ref9 = (0,react.useState)({
        spending: {},
        totalSpending: 0.0
    }), budgetSpendingData = ref9[0], setBudgetSpendingData = ref9[1];
    var ref10 = (0,react.useState)([]), selectedInvoicesIds = ref10[0], setSelectedInvoicesIds = ref10[1];
    var ref11 = (0,react.useState)([]), selectedInvoiceMonths = ref11[0], setSelectedInvoiceMonths = ref11[1];
    var ref12 = (0,react.useState)([]), invoiceTypesData = ref12[0], setInoviceTypesData = ref12[1];
    var ref13 = (0,react.useState)([]), changedInvoices = ref13[0], setChangedInvoices = ref13[1];
    var ref14 = (0,react.useState)(true), moreInvoicesAvailable = ref14[0], setMoreInvoicesAvailable = ref14[1];
    var ref15 = (0,react.useState)({
        steps: [],
        title: ""
    }), editInvoiceTypeWorkflow = ref15[0], setEditInvoiceTypeWorkflow = ref15[1];
    var ref16 = (0,react.useState)(true), isLoading = ref16[0], setIsLoading = ref16[1];
    var ref17 = (0,react.useState)(false), isLoadingRefund = ref17[0], setIsLoadingRefund = ref17[1];
    var ref18 = (0,react.useState)(false), isLoadingRequestRefund = ref18[0], setIsLoadingRequestRefund = ref18[1];
    var ref19 = (0,react.useState)(false), editInvoiceReadonly = ref19[0], setEditInvoiceReadonly = ref19[1];
    var ref20 = (0,react.useState)("This invoice is locked"), editInvoiceReadonlyReason = ref20[0], setEditInvoiceReadonlyReason = ref20[1];
    var ref21 = (0,react.useState)(false), editInvoiceModified = ref21[0], setEditInvoiceModified = ref21[1];
    var ref22 = (0,react.useState)([]), bulkUploadData = ref22[0], setBulkUploadData = ref22[1];
    var ref23 = (0,react.useState)({
        category: "",
        invoiceType: ""
    }), bulkUploadSettings = ref23[0], setBulkUploadSettings = ref23[1];
    var ref24 = (0,react.useState)(0), bulkUploadCounterFinished = ref24[0], setBulkUploadCounterFinished = ref24[1];
    var ref25 = (0,react.useState)(0), bulkUploadCounterTotal = ref25[0], setBulkUploadCounterTotal = ref25[1];
    // Async upload and queue tracking
    var ref26 = (0,react.useState)(0), uploadedFileCount = ref26[0], setUploadedFileCount = ref26[1];
    var ref27 = (0,react.useState)(0), totalFilesToUpload = ref27[0], setTotalFilesToUpload = ref27[1];
    // File input ref for bulk upload
    var fileInputRef = (0,react.useRef)(null);
    var folderInputRef = (0,react.useRef)(null);
    var ref28 = (0,react.useState)([]), queueEntryIds = ref28[0], setQueueEntryIds = ref28[1];
    var ref29 = (0,react.useState)(false), isQueueOverlayVisible = ref29[0], setIsQueueOverlayVisible = ref29[1];
    var ref30 = (0,react.useState)({
        active: 0,
        total: 0
    }), invoiceQueueCounts = ref30[0], setInvoiceQueueCounts = ref30[1];
    var ref31 = (0,react.useState)([]), categoriesData = ref31[0], setCategoriesData = ref31[1];
    var ref32 = (0,react.useState)([]), userData = ref32[0], setUserData = ref32[1];
    var ref33 = (0,react.useState)(parseInt(tabIndexMenu)), tabIndex = ref33[0], setTabIndex = ref33[1];
    //NEW
    var ref34 = (0,react.useState)([
        {
            key: "searchText",
            value: ""
        },
        {
            key: "searchUser",
            value: ""
        }
    ]), searchValues = ref34[0], setSearchValues = ref34[1];
    // New filter state management
    var ref35 = (0,react.useState)("alle"), filterView = ref35[0], setFilterView = ref35[1]; // "alle" or "meine"
    var ref36 = (0,react.useState)([]), activeFilters = ref36[0], setActiveFilters = ref36[1];
    var ref37 = (0,react.useState)(null), dateFilter = ref37[0], setDateFilter = ref37[1];
    var ref38 = (0,react.useState)(null), receiptFilter = ref38[0], setReceiptFilter = ref38[1];
    var ref39 = (0,react.useState)(null), statusFilter = ref39[0], setStatusFilter = ref39[1];
    var ref40 = (0,react.useState)(null), categoryFilter = ref40[0], setCategoryFilter = ref40[1];
    var ref41 = (0,react.useState)(null), userFilter = ref41[0], setUserFilter = ref41[1];
    var ref42 = (0,react.useState)(null), invoiceTypeFilter = ref42[0], setInvoiceTypeFilter = ref42[1];
    var ref43 = (0,react.useState)(null), invoiceKindFilter = ref43[0], setInvoiceKindFilter = ref43[1];
    var ref44 = (0,react.useState)(null), transactionTypeFilter = ref44[0], setTransactionTypeFilter = ref44[1];
    var ref45 = (0,react.useState)(null), transactionLinkedFilter = ref45[0], setTransactionLinkedFilter = ref45[1];
    var ref46 = (0,react.useState)(""), searchText = ref46[0], setSearchText = ref46[1];
    // Advanced filter modal state
    var ref47 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isAdvancedFilterOpen = ref47.isOpen, onAdvancedFilterOpen = ref47.onOpen, onAdvancedFilterClose = ref47.onClose;
    var ref48 = (0,react.useState)({
        dateRange: null,
        amountFrom: "",
        amountTo: "",
        transactionType: null,
        users: [],
        creditors: [],
        categories: [],
        invoiceTypes: [],
        invoiceStatuses: [],
        invoiceKinds: []
    }), advancedFilters = ref48[0], setAdvancedFilters = ref48[1];
    var ref49 = (0,react.useState)([]), creditorsData = ref49[0], setCreditorsData = ref49[1];
    var ref50 = (0,react.useState)("0"), totalVisibleValue = ref50[0], setTotalVisibleValue = ref50[1];
    var ref51 = (0,react.useState)(0), selectedInvoice = ref51[0], setSelectedInvoice = ref51[1];
    // Source-of-truth selection to avoid index drift when `rekeningData` changes (e.g. parallel uploads/inserts).
    var ref52 = (0,react.useState)(null), selectedInvoiceId = ref52[0], setSelectedInvoiceId = ref52[1];
    var ref53 = (0,react.useState)(undefined), selectedInvoiceNextStep = ref53[0], setSelectedInvoiceNextStep = ref53[1];
    var ref54 = (0,react.useState)(false), loginRequired = ref54[0], setLoginRequired = ref54[1];
    var ref55 = (0,react.useState)(false), uploadInProgress = ref55[0], setUploadInProgress = ref55[1];
    var ref56 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), viewImage = ref56[0], setViewImage = ref56[1];
    var ref57 = (0,react.useState)(false), createInvoice = ref57[0], setCreateInvoice = ref57[1];
    var ref58 = (0,react.useState)(""), createInvoiceType = ref58[0], setCreateInvoiceType = ref58[1];
    var api_url = "https://api.rekening.de";
    var ref59 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isRefundOpen = ref59.isOpen, onRefundOpen = ref59.onOpen, onRefundClose = ref59.onClose;
    var ref60 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isRequestRefundOpen = ref60.isOpen, onRequestRefundOpen = ref60.onOpen, onRequestRefundClose = ref60.onClose;
    var ref61 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isDownloadOpen = ref61.isOpen, onDownloadOpen = ref61.onOpen, onDownloadClose = ref61.onClose;
    var ref62 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isUpgradeOpen = ref62.isOpen, onUpgradeOpen = ref62.onOpen, onUpgradeClose = ref62.onClose;
    var ref63 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), invoiceIsOpen = ref63.isOpen, invoiceOnOpen = ref63.onOpen, invoiceOnClose = ref63.onClose;
    var ref64 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpenBulkUploadPrep = ref64.isOpen, onOpenBulkUploadPrep = ref64.onOpen, onCloseBulkUploadPrep = ref64.onClose;
    var ref65 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpenBulkUpload = ref65.isOpen, onOpenBulkUpload = ref65.onOpen, onCloseBulkUpload = ref65.onClose;
    //  Delete Confirm Modal
    var ref66 = (0,react.useState)(false), isDeleteOpen = ref66[0], setIsDeleteOpen = ref66[1];
    //Upload Duplicate
    var ref67 = (0,react.useState)(false), isDuplicateModalOpen = ref67[0], setIsDuplicateModalOpen = ref67[1];
    var ref68 = (0,react.useState)(null), duplicateCurrentFile = ref68[0], setDuplicateCurrentFile = ref68[1];
    var ref69 = (0,react.useState)(null), duplicateUserDecision = ref69[0], setDuplicateUserDecision = ref69[1];
    var handleDuplicateOverwrite = function() {
        duplicateUserDecision("overwrite");
    };
    var handleDuplicateSkip = function() {
        duplicateUserDecision("skip");
    };
    var emptyTravelExpense = {
        kind: "travel-expense",
        uuid: "",
        shop: "",
        description: "",
        invoiceStatus: "",
        category: "",
        tax: "0",
        mwst: "0",
        total: "",
        totalNet: "",
        currency: "",
        taxPositions: [],
        travelExpense: {
            locationFrom: "",
            locationTo: "",
            transportation: "train",
            transportationDistance: "",
            breakfasts: 0,
            lunches: 0,
            dinners: 0,
            startDate: new Date().toUTCString(),
            endDate: new Date().toUTCString(),
            country: "DE",
            allowanceSmall: "14",
            allowanceBig: "28",
            compensation: "0"
        },
        author: "",
        authorData: [
            {
                name: ""
            }
        ],
        childInvoices: []
    };
    var ref70 = (0,react.useState)(emptyTravelExpense), travelExpense = ref70[0], setTravelExpense = ref70[1];
    var ref71 = (0,react.useState)(true), newTravelExpense = ref71[0], setNewTravelExpense = ref71[1];
    var ref72 = (0,react.useState)({}), monthlyCost = ref72[0], setMonthlyCost = ref72[1];
    var ref73 = (0,react.useState)(0), totalCost = ref73[0], setTotalCost = ref73[1];
    var ref74 = (0,react.useState)([]), travelExpenseFilter = ref74[0], setTravelExpenseFilter = ref74[1];
    var ref75 = (0,react.useState)([]), bulkInsertData = ref75[0], setBulkInsertData = ref75[1];
    var ref76 = (0,react.useState)(true), travelExpenseLoadHasMore = ref76[0], setTravelExpenseLoadHasMore = ref76[1];
    var ref77 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isTutorialOpen = ref77.isOpen, onTutorialOpen = ref77.onOpen, onTutorialClose = ref77.onClose;
    //TRAVEL EXPENSE
    var ref78 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isTravelExpenseOpen = ref78.isOpen, onTravelExpenseOpen = ref78.onOpen, onTravelExpenseClose = ref78.onClose;
    // Use the protected session hook instead of direct useSession
    var ref79 = (0,useProtectedSession/* useProtectedSession */.b)(), session = ref79.session, status = ref79.status;
    var currency = "€";
    var query = (0,next_router.useRouter)().query;
    var router = (0,next_router.useRouter)();
    // Prevent re-opening the same invoice repeatedly when data/state updates while the URL parameter remains.
    var lastOpenedInvoiceIdRef = (0,react.useRef)(null);
    var setInvoiceIdInUrl = function(invoiceId) {
        var nextQuery = (0,_object_spread/* default */.Z)({}, router.query);
        if (!invoiceId) {
            delete nextQuery.invoiceId;
        } else {
            nextQuery.invoiceId = invoiceId;
        }
        router.replace({
            pathname: router.pathname,
            query: nextQuery
        }, undefined, {
            shallow: true
        });
    };
    var applyReadonlyForInvoice = function(invoice) {
        var ref, ref1;
        var editInvoiceReadonlyTemp = false;
        var editInvoiceReadonlyReasonTemp = "";
        // User ist owner
        if ((session === null || session === void 0 ? void 0 : (ref = session.user_data) === null || ref === void 0 ? void 0 : ref["_id"]) != (invoice === null || invoice === void 0 ? void 0 : invoice.author) && !(session === null || session === void 0 ? void 0 : (ref1 = session.rights) === null || ref1 === void 0 ? void 0 : ref1.includes("view-all-invoices"))) {
            editInvoiceReadonlyTemp = true;
            editInvoiceReadonlyReasonTemp = "This invoice is locked since it is currently in editing by its owner";
        }
        setEditInvoiceReadonlyReason(editInvoiceReadonlyReasonTemp);
        setEditInvoiceReadonly(editInvoiceReadonlyTemp);
    };
    // Keep `selectedInvoice` (index) synced to the selected ID so list mutations won’t change the opened invoice.
    react.useEffect(function() {
        if (!selectedInvoiceId) return;
        var idx = rekeningData.findIndex(function(inv) {
            return (inv === null || inv === void 0 ? void 0 : inv._id) === selectedInvoiceId;
        });
        if (idx !== -1 && idx !== selectedInvoice) {
            setSelectedInvoice(idx);
        }
    }, [
        selectedInvoiceId,
        rekeningData,
        selectedInvoice
    ]);
    // Open & reload invoice by ID (used by URL deep-link, list clicks, prev/next)
    var openInvoiceById = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(invoiceId, opts) {
            var updateUrl, openDrawer, existingIndex, existingInvoice, response, invoiceFromServer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!(session === null || session === void 0 ? void 0 : session.accessToken) || !invoiceId)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        updateUrl = (opts === null || opts === void 0 ? void 0 : opts.updateUrl) !== false;
                        openDrawer = (opts === null || opts === void 0 ? void 0 : opts.openDrawer) !== false;
                        // Avoid double-open when we set `invoiceId` into the URL ourselves (the URL effect would otherwise retrigger).
                        lastOpenedInvoiceIdRef.current = invoiceId;
                        if (updateUrl) setInvoiceIdInUrl(invoiceId);
                        setSelectedInvoiceId(invoiceId);
                        setCreateInvoice(false);
                        existingIndex = rekeningData.findIndex(function(inv) {
                            return (inv === null || inv === void 0 ? void 0 : inv._id) === invoiceId;
                        });
                        existingInvoice = existingIndex !== -1 ? rekeningData[existingIndex] : null;
                        // If already in list, open immediately with current data (fast) and then refresh.
                        if (existingInvoice) {
                            applyReadonlyForInvoice(existingInvoice);
                            setSelectedInvoice(existingIndex);
                            loadBudgetSpending(existingInvoice.category);
                            if (openDrawer) invoiceOnOpen();
                        }
                        _ctx.prev = 11;
                        _ctx.next = 14;
                        return axios_default().get("".concat(api_url, "/invoices/").concat(invoiceId), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 14:
                        response = _ctx.sent;
                        if (response.status === 200 && response.data) {
                            invoiceFromServer = response.data;
                            setRekeningData(function(prev) {
                                var idx = prev.findIndex(function(e) {
                                    return (e === null || e === void 0 ? void 0 : e._id) == invoiceId;
                                });
                                if (idx === -1) return [
                                    invoiceFromServer
                                ].concat((0,_to_consumable_array/* default */.Z)(prev));
                                var next = (0,_to_consumable_array/* default */.Z)(prev);
                                next[idx] = invoiceFromServer;
                                return next;
                            });
                            applyReadonlyForInvoice(invoiceFromServer);
                            loadBudgetSpending(invoiceFromServer.category);
                            // If it wasn't in the list, open after we inserted it at the beginning.
                            if (!existingInvoice) {
                                setSelectedInvoice(0);
                                if (openDrawer) invoiceOnOpen();
                            }
                        } else {
                            userNotification(t("components.index.invoiceNotFound"), t("components.index.invoiceNotFoundDescription"), "error");
                        }
                        _ctx.next = 22;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](11);
                        console.error("Error loading invoice by ID:", _ctx.t0);
                        userNotification(t("components.index.invoiceNotFound"), t("components.index.invoiceNotFoundDescription"), "error");
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    18
                ]
            ]);
        }));
        return function openInvoiceById(invoiceId, opts) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeInvoiceDrawer = function() {
        setInvoiceIdInUrl(null);
        setSelectedInvoiceId(null);
        lastOpenedInvoiceIdRef.current = null;
        invoiceOnClose();
    };
    // Check for invoiceId URL parameter
    react.useEffect(function() {
        if (!(session === null || session === void 0 ? void 0 : session.accessToken)) return;
        var rawInvoiceId = router.query.invoiceId;
        var invoiceIdFromUrl = Array.isArray(rawInvoiceId) ? rawInvoiceId[0] : rawInvoiceId;
        if (invoiceIdFromUrl && lastOpenedInvoiceIdRef.current !== invoiceIdFromUrl) {
            lastOpenedInvoiceIdRef.current = invoiceIdFromUrl;
            // Open from deep-link without re-writing the same URL again.
            openInvoiceById(invoiceIdFromUrl, {
                updateUrl: false,
                openDrawer: true
            });
        }
    }, [
        router.query.invoiceId,
        session === null || session === void 0 ? void 0 : session.accessToken
    ]);
    react.useEffect(function() {
        if (!(session === null || session === void 0 ? void 0 : session.accessToken)) return;
        //loadInvoices();
        loadUser();
        loadCategories();
        loadCreditors();
        if (tabIndex == 1) {
            loadTravelExpenses();
        } else {}
        loadInvoiceTypes();
        if (checkSubscription == "true") {
            updateSubscription();
        }
        dist/* default.send */.ZP.send({
            hitType: "pageview",
            page: window.location.pathname
        });
    }, [
        query,
        session === null || session === void 0 ? void 0 : session.accessToken
    ]);
    react.useEffect(function() {
        setTabIndex(tabIndexMenu);
    }, [
        tabIndexMenu
    ]);
    var updateSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, fetchDataJson;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return fetch("".concat(api_url, "/teams/subscription/update"), {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            }
                        });
                    case 4:
                        fetchData = _ctx.sent;
                        _ctx.next = 7;
                        return fetchData.json();
                    case 7:
                        fetchDataJson = _ctx.sent;
                        if ("statusCode" in fetchDataJson) {} else {
                        //window.location.href = fetchDataJson.url;
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateSubscription() {
            return _ref.apply(this, arguments);
        };
    }();
    var userNotification = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(title, subTitle, status) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toast({
                            title: title,
                            description: subTitle,
                            status: status,
                            duration: 5000,
                            isClosable: true,
                            position: "bottom-left"
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function userNotification(title, subTitle, status) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchData = axios_default().get("".concat(api_url, "/users"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 10;
                            break;
                        }
                        setUserData(data.data);
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function loadUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCategories = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data, categoryList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchData = axios_default().get("".concat(api_url, "/categories"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 12;
                            break;
                        }
                        categoryList = data.data;
                        categoryList.map(function(element, i) {
                            var displayIcon = AllIcons/* default.find */.Z.find(function(e) {
                                return e.iconWeb == element.iconWeb;
                            });
                            categoryList[i]["iconWebElement"] = displayIcon.iconWebElement;
                        });
                        //set data
                        setCategoriesData(categoryList);
                        return _ctx.abrupt("return", data.data);
                    case 12:
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return");
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    14
                ]
            ]);
        }));
        return function loadCategories() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadBudgetSpending = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(categoryId) {
            var fetchDataCategory, dataCategory;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!(categoryId == undefined)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.prev = 4;
                        fetchDataCategory = axios_default().get("".concat(api_url, "/invoices/spendingPerCategory/").concat(categoryId), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 8;
                        return fetchDataCategory;
                    case 8:
                        dataCategory = _ctx.sent;
                        if (dataCategory.status != 403 && dataCategory.status != 500) {
                            setBudgetSpendingData((0,_object_spread/* default */.Z)({}, dataCategory.data));
                        }
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](4);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    12
                ]
            ]);
        }));
        return function loadBudgetSpending(categoryId) {
            return _ref.apply(this, arguments);
        };
    }();
    var calculateMonthlyCost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var existingInvoices, totalCostTemp, monthlyCostTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        existingInvoices = rekeningData;
                        totalCostTemp = 0.0;
                        if (data != undefined) {
                            existingInvoices = data;
                        }
                        existingInvoices.sort(function(a, b) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        });
                        setRekeningData((0,_to_consumable_array/* default */.Z)(existingInvoices));
                        monthlyCostTemp = {};
                        existingInvoices.map(function(item, index) {
                            var invDate = new Date(item.date).toLocaleString();
                            var dateNew = new Date(item.date).getMonth();
                            var yearNew = new Date(item.date).getFullYear();
                            var key = yearNew + "_" + dateNew;
                            //const dateArray = invDate.split(".");
                            //var dateNew = parseInt(dateArray[1]) -1;
                            if (key in monthlyCostTemp == false) {
                                monthlyCostTemp[key] = 0;
                            }
                            var singelItemPrice = item.total;
                            if (typeof singelItemPrice == "string") {
                                singelItemPrice = singelItemPrice.replace(",", ".");
                            }
                            var currentCost = monthlyCostTemp[key];
                            var totalPrice = (parseFloat(singelItemPrice) + parseFloat(currentCost)).toFixed(2);
                            monthlyCostTemp[key] = totalPrice;
                            totalCostTemp = totalCostTemp + parseFloat(singelItemPrice);
                        });
                        setTotalCost(parseFloat(totalCostTemp.toFixed(2)));
                        setMonthlyCost(monthlyCostTemp);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function calculateMonthlyCost(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadInvoices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var pageNumber, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pageNumber = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 1;
                        return _ctx.abrupt("return", loadInvoicesWithSearchValues(searchValues, pageNumber));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadInvoices() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadSingleInvoices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(invoiceId) {
            var fetchData, data, rekeningDataTempResponse, indexToReplace, next;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchData = axios_default().get("".concat(api_url, "/invoices/").concat(invoiceId), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 12;
                            break;
                        }
                        rekeningDataTempResponse = data.data;
                        indexToReplace = rekeningData.findIndex(function(e) {
                            return e._id == invoiceId;
                        });
                        if (indexToReplace === -1) {
                            // If invoice wasn't in list (edge-case), append it.
                            setRekeningData((0,_to_consumable_array/* default */.Z)(rekeningData).concat([
                                rekeningDataTempResponse
                            ]));
                        } else {
                            next = (0,_to_consumable_array/* default */.Z)(rekeningData);
                            next[indexToReplace] = rekeningDataTempResponse;
                            setRekeningData(next);
                        }
                        return _ctx.abrupt("return", rekeningDataTempResponse);
                    case 12:
                        _ctx.next = 18;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](2);
                        setLoginRequired(false);
                        setIsLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    14
                ]
            ]);
        }));
        return function loadSingleInvoices(invoiceId) {
            return _ref.apply(this, arguments);
        };
    }();
    var scrollLoadMoreInvoices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pageNumber) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        loadInvoicesWithSearchValues(searchValues, pageNumber);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        /*let offset = numberScrolled * 200,
    limit = 200,
    travelExpenseFilterTemp = travelExpenseFilter,
    filterExistsOffset = travelExpenseFilterTemp.findIndex((e)=> e.key == "offset"),
    filterExistsLimit = travelExpenseFilterTemp.findIndex((e)=> e.key == "limit");

    if(filterExistsOffset == -1){
      travelExpenseFilterTemp.push({key: "offset", value: offset});
      travelExpenseFilterTemp.push({key: "limit", value: limit});
    }
    setTravelExpenseLoadHasMore(false);
    setTravelExpenseFilter([...travelExpenseFilterTemp]);
*/ }));
        return function scrollLoadMoreInvoices(pageNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadTravelExpenses = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var loadTravelExpensesUrl, fetchData, data, travelExpensesFromServer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        loadTravelExpensesUrl = "".concat(api_url, "/travelExpense?");
                        _ctx.prev = 3;
                        fetchData = axios_default().get(loadTravelExpensesUrl, {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 7;
                        return fetchData;
                    case 7:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 16;
                            break;
                        }
                        travelExpensesFromServer = data.data;
                        /*if(travelExpenseFilter.findIndex((e)=> e.key = "offset") != -1){
              console.log("COMBINE", travelExpenseData);
              travelExpensesFromServer = travelExpensesFromServer.concat(travelExpenseData);
            }*/ travelExpensesFromServer.sort(function(a, b) {
                            return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
                        });
                        setTravelExpenseData(travelExpensesFromServer);
                        /*if(searchForText != "" || searchForStatus != "" || searchForUser != ""){
              searchFor(searchForText, searchForStatus, searchForUser);
            }*/ setIsLoading(false);
                        return _ctx.abrupt("return", data.data);
                    case 16:
                        {
                            setIsLoading(false);
                        }
                    case 17:
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](3);
                        setIsLoading(false);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    19
                ]
            ]);
        }));
        return function loadTravelExpenses() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadInvoiceTypes = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchData = axios_default().get("".concat(api_url, "/invoiceTypes"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 10;
                            break;
                        }
                        setInoviceTypesData(data.data);
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function loadInvoiceTypes() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCreditors = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var fetchData, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        fetchData = axios_default().get("".concat(api_url, "/trading-partners"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 6;
                        return fetchData;
                    case 6:
                        data = _ctx.sent;
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 10;
                            break;
                        }
                        // Map trading partners to creditors format for backward compatibility
                        setCreditorsData(data.data.tradingPartners || data.data);
                        return _ctx.abrupt("return", data.data.tradingPartners || data.data);
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        return _ctx.abrupt("return");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function loadCreditors() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteSelectedInvoices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var rekeningDataTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        rekeningDataTemp = rekeningData;
                        selectedInvoicesIds.map(function(singleInvoice) {
                            deleteInvoice(singleInvoice._id, true);
                            rekeningDataTemp = rekeningDataTemp.filter(function(e) {
                                return e._id != singleInvoice._id;
                            });
                        });
                        setIsDeleteOpen(false);
                        setSelectedInvoicesIds([]);
                        setRekeningData(rekeningDataTemp);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteSelectedInvoices() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, bulkDelete) {
            var fetchData, rekeningDataTemp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return fetch("".concat(api_url, "/invoices/").concat(id), {
                            method: "DELETE",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 4:
                        fetchData = _ctx.sent;
                        rekeningDataTemp = rekeningData.filter(function(e) {
                            return e._id != id;
                        });
                        if (!bulkDelete) {
                            setRekeningData(rekeningDataTemp);
                        }
                        setEditInvoiceModified(false);
                        userNotification("Delete Successfull", "Your invoice has been successfully deleted", "success");
                        setChangedInvoices([]);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteInvoice(id, bulkDelete) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var body, fetchData, fetchDataJson;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        body = data;
                        if (!(data == undefined)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        _ctx.next = 7;
                        return fetch("".concat(api_url, "/invoices/").concat(data._id), {
                            method: "PATCH",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 7:
                        fetchData = _ctx.sent;
                        _ctx.next = 10;
                        return fetchData.json();
                    case 10:
                        fetchDataJson = _ctx.sent;
                        if (!("statusCode" in fetchDataJson)) {
                            _ctx.next = 16;
                            break;
                        }
                        userNotification("Update Error", fetchDataJson["message"][0], "error");
                        return _ctx.abrupt("return", false);
                    case 16:
                        userNotification("Update Successfull", "Your invoice has been successfully updated", "success");
                        setChangedInvoices([
                            fetchDataJson["_id"]
                        ]);
                        _ctx.next = 20;
                        return loadSingleInvoices(data._id);
                    case 20:
                        return _ctx.abrupt("return", true);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateInvoice(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var refundAll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoadingRefund(true);
                        _ctx.next = 3;
                        return rekeningData.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inv) {
                                var tempInv;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            tempInv = inv;
                                            tempInv.status = "refunded";
                                            _ctx.next = 4;
                                            return updateInvoice(tempInv);
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(inv) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 3:
                        setIsLoadingRefund(false);
                        onRefundClose();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refundAll() {
            return _ref.apply(this, arguments);
        };
    }();
    var requestRefundAll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoadingRequestRefund(true);
                        _ctx.next = 3;
                        return rekeningData.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inv) {
                                var tempInv;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            tempInv = inv;
                                            tempInv.status = "requested";
                                            _ctx.next = 4;
                                            return updateInvoice(tempInv);
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(inv) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 3:
                        setRekeningData([]);
                        _ctx.next = 6;
                        return loadInvoices();
                    case 6:
                        setIsLoadingRequestRefund(false);
                        onRequestRefundClose();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function requestRefundAll() {
            return _ref.apply(this, arguments);
        };
    }();
    var bulkUpdateInvoiceStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var changedInvovicesIds;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoadingRequestRefund(true);
                        changedInvovicesIds = [];
                        _ctx.next = 4;
                        return Promise.all(selectedInvoicesIds.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inv) {
                                var tempInv;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            tempInv = inv;
                                            tempInv.invoiceStatus = selectedInvoiceNextStep._id;
                                            changedInvovicesIds.push(tempInv._id);
                                            return _ctx.abrupt("return", updateInvoice(tempInv));
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(inv) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 4:
                        setRekeningData([]);
                        setSelectedInvoicesIds([]);
                        setChangedInvoices(changedInvovicesIds);
                        loadInvoices();
                        setIsLoadingRequestRefund(false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function bulkUpdateInvoiceStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleInvoiceSelectMonth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(year, month) {
            var rekeningDataTemp, forceStatus, tempSelectedInvoiceMonths, tempSelectedInvoiceMonthsNew, invoicesToUpdateArray;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log(year, month);
                        rekeningDataTemp = rekeningData;
                        forceStatus = true;
                        tempSelectedInvoiceMonths = selectedInvoiceMonths;
                        console.log("tempSelectedInvoiceMonths", tempSelectedInvoiceMonths);
                        if (tempSelectedInvoiceMonths.includes(year + "-" + month)) {
                            forceStatus = false;
                            console.log("FALSE");
                            tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(function(item) {
                                return item !== year + "-" + month;
                            });
                            setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
                        } else {
                            tempSelectedInvoiceMonths.push(year + "-" + month);
                            setSelectedInvoiceMonths(tempSelectedInvoiceMonths);
                        }
                        invoicesToUpdateArray = [];
                        // Step 1: Collect Promises
                        rekeningDataTemp.map(function(item, index) {
                            var itemDate = new Date(item.date);
                            var itemYear = itemDate.getFullYear();
                            var itemMonth = itemDate.getMonth() + 1; // +1 to make it 1-based (January = 1)
                            if (itemYear === year && itemMonth === month) {
                                // Assuming toggleInvoiceSelect returns a Promise
                                invoicesToUpdateArray.push({
                                    _id: item._id,
                                    status: forceStatus
                                });
                            }
                        });
                        toggleInvoiceSelect(invoicesToUpdateArray);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function toggleInvoiceSelectMonth(year, month) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleInvoiceSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(invArray) {
            var rekeningDataTemp, selectedInvoicesIdsTemp, invoiceType, invoiceStatus, invoiceStatusToSet, countDifferentInoviceTypeStatus, invoiceTypeObject, invoiceStatusObjectIndex;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        rekeningDataTemp = rekeningData, selectedInvoicesIdsTemp = selectedInvoicesIds;
                        invArray.map(function(element, index) {
                            var _id = element._id;
                            var forceStatus = element.status;
                            var item = rekeningDataTemp.find(function(el) {
                                return el._id === _id;
                            });
                            console.log("Selected:", item);
                            var yearNew = new Date(item.date).getFullYear();
                            var monthNew = new Date(item.date).getMonth() + 1;
                            var tempSelectedInvoiceMonths = selectedInvoiceMonths;
                            if (forceStatus != undefined) {
                                item["selected"] = forceStatus;
                                console.log("forceStatus", forceStatus);
                                if (forceStatus == true) {
                                    selectedInvoicesIdsTemp.push(item);
                                } else {
                                    selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(function(e) {
                                        return e._id !== _id;
                                    });
                                    console.log("ID:", _id);
                                    console.log("Filtered:", selectedInvoicesIdsTemp);
                                }
                            } else if (item["selected"] == undefined || item["selected"] == false) {
                                item["selected"] = true;
                                selectedInvoicesIdsTemp.push(item);
                            } else {
                                item["selected"] = false;
                                selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(function(e) {
                                    return e._id !== _id;
                                });
                                //Deselect Month
                                if (tempSelectedInvoiceMonths.includes(yearNew + "-" + monthNew)) {
                                    forceStatus = false;
                                    console.log("FALSE");
                                    var tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(function(item) {
                                        return item !== yearNew + "-" + monthNew;
                                    });
                                    setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
                                }
                            }
                        });
                        invoiceType = "", invoiceStatus = "", invoiceStatusToSet = undefined, countDifferentInoviceTypeStatus = 0;
                        selectedInvoicesIdsTemp.map(function(singleSelectedInvoice) {
                            if (invoiceType == "" && invoiceStatus == "") {
                                invoiceType = singleSelectedInvoice.invoiceType;
                                invoiceStatus = singleSelectedInvoice.invoiceStatus;
                            }
                            if (invoiceType != singleSelectedInvoice.invoiceType || invoiceStatus != singleSelectedInvoice.invoiceStatus) {
                                countDifferentInoviceTypeStatus += 1;
                            }
                        });
                        if (countDifferentInoviceTypeStatus == 0 && selectedInvoicesIdsTemp.length != 0) {
                            invoiceTypeObject = invoiceTypesData.find(function(e) {
                                return e._id == invoiceType;
                            });
                            if (invoiceTypeObject != -1) {
                                invoiceStatusObjectIndex = invoiceTypeObject.steps.findIndex(function(e) {
                                    return e._id == invoiceStatus;
                                });
                                if (invoiceStatusObjectIndex < invoiceTypeObject.steps.length) {
                                    invoiceStatusToSet = invoiceTypeObject.steps[invoiceStatusObjectIndex + 1];
                                }
                            }
                            setSelectedInvoiceNextStep(invoiceStatusToSet);
                        }
                        setSelectedInvoicesIds(selectedInvoicesIdsTemp);
                        setRekeningData((0,_to_consumable_array/* default */.Z)(rekeningDataTemp));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function toggleInvoiceSelect(invArray) {
            return _ref.apply(this, arguments);
        };
    }();
    /*
  const toggleInvoiceSelect = async (i, forceStatus = undefined) => {
    let rekeningDataTemp = rekeningData,
    selectedInvoicesIdsTemp = selectedInvoicesIds,
    item = rekeningData[i];
    const yearNew = new Date(item.date).getFullYear();
    const monthNew = new Date(item.date).getMonth() +1;
    let tempSelectedInvoiceMonths = selectedInvoiceMonths;

    if(forceStatus != undefined){
      rekeningDataTemp[i]["selected"] = forceStatus;
      console.log("forceStatus", forceStatus);
      if(forceStatus == true){
        selectedInvoicesIdsTemp.push(rekeningDataTemp[i]);
      }else{
        selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== rekeningDataTemp[i]._id);
        console.log("Filtered:", selectedInvoicesIdsTemp)
      }
    }else if(rekeningDataTemp[i]["selected"] == undefined || rekeningDataTemp[i]["selected"] == false){
      rekeningDataTemp[i]["selected"] = true;
      selectedInvoicesIdsTemp.push(rekeningDataTemp[i]);
    }else{
      rekeningDataTemp[i]["selected"] = false;
      selectedInvoicesIdsTemp = selectedInvoicesIdsTemp.filter(e => e._id !== rekeningDataTemp[i]._id);

      //Deselect Month
      if(tempSelectedInvoiceMonths.includes(yearNew+"-"+monthNew)){
        forceStatus = false;
        console.log("FALSE");
        let tempSelectedInvoiceMonthsNew = tempSelectedInvoiceMonths.filter(item => item !== yearNew+"-"+monthNew);
        setSelectedInvoiceMonths(tempSelectedInvoiceMonthsNew);
      }
    }


    let invoiceType = "",
    invoiceStatus = "",
    invoiceStatusToSet = undefined,
    countDifferentInoviceTypeStatus = 0;

    selectedInvoicesIdsTemp.map((singleSelectedInvoice) =>{
      if(invoiceType == "" && invoiceStatus == ""){
        invoiceType = singleSelectedInvoice.invoiceType;
        invoiceStatus = singleSelectedInvoice.invoiceStatus;
      }
      if(invoiceType != singleSelectedInvoice.invoiceType || invoiceStatus != singleSelectedInvoice.invoiceStatus){
        countDifferentInoviceTypeStatus += 1;
      }
    });
    if(countDifferentInoviceTypeStatus == 0 && selectedInvoicesIdsTemp.length != 0){
      let invoiceTypeObject = invoiceTypesData.find(e => e._id == invoiceType);

      if(invoiceTypeObject != -1){
        let invoiceStatusObjectIndex = invoiceTypeObject.steps.findIndex(e => e._id == invoiceStatus);

        if(invoiceStatusObjectIndex < invoiceTypeObject.steps.length){
          invoiceStatusToSet = invoiceTypeObject.steps[invoiceStatusObjectIndex +1];
        }
      }

      setSelectedInvoiceNextStep(invoiceStatusToSet);
    }




    setSelectedInvoicesIds(selectedInvoicesIdsTemp);
    setRekeningData([...rekeningDataTemp]);
  }
*/ var previewForwards = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var next;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        next = rekeningData[selectedInvoice + 1];
                        if (next === null || next === void 0 ? void 0 : next._id) {
                            openInvoiceById(next._id);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function previewForwards() {
            return _ref.apply(this, arguments);
        };
    }();
    var previewBackwards = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var prev;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        prev = rekeningData[selectedInvoice - 1];
                        if (prev === null || prev === void 0 ? void 0 : prev._id) {
                            openInvoiceById(prev._id);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function previewBackwards() {
            return _ref.apply(this, arguments);
        };
    }();
    var openInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var currentDate, invoice, invoiceId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setEditInvoiceModified(false);
                        currentDate = new Date().toUTCString();
                        if (!(id == "invoice")) {
                            _ctx.next = 6;
                            break;
                        }
                        {
                            setInvoiceIdInUrl(null);
                            setSelectedInvoiceId(null);
                            setCreateInvoice(true);
                            setCreateInvoiceType("invoice");
                            setEditInvoiceReadonlyReason("");
                            setEditInvoiceReadonly(false);
                            /*
      let invData = emptyInvoice;
      invData.category = categoriesData[0]._id;
      saveInvoiceData(invData);
      */ loadBudgetSpending(categoriesData[0]._id);
                        }
                        _ctx.next = 15;
                        break;
                    case 6:
                        if (!(id == "travel-expense")) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            console.log("Travel Expense");
                            setInvoiceIdInUrl(null);
                            setSelectedInvoiceId(null);
                            setCreateInvoice(true);
                            setCreateInvoiceType("travel-expense");
                            setEditInvoiceReadonlyReason("");
                            setEditInvoiceReadonly(false);
                            /*
      let invData = emptyInvoice;
      invData.category = categoriesData[0]._id;
      saveInvoiceData(invData);
      */ loadBudgetSpending(categoriesData[0]._id);
                        }
                        _ctx.next = 15;
                        break;
                    case 10:
                        invoice = rekeningData === null || rekeningData === void 0 ? void 0 : rekeningData[id];
                        invoiceId = invoice === null || invoice === void 0 ? void 0 : invoice._id;
                        if (!invoiceId) {
                            _ctx.next = 15;
                            break;
                        }
                        openInvoiceById(invoiceId);
                        return _ctx.abrupt("return");
                    case 15:
                        invoiceOnOpen();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function openInvoice(id) {
            return _ref.apply(this, arguments);
        };
    }();
    // Don't render main content until session is available
    // But we can't return early here because it would skip hooks below
    // Instead, we'll check session availability in the render section
    var searchForValues = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(key, value) {
            var searchValuesTemp, searchTextIndex;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        searchValuesTemp = searchValues, searchTextIndex = searchValuesTemp.findIndex(function(e) {
                            return e.key == key;
                        });
                        if (searchTextIndex == -1) {
                            searchValuesTemp.push({
                                key: key,
                                value: value
                            });
                        } else {
                            searchValuesTemp[searchTextIndex] = {
                                key: key,
                                value: value
                            };
                        }
                        setSearchValues(searchValuesTemp);
                        loadInvoices();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function searchForValues(key, value) {
            return _ref.apply(this, arguments);
        };
    }();
    // New filter functions
    var updateActiveFilters = function() {
        var filters = [];
        if (dateFilter) {
            filters.push({
                key: "date",
                label: "Transaktionsdatum",
                value: dateFilter,
                remove: function() {
                    return setDateFilter(null);
                }
            });
        }
        if (receiptFilter) {
            filters.push({
                key: "receipt",
                label: "Beleg",
                value: receiptFilter,
                remove: function() {
                    return setReceiptFilter(null);
                }
            });
        }
        if (statusFilter) {
            // Find the readable status name
            var statusName = statusFilter;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = invoiceTypesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var invoiceType = _step.value;
                    var statusStep = invoiceType.steps.find(function(step) {
                        return step._id === statusFilter;
                    });
                    if (statusStep) {
                        statusName = "".concat(invoiceType.title, " - ").concat(statusStep.title);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            filters.push({
                key: "status",
                label: "Status",
                value: statusName,
                remove: function() {
                    return setStatusFilter(null);
                }
            });
        }
        if (categoryFilter) {
            // Find the readable category name
            var category = categoriesData.find(function(cat) {
                return cat._id === categoryFilter;
            });
            filters.push({
                key: "category",
                label: "Kategorie",
                value: category ? category.title : categoryFilter,
                remove: function() {
                    return setCategoryFilter(null);
                }
            });
        }
        if (userFilter) {
            // Find the readable user name
            var user = userData.find(function(usr) {
                return usr._id === userFilter;
            });
            filters.push({
                key: "user",
                label: "Benutzer",
                value: user ? user.username : userFilter,
                remove: function() {
                    return setUserFilter(null);
                }
            });
        }
        if (invoiceTypeFilter) {
            // Find the readable invoice type name
            var invoiceType1 = invoiceTypesData.find(function(type) {
                return type._id === invoiceTypeFilter;
            });
            filters.push({
                key: "invoiceType",
                label: "Rechnungstyp",
                value: invoiceType1 ? invoiceType1.title : invoiceTypeFilter,
                remove: function() {
                    return setInvoiceTypeFilter(null);
                }
            });
        }
        if (invoiceKindFilter) {
            // Map invoice kind to readable name
            var kindName = invoiceKindFilter === "invoice" ? "Rechnung" : invoiceKindFilter === "travel-expense" ? "Reisekosten" : invoiceKindFilter;
            filters.push({
                key: "invoiceKind",
                label: "Art",
                value: kindName,
                remove: function() {
                    return setInvoiceKindFilter(null);
                }
            });
        }
        if (transactionTypeFilter) {
            // Map transaction type to readable name
            var typeName = transactionTypeFilter === "incoming" ? "Eingehend" : transactionTypeFilter === "outgoing" ? "Ausgehend" : transactionTypeFilter === "bank_statement" ? "Kontoauszug" : transactionTypeFilter === "credit_card_statement" ? "Kreditkartenabrechnung" : transactionTypeFilter === "other" ? "Sonstige" : transactionTypeFilter;
            filters.push({
                key: "transactionType",
                label: "Transaktionstyp",
                value: typeName,
                remove: function() {
                    return setTransactionTypeFilter(null);
                }
            });
        }
        if (transactionLinkedFilter) {
            filters.push({
                key: "transactionLinked",
                label: "Transaktion",
                value: transactionLinkedFilter === "linked" ? "Verkn\xfcpft" : "Nicht verkn\xfcpft",
                remove: function() {
                    return setTransactionLinkedFilter(null);
                }
            });
        }
        // Add advanced filters from searchValues
        searchValues.forEach(function(searchItem) {
            var ref;
            if (searchItem.key === "dateFilter") {
                // Map date filter values to readable names
                var dateName = searchItem.value;
                switch(searchItem.value){
                    case "thisWeek":
                        dateName = "Diese Woche";
                        break;
                    case "thisMonth":
                        dateName = "Diesen Monat";
                        break;
                    case "last3Months":
                        dateName = "Letzte 3 Monate";
                        break;
                    case "thisYear":
                        dateName = "Dieses Jahr";
                        break;
                    case "lastWeek":
                        dateName = "Letzte Woche";
                        break;
                    case "lastMonth":
                        dateName = "Letzter Monat";
                        break;
                    case "lastYear":
                        dateName = "Vergangenes Jahr";
                        break;
                }
                filters.push({
                    key: "advancedDate",
                    label: "Transaktionsdatum",
                    value: dateName,
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "dateFilter";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            } else if (searchItem.key === "amountFrom" || searchItem.key === "amountTo") {
                var existingFilter = filters.find(function(f) {
                    return f.key === "amount";
                });
                if (!existingFilter) {
                    var ref1, ref2;
                    var fromValue = ((ref1 = searchValues.find(function(s) {
                        return s.key === "amountFrom";
                    })) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
                    var toValue = ((ref2 = searchValues.find(function(s) {
                        return s.key === "amountTo";
                    })) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
                    var amountText = fromValue && toValue ? "".concat(fromValue, "€ - ").concat(toValue, "€") : fromValue ? "Ab ".concat(fromValue, "€") : toValue ? "Bis ".concat(toValue, "€") : "";
                    filters.push({
                        key: "amount",
                        label: "Betrag",
                        value: amountText,
                        remove: function() {
                            var newSearchValues = searchValues.filter(function(item) {
                                return item.key !== "amountFrom" && item.key !== "amountTo";
                            });
                            setSearchValues(newSearchValues);
                            loadInvoices(1);
                        }
                    });
                }
            } else if (searchItem.key === "searchUser" && searchItem.value !== (session === null || session === void 0 ? void 0 : (ref = session.user_data) === null || ref === void 0 ? void 0 : ref._id)) {
                // Find the readable user name
                var userIds = searchItem.value.split(",");
                var userNames = userIds.map(function(id) {
                    var user = userData.find(function(usr) {
                        return usr._id === id;
                    });
                    return user ? user.username : id;
                });
                filters.push({
                    key: "advancedUser",
                    label: "Benutzer",
                    value: userNames.join(", "),
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "searchUser";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            } else if (searchItem.key === "searchCreditor") {
                // Find the readable creditor name
                var creditorIds = searchItem.value.split(",");
                var creditorNames = creditorIds.map(function(id) {
                    var creditor = creditorsData.find(function(c) {
                        return c._id === id;
                    });
                    return creditor ? creditor.name : id;
                });
                filters.push({
                    key: "advancedCreditor",
                    label: "Karte",
                    value: creditorNames.join(", "),
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "searchCreditor";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            } else if (searchItem.key === "searchCategory") {
                // Find the readable category name
                var categoryIds = searchItem.value.split(",");
                var categoryNames = categoryIds.map(function(id) {
                    var category = categoriesData.find(function(c) {
                        return c._id === id;
                    });
                    return category ? category.title : id;
                });
                filters.push({
                    key: "advancedCategory",
                    label: "Kategorie",
                    value: categoryNames.join(", "),
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "searchCategory";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            } else if (searchItem.key === "searchInvoiceType") {
                // Find the readable invoice type name
                var typeIds = searchItem.value.split(",");
                var typeNames = typeIds.map(function(id) {
                    var type = invoiceTypesData.find(function(t) {
                        return t._id === id;
                    });
                    return type ? type.title : id;
                });
                filters.push({
                    key: "advancedInvoiceType",
                    label: "Rechnungstyp",
                    value: typeNames.join(", "),
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "searchInvoiceType";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            } else if (searchItem.key === "searchInvoiceKind") {
                // Map invoice kind to readable name
                var kinds = searchItem.value.split(",");
                var kindNames = kinds.map(function(kind) {
                    return kind === "invoice" ? "Rechnung" : kind === "travel-expense" ? "Reisekosten" : kind;
                });
                filters.push({
                    key: "advancedInvoiceKind",
                    label: "Rechnungsart",
                    value: kindNames.join(", "),
                    remove: function() {
                        var newSearchValues = searchValues.filter(function(item) {
                            return item.key !== "searchInvoiceKind";
                        });
                        setSearchValues(newSearchValues);
                        loadInvoices(1);
                    }
                });
            }
        });
        setActiveFilters(filters);
    };
    var applyFilters = function() {
        var ref;
        // Only apply basic filters if no advanced filters are active
        if (searchValues.length > 0 && searchValues.some(function(item) {
            return item.key === "dateFilter" || item.key === "amountFrom" || item.key === "amountTo" || item.key === "transactionType" || item.key === "searchCreditor";
        })) {
            // Advanced filters are active, don't override them
            return;
        }
        var searchString = "";
        // Add search text
        if (searchText) {
            searchString += "&searchText=" + encodeURIComponent(searchText);
        }
        // Add view filter
        if (filterView === "meine") {
            var ref1;
            searchString += "&searchUser=" + ((session === null || session === void 0 ? void 0 : (ref1 = session.user_data) === null || ref1 === void 0 ? void 0 : ref1._id) || "");
        }
        // Add other filters
        if (dateFilter) {
            searchString += "&dateFilter=" + encodeURIComponent(dateFilter);
        }
        if (receiptFilter) {
            searchString += "&receiptFilter=" + encodeURIComponent(receiptFilter);
        }
        if (statusFilter) {
            searchString += "&searchInvoiceStatus=" + encodeURIComponent(statusFilter);
        }
        if (categoryFilter) {
            searchString += "&searchCategory=" + encodeURIComponent(categoryFilter);
        }
        if (userFilter) {
            searchString += "&searchUser=" + encodeURIComponent(userFilter);
        }
        if (invoiceTypeFilter) {
            searchString += "&searchInvoiceType=" + encodeURIComponent(invoiceTypeFilter);
        }
        if (invoiceKindFilter) {
            searchString += "&searchInvoiceKind=" + encodeURIComponent(invoiceKindFilter);
        }
        if (transactionTypeFilter) {
            searchString += "&searchTransactionType=" + encodeURIComponent(transactionTypeFilter);
        }
        if (transactionLinkedFilter) {
            searchString += "&transactionLinked=" + encodeURIComponent(transactionLinkedFilter);
        }
        // Update searchValues for compatibility
        var newSearchValues = [];
        if (searchText) newSearchValues.push({
            key: "searchText",
            value: searchText
        });
        if (filterView === "meine" && (session === null || session === void 0 ? void 0 : (ref = session.user_data) === null || ref === void 0 ? void 0 : ref._id)) newSearchValues.push({
            key: "searchUser",
            value: session.user_data._id
        });
        if (statusFilter) newSearchValues.push({
            key: "searchInvoiceStatus",
            value: statusFilter
        });
        if (categoryFilter) newSearchValues.push({
            key: "searchCategory",
            value: categoryFilter
        });
        if (userFilter) newSearchValues.push({
            key: "searchUser",
            value: userFilter
        });
        if (invoiceTypeFilter) newSearchValues.push({
            key: "searchInvoiceType",
            value: invoiceTypeFilter
        });
        if (invoiceKindFilter) newSearchValues.push({
            key: "searchInvoiceKind",
            value: invoiceKindFilter
        });
        if (transactionTypeFilter) newSearchValues.push({
            key: "searchTransactionType",
            value: transactionTypeFilter
        });
        if (transactionLinkedFilter) newSearchValues.push({
            key: "transactionLinked",
            value: transactionLinkedFilter
        });
        setSearchValues(newSearchValues);
        loadInvoicesWithSearchValues(newSearchValues, 1);
    };
    // Update active filters whenever any filter changes
    react.useEffect(function() {
        updateActiveFilters();
    }, [
        dateFilter,
        receiptFilter,
        statusFilter,
        categoryFilter,
        userFilter,
        invoiceTypeFilter,
        invoiceKindFilter,
        transactionTypeFilter,
        transactionLinkedFilter,
        searchValues
    ]);
    // Apply filters when they change
    react.useEffect(function() {
        applyFilters();
    }, [
        filterView,
        searchText,
        dateFilter,
        receiptFilter,
        statusFilter,
        categoryFilter,
        userFilter,
        invoiceTypeFilter,
        invoiceKindFilter,
        transactionTypeFilter,
        transactionLinkedFilter
    ]);
    var downloadSelected = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        exportExcel(selectedInvoicesIds);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function downloadSelected() {
            return _ref.apply(this, arguments);
        };
    }();
    // Advanced filter functions
    var openAdvancedFilter = function() {
        onAdvancedFilterOpen();
    };
    var applyAdvancedFilters = function() {
        console.log("Applying advanced filters:", advancedFilters);
        // Reset basic filters
        setDateFilter(null);
        setReceiptFilter(null);
        setStatusFilter(null);
        setCategoryFilter(null);
        setUserFilter(null);
        setInvoiceTypeFilter(null);
        setInvoiceKindFilter(null);
        setTransactionLinkedFilter(null);
        // Apply advanced filters
        var newSearchValues = [];
        if (advancedFilters.dateRange) {
            // Handle date range filter - map to API parameters
            switch(advancedFilters.dateRange){
                case "Diese Woche":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "thisWeek"
                    });
                    break;
                case "Diesen Monat":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "thisMonth"
                    });
                    break;
                case "Letzte 3 Monate":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "last3Months"
                    });
                    break;
                case "Dieses Jahr":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "thisYear"
                    });
                    break;
                case "Letzte Woche":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "lastWeek"
                    });
                    break;
                case "Letzter Monat":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "lastMonth"
                    });
                    break;
                case "Vergangenes Jahr":
                    newSearchValues.push({
                        key: "dateFilter",
                        value: "lastYear"
                    });
                    break;
                default:
                    break;
            }
        }
        if (advancedFilters.amountFrom || advancedFilters.amountTo) {
            // Handle amount range filter
            if (advancedFilters.amountFrom) {
                newSearchValues.push({
                    key: "amountFrom",
                    value: advancedFilters.amountFrom
                });
            }
            if (advancedFilters.amountTo) {
                newSearchValues.push({
                    key: "amountTo",
                    value: advancedFilters.amountTo
                });
            }
        }
        if (advancedFilters.transactionType) {
            newSearchValues.push({
                key: "transactionType",
                value: advancedFilters.transactionType
            });
        }
        if (advancedFilters.users.length > 0) {
            // If only one user, use single ID, otherwise join with comma
            if (advancedFilters.users.length === 1) {
                newSearchValues.push({
                    key: "searchUser",
                    value: advancedFilters.users[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchUser",
                    value: advancedFilters.users.join(",")
                });
            }
        }
        if (advancedFilters.creditors.length > 0) {
            // If only one creditor, use single ID, otherwise join with comma
            if (advancedFilters.creditors.length === 1) {
                newSearchValues.push({
                    key: "searchCreditor",
                    value: advancedFilters.creditors[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchCreditor",
                    value: advancedFilters.creditors.join(",")
                });
            }
        }
        if (advancedFilters.categories.length > 0) {
            // If only one category, use single ID, otherwise join with comma
            if (advancedFilters.categories.length === 1) {
                newSearchValues.push({
                    key: "searchCategory",
                    value: advancedFilters.categories[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchCategory",
                    value: advancedFilters.categories.join(",")
                });
            }
        }
        if (advancedFilters.invoiceTypes.length > 0) {
            // If only one invoice type, use single ID, otherwise join with comma
            if (advancedFilters.invoiceTypes.length === 1) {
                newSearchValues.push({
                    key: "searchInvoiceType",
                    value: advancedFilters.invoiceTypes[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchInvoiceType",
                    value: advancedFilters.invoiceTypes.join(",")
                });
            }
        }
        if (advancedFilters.invoiceStatuses.length > 0) {
            // If only one status, use single ID, otherwise join with comma
            if (advancedFilters.invoiceStatuses.length === 1) {
                newSearchValues.push({
                    key: "searchInvoiceStatus",
                    value: advancedFilters.invoiceStatuses[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchInvoiceStatus",
                    value: advancedFilters.invoiceStatuses.join(",")
                });
            }
        }
        if (advancedFilters.invoiceKinds.length > 0) {
            // If only one kind, use single value, otherwise join with comma
            if (advancedFilters.invoiceKinds.length === 1) {
                newSearchValues.push({
                    key: "searchInvoiceKind",
                    value: advancedFilters.invoiceKinds[0]
                });
            } else {
                newSearchValues.push({
                    key: "searchInvoiceKind",
                    value: advancedFilters.invoiceKinds.join(",")
                });
            }
        }
        console.log("New search values:", newSearchValues);
        // Update searchValues and trigger invoice loading
        setSearchValues(newSearchValues);
        onAdvancedFilterClose();
        // Clear current data and reload with new filters
        setRekeningData([]);
        // Call loadInvoices directly with the new search values to avoid timing issues
        loadInvoicesWithSearchValues(newSearchValues, 1);
    };
    // Helper function to load invoices with specific search values
    var loadInvoicesWithSearchValues = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(searchValuesToUse) {
            var pageNumber, rekeningDataOld, searchString, fetchData, data, rekeningDataTempResponse, invoiceDataCombined, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pageNumber = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 1;
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        rekeningDataOld = rekeningData;
                        if (pageNumber == 1) {
                            rekeningDataOld = [];
                        }
                        searchString = "";
                        searchValuesToUse.map(function(singleSearchElement) {
                            if (singleSearchElement.value != "") {
                                searchString += "&" + singleSearchElement.key + "=" + encodeURIComponent(singleSearchElement.value);
                            }
                        });
                        console.log("Loading invoices with searchValues:", searchValuesToUse);
                        console.log("Search string:", searchString);
                        console.log("Full URL:", "".concat(api_url, "/invoices?page=").concat(pageNumber, "&pageSize=25").concat(searchString));
                        setMoreInvoicesAvailable(false);
                        _ctx.prev = 11;
                        fetchData = axios_default().get("".concat(api_url, "/invoices?page=").concat(pageNumber, "&pageSize=25").concat(searchString), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                        _ctx.next = 15;
                        return fetchData;
                    case 15:
                        data = _ctx.sent;
                        console.log("API response:", data.data);
                        if (!(data.status != 403 && data.status != 500)) {
                            _ctx.next = 31;
                            break;
                        }
                        rekeningDataTempResponse = data.data;
                        _ctx.next = 21;
                        return rekeningDataTempResponse.map(function(singleInvoice, i) {
                            if (singleInvoice.taxPositions == undefined || singleInvoice.taxPositions.length == 0) {
                                var tempNewTax = {
                                    value: singleInvoice.total,
                                    taxRate: singleInvoice.mwst,
                                    valueNet: singleInvoice.totalNet || "",
                                    valueTax: ""
                                };
                                rekeningDataTempResponse[i].taxPositions = [];
                                rekeningDataTempResponse[i].taxPositions.push(tempNewTax);
                            }
                        });
                    case 21:
                        if (rekeningDataTempResponse.length == 25) {
                            setMoreInvoicesAvailable(true);
                        }
                        invoiceDataCombined = rekeningDataTempResponse.concat(rekeningDataOld);
                        setRekeningData(invoiceDataCombined);
                        calculateMonthlyCost(invoiceDataCombined);
                        setRekeningDataOriginal(invoiceDataCombined);
                        setIsLoading(false);
                        // Check if there are invoices in queue and show overlay if needed
                        checkQueueAndShowOverlay();
                        return _ctx.abrupt("return", invoiceDataCombined);
                    case 31:
                        {
                            setLoginRequired(false);
                            setIsLoading(false);
                        }
                    case 32:
                        _ctx.next = 39;
                        break;
                    case 34:
                        _ctx.prev = 34;
                        _ctx.t0 = _ctx["catch"](11);
                        console.error("Error loading invoices:", _ctx.t0);
                        setLoginRequired(false);
                        setIsLoading(false);
                    case 39:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    34
                ]
            ]);
        }));
        return function loadInvoicesWithSearchValues(searchValuesToUse) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearAllFilters = function() {
        // Reset advanced filters
        setAdvancedFilters({
            dateRange: null,
            amountFrom: "",
            amountTo: "",
            transactionType: null,
            users: [],
            creditors: [],
            categories: [],
            invoiceTypes: [],
            invoiceStatuses: [],
            invoiceKinds: []
        });
        // Reset basic filters
        setDateFilter(null);
        setReceiptFilter(null);
        setStatusFilter(null);
        setCategoryFilter(null);
        setUserFilter(null);
        setInvoiceTypeFilter(null);
        setInvoiceKindFilter(null);
        setTransactionLinkedFilter(null);
        setSearchText("");
        // Clear searchValues and reload
        setSearchValues([]);
        setRekeningData([]);
        loadInvoicesWithSearchValues([], 1);
    };
    var saveAsDefault = function() {
        // TODO: Implement save as default functionality
        userNotification("Filter gespeichert", "Die Filter wurden als Standard gespeichert", "success");
    };
    // Test function to verify filters work
    var testFilter = function() {
        var ref;
        console.log("Testing filter...");
        var testSearchValues = [
            {
                key: "searchText",
                value: "test"
            },
            {
                key: "searchCategory",
                value: ((ref = categoriesData[0]) === null || ref === void 0 ? void 0 : ref._id) || ""
            }
        ];
        console.log("Test search values:", testSearchValues);
        setSearchValues(testSearchValues);
        setRekeningData([]);
        loadInvoicesWithSearchValues(testSearchValues, 1);
    };
    var exportExcel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(dataToExport) {
            var data, tempDateXls, fileName, exportType, imageArray;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = [];
                        onDownloadOpen();
                        tempDateXls = new Date();
                        fileName = tempDateXls.getFullYear() + "-" + tempDateXls.getMonth() + "-" + tempDateXls.getDay() + "-rekening-export";
                        exportType = "csv";
                        imageArray = [];
                        dataToExport.map(function(item) {
                            var ref;
                            var newItem = {};
                            newItem["Shop"] = item.shop;
                            newItem["Total"] = item.total.replace(".", ",");
                            newItem["TotalNet"] = item.totalNet.replace(".", ",");
                            newItem["Tax"] = item.tax.replace(".", ",");
                            newItem["TaxRate"] = item.mwst;
                            if (item.currency != undefined) {
                                newItem["Currency"] = item.currency;
                            } else {
                                newItem["Currency"] = "EUR";
                            }
                            newItem["Date"] = new Date(item.date).toLocaleDateString("de-DE");
                            newItem["Status"] = item.status;
                            if (item.authorData.length != 0) {
                                newItem["Person"] = item.authorData[0].username;
                            } else {
                                newItem["Person"] = "Removed User";
                            }
                            var attachmentUrl = ((ref = item) === null || ref === void 0 ? void 0 : ref.scanAttachedSignedUrl) || item.scanAttached;
                            if (attachmentUrl != "") {
                                var imageObject = {};
                                imageObject["url"] = attachmentUrl;
                                var tempDate = new Date(item.date);
                                var tempDateString = tempDate.getFullYear() + "-" + (tempDate.getMonth() + 1) + "-" + tempDate.getDay();
                                imageObject["filename"] = tempDateString + "-" + item.shop.replace(" ", "_").toLowerCase() + "-" + item.total.replace(".", ",") + "-" + item.authorData[0].username.replace(" ", "_") + "-rekening";
                                imageArray.push(imageObject);
                                newItem["Filename"] = imageObject["filename"];
                            }
                            data.push(newItem);
                        });
                        _ctx.next = 9;
                        return handleDownload(imageArray);
                    case 9:
                        (0,esm/* default */.Z)({
                            data: data,
                            fileName: fileName,
                            exportType: exportType
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function exportExcel(dataToExport) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownload = function(images) {
        var zip = new (jszip_min_default())();
        var imgFolder = zip.folder("images");
        var promises = [];
        var ext = "";
        images.map(function(image, i) {
            return promises.push(fetch(image["url"], function() {
                // Signed URLs should be fetched WITHOUT Authorization header (avoids CORS preflight / blocked requests).
                // Only attach Authorization when fetching from our API or a relative URL.
                try {
                    var u = new URL(image["url"]);
                    if (u.hostname === "api.rekening.de") {
                        return {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        };
                    }
                    return {
                        method: "GET"
                    };
                } catch (e) {
                    // relative URL
                    return {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(session.accessToken)
                        }
                    };
                }
            }()).then(function(response) {
                var extArray = image["url"].split(".");
                ext = extArray.pop();
                var data = response.blob();
                return imgFolder.file("".concat(image["filename"], ".").concat(ext), data);
            }));
        });
        Promise.all(promises).then(function() {
            return zip.generateAsync({
                type: "blob"
            }).then(function(content) {
                // see FileSaver.js
                var tempDateXls = new Date();
                var tempDateStringXls = tempDateXls.getFullYear() + "-" + (tempDateXls.getMonth() + 1) + "-" + tempDateXls.getDay() + "-rekening-export";
                (0,FileSaver_min.saveAs)(content, tempDateStringXls + ".zip");
                onDownloadClose();
                userNotification("Download Successfull", "Invoices successfully downloaded", "success");
            });
        });
    };
    //BULK UPLOAD CHANGE SETTINGS
    var onChangeSettingsBulkUpload = function(key, val) {
        var bulkUploadSettingsTmp = bulkUploadSettings;
        bulkUploadSettingsTmp[key] = val;
        //SAVE
        setBulkUploadSettings((0,_object_spread/* default */.Z)({}, bulkUploadSettingsTmp));
    };
    var createNewInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var bulkUpload, body, fetchData, fetchDataJson, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        bulkUpload = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        body = data;
                        if (!(data == undefined)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        delete body.authorData;
                        _ctx.next = 7;
                        return fetch("".concat(api_url, "/invoices"), {
                            credentials: "include",
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        });
                    case 7:
                        fetchData = _ctx.sent;
                        _ctx.next = 10;
                        return fetchData.json();
                    case 10:
                        fetchDataJson = _ctx.sent;
                        if (!("statusCode" in fetchDataJson)) {
                            _ctx.next = 15;
                            break;
                        }
                        {
                            userNotification("Creation Error", fetchDataJson["message"][0], "error");
                        }
                        _ctx.next = 21;
                        break;
                    case 15:
                        userNotification("New Invoice Created", "Your new invoice has been successfully created", "success");
                        _ctx.next = 18;
                        return setRekeningData([]);
                    case 18:
                        _ctx.next = 20;
                        return loadInvoices();
                    case 20:
                        if (!bulkUpload && "statusCode" in fetchDataJson == false) {
                            setChangedInvoices([
                                fetchDataJson._id
                            ]);
                            setTimeout(function() {
                                modules/* scroller.scrollTo */.OK.scrollTo(fetchDataJson._id, {
                                    duration: 500,
                                    delay: 0,
                                    smooth: true,
                                    offset: -100
                                });
                            }, 200);
                        }
                    case 21:
                        return _ctx.abrupt("return", fetchDataJson);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createNewInvoice(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var extractFilesFromDataTransfer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(dataTransfer) {
            var fileList, items, entries, collectedFiles, readFile, readDir, traverse, seen, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f, key;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (dataTransfer) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", []);
                    case 2:
                        fileList = Array.from(dataTransfer.files || []);
                        items = dataTransfer.items ? Array.from(dataTransfer.items) : [];
                        entries = items.filter(function(item) {
                            return item.kind === "file";
                        }).map(function(item) {
                            return item.webkitGetAsEntry ? item.webkitGetAsEntry() : null;
                        }).filter(function(entry) {
                            return entry !== null;
                        });
                        collectedFiles = [];
                        readFile = function(entry) {
                            return new Promise(function(resolve) {
                                try {
                                    entry.file(resolve, function() {
                                        return resolve(null);
                                    });
                                } catch (e) {
                                    resolve(null);
                                }
                            });
                        };
                        readDir = function(reader) {
                            return new Promise(function(resolve) {
                                try {
                                    reader.readEntries(function(results) {
                                        return resolve(Array.from(results || []));
                                    }, function() {
                                        return resolve([]);
                                    });
                                } catch (e) {
                                    resolve([]);
                                }
                            });
                        };
                        traverse = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(entry) {
                                var file, reader, batch;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!entry.isFile) {
                                                _ctx.next = 7;
                                                break;
                                            }
                                            _ctx.next = 3;
                                            return readFile(entry);
                                        case 3:
                                            file = _ctx.sent;
                                            if (file) collectedFiles.push(file);
                                            _ctx.next = 17;
                                            break;
                                        case 7:
                                            if (!entry.isDirectory) {
                                                _ctx.next = 17;
                                                break;
                                            }
                                            reader = entry.createReader();
                                            ;
                                        case 10:
                                            _ctx.next = 12;
                                            return readDir(reader);
                                        case 12:
                                            batch = _ctx.sent;
                                            if (!(batch.length > 0)) {
                                                _ctx.next = 16;
                                                break;
                                            }
                                            _ctx.next = 16;
                                            return Promise.all(batch.map(traverse));
                                        case 16:
                                            if (batch.length > 0) {
                                                _ctx.next = 10;
                                                break;
                                            }
                                        case 17:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function traverse(entry) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!(entries.length > 0)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 12;
                        return Promise.all(entries.map(traverse));
                    case 12:
                        if (!(collectedFiles.length === 0 && fileList.length > 0)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", fileList);
                    case 14:
                        seen = new Set(collectedFiles.map(function(f) {
                            return "".concat(f.name, ":").concat(f.size, ":").concat(f.lastModified);
                        }));
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 16;
                        for(_iterator = fileList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            f = _step.value;
                            key = "".concat(f.name, ":").concat(f.size, ":").concat(f.lastModified);
                            if (!seen.has(key)) {
                                collectedFiles.push(f);
                                seen.add(key);
                            }
                        }
                        _ctx.next = 24;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](16);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 24:
                        _ctx.prev = 24;
                        _ctx.prev = 25;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 27:
                        _ctx.prev = 27;
                        if (!_didIteratorError) {
                            _ctx.next = 30;
                            break;
                        }
                        throw _iteratorError;
                    case 30:
                        return _ctx.finish(27);
                    case 31:
                        return _ctx.finish(24);
                    case 32:
                        return _ctx.abrupt("return", collectedFiles);
                    case 33:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    16,
                    20,
                    24,
                    32
                ],
                [
                    25,
                    ,
                    27,
                    31
                ]
            ]);
        }));
        return function extractFilesFromDataTransfer(dataTransfer) {
            return _ref.apply(this, arguments);
        };
    }();
    var prepareBulkUploadFromFiles = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(files) {
            var inputFiles, expanded, allowedFiles, rejectedCount, defaultInvoiceType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        inputFiles = Array.from(files || []).filter(Boolean);
                        _ctx.next = 3;
                        return (0,expandUploadFiles/* expandUploadFiles */.iv)(inputFiles, "invoice");
                    case 3:
                        expanded = _ctx.sent;
                        allowedFiles = expanded.files.filter(expandUploadFiles/* isAllowedInvoiceUploadFile */.rY);
                        rejectedCount = expanded.files.length - allowedFiles.length + expanded.skippedCount;
                        if (!(allowedFiles.length === 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        userNotification(t("index.uploadError") || "Upload-Fehler", t("index.uploadOnlyPdfImages") || "Bitte nur Ordner, ZIP-Dateien, PDFs oder Bilder hochladen.", "error");
                        return _ctx.abrupt("return");
                    case 9:
                        defaultInvoiceType = invoiceTypesData.length === 1 ? invoiceTypesData[0]._id : "";
                        onOpenBulkUploadPrep();
                        setBulkUploadSettings({
                            invoiceType: defaultInvoiceType,
                            category: ""
                        });
                        setBulkUploadCounterTotal(allowedFiles.length);
                        setBulkUploadData(allowedFiles);
                        if (rejectedCount > 0) {
                            userNotification(t("index.uploadSkippedFilesTitle") || "Dateien \xfcbersprungen", t("index.uploadSkippedFilesDetails", {
                                count: rejectedCount
                            }) || "".concat(rejectedCount, " Datei(en) wurden \xfcbersprungen (nur PDF/Bilder sind erlaubt; ZIPs werden sicher entpackt)."), "warning");
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function prepareBulkUploadFromFiles(files) {
            return _ref.apply(this, arguments);
        };
    }();
    var bulkUploadPrep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ev) {
            var extracted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ev.preventDefault();
                        _ctx.next = 3;
                        return extractFilesFromDataTransfer(ev.dataTransfer);
                    case 3:
                        extracted = _ctx.sent;
                        _ctx.next = 6;
                        return prepareBulkUploadFromFiles(extracted);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function bulkUploadPrep(ev) {
            return _ref.apply(this, arguments);
        };
    }();
    // Handle file input for bulk upload
    var handleFileInputChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var files;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        files = Array.from(e.target.files || []);
                        if (!(files.length > 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return prepareBulkUploadFromFiles(files);
                    case 4:
                        // Reset input value so same file can be selected again
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFileInputChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFolderInputChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var files;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        files = Array.from(e.target.files || []);
                        if (!(files.length > 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return prepareBulkUploadFromFiles(files);
                    case 4:
                        if (folderInputRef.current) {
                            folderInputRef.current.value = "";
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFolderInputChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // Open file input dialog
    var openFileInput = function() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    var openFolderInput = function() {
        if (folderInputRef.current) {
            folderInputRef.current.click();
        }
    };
    var bulkUpload = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var uploadedQueueIds, i, file, formData, response, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        onCloseBulkUploadPrep();
                        // Reset counters and open upload modal
                        setUploadedFileCount(0);
                        setTotalFilesToUpload(bulkUploadData.length);
                        setBulkUploadCounterFinished(0);
                        setBulkUploadCounterTotal(bulkUploadData.length);
                        setQueueEntryIds([]);
                        onOpenBulkUpload();
                        uploadedQueueIds = [];
                        i = 0;
                    case 9:
                        if (!(i < bulkUploadData.length)) {
                            _ctx.next = 30;
                            break;
                        }
                        file = bulkUploadData[i];
                        _ctx.prev = 11;
                        formData = new FormData();
                        formData.append("file", file);
                        _ctx.next = 16;
                        return fetch((0,url/* withInvoiceQueueConsumerTarget */.r)("".concat(api_url, "/invoices/upload-async")), {
                            method: "POST",
                            headers: {
                                "Authorization": "Bearer ".concat(session.accessToken)
                            },
                            body: formData
                        });
                    case 16:
                        response = _ctx.sent;
                        _ctx.next = 19;
                        return response.json();
                    case 19:
                        result = _ctx.sent;
                        if (response.ok && result._id) {
                            uploadedQueueIds.push(result._id);
                            setUploadedFileCount(i + 1);
                            setBulkUploadCounterFinished(i + 1);
                        } else {
                            userNotification(t("index.uploadError"), t("index.uploadErrorDetails", {
                                filename: file.name
                            }), "error");
                        }
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](11);
                        console.error("Upload error:", _ctx.t0);
                        userNotification(t("index.uploadError"), t("index.uploadErrorDetails", {
                            filename: file.name
                        }), "error");
                    case 27:
                        i++;
                        _ctx.next = 9;
                        break;
                    case 30:
                        // Store queue IDs and close upload modal
                        setQueueEntryIds(uploadedQueueIds);
                        setInvoiceQueueCounts({
                            active: uploadedQueueIds.length,
                            total: uploadedQueueIds.length
                        });
                        // Close upload modal after a short delay
                        setTimeout(function() {
                            onCloseBulkUpload();
                            // Show queue overlay if there are uploaded files
                            if (uploadedQueueIds.length > 0) {
                                setIsQueueOverlayVisible(true);
                            }
                            // Reset bulk upload data
                            setBulkUploadData([]);
                        }, 500);
                    case 33:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    23
                ]
            ]);
        }));
        return function bulkUpload() {
            return _ref.apply(this, arguments);
        };
    }();
    var getInvoiceQueueCounts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, entries, total, activeCount, _total;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (session === null || session === void 0 ? void 0 : session.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            active: 0,
                            total: 0
                        });
                    case 2:
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return axios_default().get("".concat(api_url, "/invoices/queue?pageSize=100&page=1"), {
                            headers: {
                                Authorization: "Bearer ".concat(session.accessToken)
                            }
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        entries = [];
                        total = 0;
                        activeCount = 0;
                        if (Array.isArray(response.data)) {
                            entries = response.data;
                            total = entries.length;
                        } else if (response.data.entries && Array.isArray(response.data.entries)) {
                            entries = response.data.entries;
                            total = response.data.total || entries.length;
                        }
                        if (response.data.counts) {
                            ;
                            total = Number((_total = response.data.counts.total) !== null && _total !== void 0 ? _total : total);
                            activeCount = Number(response.data.counts.pending || 0) + Number(response.data.counts.processing || 0);
                        } else {
                            // Check if there are any pending or processing entries
                            activeCount = entries.filter(function(entry) {
                                return entry.status === "pending" || entry.status === "processing";
                            }).length;
                        }
                        return _ctx.abrupt("return", {
                            active: activeCount,
                            total: total
                        });
                    case 13:
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error("Error checking queue:", _ctx.t0);
                    case 18:
                        return _ctx.abrupt("return", {
                            active: 0,
                            total: 0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        }));
        return function getInvoiceQueueCounts() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkQueueAndShowOverlay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var counts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getInvoiceQueueCounts();
                    case 2:
                        counts = _ctx.sent;
                        setInvoiceQueueCounts(counts);
                        // If there are active queue entries, show the overlay
                        if (counts.active > 0 || counts.total > 0) {
                            setIsQueueOverlayVisible(true);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkQueueAndShowOverlay() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        if (!(session === null || session === void 0 ? void 0 : session.accessToken) || invoiceQueueCounts.active <= 0) return;
        var isActive = true;
        var intervalId = setInterval((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var counts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getInvoiceQueueCounts();
                    case 2:
                        counts = _ctx.sent;
                        if (isActive) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        setInvoiceQueueCounts(counts);
                        if (counts.active === 0) {
                            loadInvoices();
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 2000);
        return function() {
            isActive = false;
            clearInterval(intervalId);
        };
    }, [
        session === null || session === void 0 ? void 0 : session.accessToken,
        invoiceQueueCounts.active
    ]);
    var renderInvoiceQueueStatus = function() {
        if (invoiceQueueCounts.active <= 0) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            maxW: "640px",
            mx: "auto",
            mt: 4,
            mb: 8,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dist_index_esm/* Alert */.bZ, {
                status: "info",
                variant: "subtle",
                borderRadius: "lg",
                borderWidth: "1px",
                borderColor: "orange.200",
                bg: "orange.50",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                        size: "sm",
                        color: "orange.500",
                        thickness: "2px",
                        mr: 3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        flex: "1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontWeight: "semibold",
                                color: "gray.800",
                                children: t("index.invoiceQueueStatusTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "sm",
                                color: "gray.600",
                                children: t("index.invoiceQueueStatusDescription", {
                                    count: invoiceQueueCounts.active
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/queue",
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                            fontWeight: "semibold",
                            color: "orange.600",
                            ml: 4,
                            whiteSpace: "nowrap",
                            children: t("index.showQueue")
                        })
                    })
                ]
            })
        });
    };
    var uploadDragOver = function(ev) {
        ev.preventDefault();
    };
    var createTravelExpenseFromInvoices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newTravelExpense;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newTravelExpense = emptyTravelExpense;
                        newTravelExpense.childInvoices = selectedInvoicesIds;
                        setTravelExpense(newTravelExpense);
                        setNewTravelExpense(true);
                        onTravelExpenseOpen();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createTravelExpenseFromInvoices() {
            return _ref.apply(this, arguments);
        };
    }();
    if (rekeningData == null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var lastDate = undefined;
    var components = {
        Card: CustomCard,
        NewCardForm: NewCardForm
    };
    var rekeningDataBoard = {
        lanes: [
            {
                id: "lane1",
                title: "Planned Tasks",
                label: "2/2",
                cards: rekeningData
            },
            {
                id: "lane2",
                title: "Completed",
                label: "0/0",
                cards: []
            }
        ]
    };
    // Don't render main content until session is available
    // But we can't return early because it would skip hooks below (violates Rules of Hooks)
    // Instead, check session availability in the render
    if (status === "loading" || !session || !session.accessToken) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Rekening Expense Dashboard"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "main-content"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        onDrop: function(ev) {
            return bulkUploadPrep(ev);
        },
        onDragOver: function(ev) {
            return uploadDragOver(ev);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Rekening Expense Dashboard"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Rekening Dashboard"
                    }, "title")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuElement/* default */.Z, {
                onUpgradeOpen: onUpgradeOpen,
                openInvoice: openInvoice,
                sessionData: session
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionManager/* default */.Z, {
                        isUpgradeOpen: isUpgradeOpen,
                        onUpgradeClose: onUpgradeClose,
                        onUpgradeOpen: onUpgradeOpen,
                        forceDisplay: false,
                        session: session
                    }),
                    tabIndex == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                position: "sticky",
                                top: 0,
                                zIndex: 20,
                                bg: "white",
                                pt: 2,
                                pb: 3,
                                mb: 4,
                                borderBottom: "1px solid",
                                borderColor: "gray.100",
                                boxShadow: "sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                        mb: "0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                as: "h2",
                                                size: "lg",
                                                ml: "0%",
                                                mb: "2",
                                                style: {
                                                    width: "100%"
                                                },
                                                children: t("index.allPayments")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        mb: 0,
                                        mt: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                                columns: 16,
                                                spacing: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 5,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* InputGroup */.BZ, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* InputLeftElement */.Z8, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearch */.eaK, {
                                                                        size: 16,
                                                                        color: "gray.500"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                    placeholder: "Suche",
                                                                    value: searchText,
                                                                    onChange: function(e) {
                                                                        return setSearchText(e.target.value);
                                                                    },
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    _hover: {
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    _focus: {
                                                                        borderColor: "blue.500",
                                                                        boxShadow: "0 0 0 1px #3182ce"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 11,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: 3,
                                                            children: [
                                                                tabIndex == 0 && (session === null || session === void 0 ? void 0 : (ref = session.usage) === null || ref === void 0 ? void 0 : ref.used) < (session === null || session === void 0 ? void 0 : (ref1 = session.usage) === null || ref1 === void 0 ? void 0 : ref1.limit) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                            as: button_dist_index_esm/* Button */.zx,
                                                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                            colorScheme: "rekening",
                                                                            size: "md",
                                                                            h: "40px",
                                                                            px: 4,
                                                                            children: t("index.add") || "Add"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: openFileInput,
                                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {
                                                                                        size: 15
                                                                                    }),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        as: "h4",
                                                                                        ml: "2",
                                                                                        size: "sm",
                                                                                        children: t("index.uploadInvoice") || "Beleg hochladen"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: openFolderInput,
                                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {
                                                                                        size: 15
                                                                                    }),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        as: "h4",
                                                                                        ml: "2",
                                                                                        size: "sm",
                                                                                        children: t("index.uploadFolder") || "Ordner hochladen"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: function() {
                                                                                        openInvoice("invoice");
                                                                                        dist/* default.event */.ZP.event({
                                                                                            category: "Invoice",
                                                                                            action: "Add Invoice"
                                                                                        });
                                                                                    },
                                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoReceipt */.Mpc, {
                                                                                        size: 15
                                                                                    }),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        as: "h4",
                                                                                        ml: "2",
                                                                                        size: "sm",
                                                                                        children: t("index.addInvoice") || "Beleg hinzuf\xfcgen"
                                                                                    })
                                                                                }),
                                                                                ((ref2 = session.rights) === null || ref2 === void 0 ? void 0 : ref2.includes("travel-expenses")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: function() {
                                                                                        openInvoice("travel-expense");
                                                                                        dist/* default.event */.ZP.event({
                                                                                            category: "Invoice",
                                                                                            action: "Add Travel Expense"
                                                                                        });
                                                                                    },
                                                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoEarth */.uWg, {
                                                                                        size: 15
                                                                                    }),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        as: "h4",
                                                                                        ml: "2",
                                                                                        size: "sm",
                                                                                        children: t("index.addTravelExpense") || "Reisekosten hinzuf\xfcgen"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    ref: fileInputRef,
                                                                    type: "file",
                                                                    multiple: true,
                                                                    accept: "application/pdf,image/*,".concat(expandUploadFiles/* ZIP_UPLOAD_ACCEPT */.pj),
                                                                    style: {
                                                                        display: "none"
                                                                    },
                                                                    onChange: handleFileInputChange
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                    ref: folderInputRef,
                                                                    type: "file",
                                                                    multiple: true,
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                }, {
                                                                    webkitdirectory: "true",
                                                                    directory: "true"
                                                                }), {
                                                                    onChange: handleFolderInputChange
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                            as: button_dist_index_esm/* Button */.zx,
                                                                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                            variant: "outline",
                                                                            size: "md",
                                                                            bg: "white",
                                                                            borderColor: "gray.300",
                                                                            color: "gray.700",
                                                                            _hover: {
                                                                                bg: "gray.50",
                                                                                borderColor: "gray.400"
                                                                            },
                                                                            h: "40px",
                                                                            px: 4,
                                                                            children: "Schnellaktionen"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                    borderBottom: "1px solid #E2E8F0",
                                                                                    pl: "3",
                                                                                    pb: "2",
                                                                                    pt: "2",
                                                                                    fontWeight: "bold",
                                                                                    children: [
                                                                                        t("index.refresh"),
                                                                                        ":"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: function() {
                                                                                        return loadInvoices();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRefreshCircle */._Zx, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            mr: "2",
                                                                                            size: "sm",
                                                                                            children: t("index.refreshData")
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                    borderBottom: "1px solid #E2E8F0",
                                                                                    pl: "3",
                                                                                    pb: "2",
                                                                                    pt: "2",
                                                                                    fontWeight: "bold",
                                                                                    children: [
                                                                                        t("download"),
                                                                                        ":"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    minH: "45px",
                                                                                    onClick: function() {
                                                                                        return exportExcel(rekeningData);
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoDownload */.k$5, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            mr: "2",
                                                                                            size: "sm",
                                                                                            children: t("index.downloadAllVisible")
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    isDisabled: selectedInvoicesIds.length == 0,
                                                                                    minH: "45px",
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    onClick: function() {
                                                                                        return downloadSelected();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckbox */.MIH, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            size: "sm",
                                                                                            children: [
                                                                                                t("index.downloadSelected"),
                                                                                                "(",
                                                                                                selectedInvoicesIds.length,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                selectedInvoicesIds.length != 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    pl: "3",
                                                                                    pb: "2",
                                                                                    pt: "2",
                                                                                    fontWeight: "bold",
                                                                                    children: [
                                                                                        t("index.travelExpense"),
                                                                                        ":"
                                                                                    ]
                                                                                }),
                                                                                selectedInvoicesIds.length != 0 && selectedInvoicesIds.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    onClick: function() {
                                                                                        return createTravelExpenseFromInvoices();
                                                                                    },
                                                                                    minH: "45px",
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoGlobe */.B1V, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            size: "sm",
                                                                                            children: t("index.createTravelExpenseSelected")
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    pl: "3",
                                                                                    pb: "2",
                                                                                    pt: "2",
                                                                                    fontWeight: "bold",
                                                                                    children: [
                                                                                        t("index.update"),
                                                                                        ":"
                                                                                    ]
                                                                                }),
                                                                                selectedInvoiceNextStep != undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    isDisabled: selectedInvoicesIds.length == 0,
                                                                                    onClick: function() {
                                                                                        return bulkUpdateInvoiceStatus();
                                                                                    },
                                                                                    minH: "45px",
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneCircleSharp */.w_p, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            size: "sm",
                                                                                            children: [
                                                                                                selectedInvoiceNextStep.title,
                                                                                                " (",
                                                                                                selectedInvoicesIds.length,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    isDisabled: selectedInvoicesIds.length == 0,
                                                                                    onClick: function() {
                                                                                        return setIsDeleteOpen(true);
                                                                                    },
                                                                                    minH: "45px",
                                                                                    borderTop: "1px solid #E2E8F0",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoTrash */.VOs, {
                                                                                            size: 15
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                                            as: "h4",
                                                                                            ml: "2",
                                                                                            size: "sm",
                                                                                            children: [
                                                                                                t("index.deleteSelected"),
                                                                                                "(",
                                                                                                selectedInvoicesIds.length,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                spacing: 3,
                                                mt: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                spacing: 0,
                                                                bg: "gray.100",
                                                                p: 1,
                                                                borderRadius: "md",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                        size: "sm",
                                                                        variant: filterView === "alle" ? "solid" : "ghost",
                                                                        bg: filterView === "alle" ? "white" : "transparent",
                                                                        color: filterView === "alle" ? "gray.800" : "gray.600",
                                                                        onClick: function() {
                                                                            return setFilterView("alle");
                                                                        },
                                                                        flex: 1,
                                                                        borderRadius: "md",
                                                                        boxShadow: filterView === "alle" ? "sm" : "none",
                                                                        _hover: {
                                                                            bg: filterView === "alle" ? "white" : "gray.200",
                                                                            color: filterView === "alle" ? "gray.800" : "gray.700"
                                                                        },
                                                                        fontWeight: "medium",
                                                                        h: "32px",
                                                                        children: "Alle"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                        size: "sm",
                                                                        variant: filterView === "meine" ? "solid" : "ghost",
                                                                        bg: filterView === "meine" ? "white" : "transparent",
                                                                        color: filterView === "meine" ? "gray.800" : "gray.600",
                                                                        onClick: function() {
                                                                            return setFilterView("meine");
                                                                        },
                                                                        flex: 1,
                                                                        borderRadius: "md",
                                                                        boxShadow: filterView === "meine" ? "sm" : "none",
                                                                        _hover: {
                                                                            bg: filterView === "meine" ? "white" : "gray.200",
                                                                            color: filterView === "meine" ? "gray.800" : "gray.700"
                                                                        },
                                                                        fontWeight: "medium",
                                                                        h: "32px",
                                                                        children: "Meine"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                    as: button_dist_index_esm/* Button */.zx,
                                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    position: "relative",
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    color: "gray.700",
                                                                    _hover: {
                                                                        bg: "gray.50",
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    h: "32px",
                                                                    px: 3,
                                                                    minW: "fit-content",
                                                                    children: [
                                                                        "Transaktionsdatum",
                                                                        dateFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "blue",
                                                                            position: "absolute",
                                                                            top: "-1",
                                                                            right: "-1",
                                                                            borderRadius: "full",
                                                                            fontSize: "xs",
                                                                            minW: "20px",
                                                                            h: "20px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            children: "1"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setDateFilter("Letzte 6 Monate");
                                                                            },
                                                                            children: "Letzte 6 Monate"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setDateFilter("Letzte 3 Monate");
                                                                            },
                                                                            children: "Letzte 3 Monate"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setDateFilter("Letzter Monat");
                                                                            },
                                                                            children: "Letzter Monat"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setDateFilter("Dieses Jahr");
                                                                            },
                                                                            children: "Dieses Jahr"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                    as: button_dist_index_esm/* Button */.zx,
                                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    position: "relative",
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    color: "gray.700",
                                                                    _hover: {
                                                                        bg: "gray.50",
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    h: "32px",
                                                                    px: 3,
                                                                    minW: "fit-content",
                                                                    children: [
                                                                        "Beleg",
                                                                        receiptFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "blue",
                                                                            position: "absolute",
                                                                            top: "-1",
                                                                            right: "-1",
                                                                            borderRadius: "full",
                                                                            fontSize: "xs",
                                                                            minW: "20px",
                                                                            h: "20px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            children: "1"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setReceiptFilter("Mit Beleg");
                                                                            },
                                                                            children: "Mit Beleg"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setReceiptFilter("Ohne Beleg");
                                                                            },
                                                                            children: "Ohne Beleg"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                    as: button_dist_index_esm/* Button */.zx,
                                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    position: "relative",
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    color: "gray.700",
                                                                    _hover: {
                                                                        bg: "gray.50",
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    h: "32px",
                                                                    px: 3,
                                                                    minW: "fit-content",
                                                                    children: [
                                                                        "Transaktion",
                                                                        transactionLinkedFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "blue",
                                                                            position: "absolute",
                                                                            top: "-1",
                                                                            right: "-1",
                                                                            borderRadius: "full",
                                                                            fontSize: "xs",
                                                                            minW: "20px",
                                                                            h: "20px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            children: "1"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionLinkedFilter("linked");
                                                                            },
                                                                            children: "Verkn\xfcpft"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionLinkedFilter("unlinked");
                                                                            },
                                                                            children: "Nicht verkn\xfcpft"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                    as: button_dist_index_esm/* Button */.zx,
                                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    position: "relative",
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    color: "gray.700",
                                                                    _hover: {
                                                                        bg: "gray.50",
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    h: "32px",
                                                                    px: 3,
                                                                    minW: "fit-content",
                                                                    children: [
                                                                        "Status",
                                                                        statusFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "blue",
                                                                            position: "absolute",
                                                                            top: "-1",
                                                                            right: "-1",
                                                                            borderRadius: "full",
                                                                            fontSize: "xs",
                                                                            minW: "20px",
                                                                            h: "20px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            children: "1"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuList */.qy, {
                                                                    children: invoiceTypesData.map(function(singleType) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuGroup */.kS, {
                                                                            title: singleType.title,
                                                                            children: singleType.steps.map(function(singleStep) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                                    onClick: function() {
                                                                                        return setStatusFilter(singleStep._id);
                                                                                    },
                                                                                    children: singleStep.title
                                                                                }, singleStep._id);
                                                                            })
                                                                        }, singleType._id);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                                    as: button_dist_index_esm/* Button */.zx,
                                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronDown */.CgR, {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    position: "relative",
                                                                    bg: "white",
                                                                    borderColor: "gray.300",
                                                                    color: "gray.700",
                                                                    _hover: {
                                                                        bg: "gray.50",
                                                                        borderColor: "gray.400"
                                                                    },
                                                                    h: "32px",
                                                                    px: 3,
                                                                    minW: "fit-content",
                                                                    children: [
                                                                        "Transaktionstyp",
                                                                        transactionTypeFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                            colorScheme: "blue",
                                                                            position: "absolute",
                                                                            top: "-1",
                                                                            right: "-1",
                                                                            borderRadius: "full",
                                                                            fontSize: "xs",
                                                                            minW: "20px",
                                                                            h: "20px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            children: "1"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuList */.qy, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionTypeFilter("incoming");
                                                                            },
                                                                            children: "Eingehend"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionTypeFilter("outgoing");
                                                                            },
                                                                            children: "Ausgehend"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionTypeFilter("bank_statement");
                                                                            },
                                                                            children: "Kontoauszug"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionTypeFilter("credit_card_statement");
                                                                            },
                                                                            children: "Kreditkartenabrechnung"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItem */.sN, {
                                                                            onClick: function() {
                                                                                return setTransactionTypeFilter("other");
                                                                            },
                                                                            children: "Sonstige"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoFilter */.FpS, {
                                                                size: 16
                                                            }),
                                                            variant: "outline",
                                                            size: "sm",
                                                            bg: "white",
                                                            borderColor: "gray.300",
                                                            color: "gray.700",
                                                            _hover: {
                                                                bg: "gray.50",
                                                                borderColor: "gray.400"
                                                            },
                                                            h: "32px",
                                                            px: 3,
                                                            minW: "fit-content",
                                                            onClick: openAdvancedFilter,
                                                            children: "Alle Filter"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    activeFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        mb: 0,
                                        mt: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                            spacing: 2,
                                            flexWrap: "wrap",
                                            children: activeFilters.map(function(filter) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
                                                    colorScheme: "gray",
                                                    borderRadius: "full",
                                                    px: 3,
                                                    py: 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    bg: "gray.100",
                                                    color: "gray.700",
                                                    border: "1px solid",
                                                    borderColor: "gray.300",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                            fontSize: "xs",
                                                            fontWeight: "medium",
                                                            children: [
                                                                filter.label,
                                                                ": ",
                                                                filter.value
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                                            size: "xs",
                                                            variant: "ghost",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                                                                size: 12
                                                            }),
                                                            onClick: filter.remove,
                                                            "aria-label": "Remove ".concat(filter.label, " filter"),
                                                            color: "gray.500",
                                                            _hover: {
                                                                bg: "gray.200"
                                                            }
                                                        })
                                                    ]
                                                }, filter.key);
                                            })
                                        })
                                    })
                                ]
                            }),
                            rekeningData.length != 0 && isLoading == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "create-first-invoice",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                            as: "h2",
                                            size: "md",
                                            mt: "10",
                                            mb: "10",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {
                                                    style: {
                                                        float: "left",
                                                        marginRight: "10",
                                                        marginTop: "2"
                                                    }
                                                }),
                                                t("index.dragAndDropHere"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCloudUpload */.ZAz, {
                                                    style: {
                                                        float: "right",
                                                        marginLeft: "10",
                                                        marginTop: "2"
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    renderInvoiceQueueStatus()
                                ]
                            }),
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                    thickness: "5px",
                                    speed: "1s",
                                    emptyColor: "gray.200",
                                    color: "orange.500",
                                    size: "xl",
                                    mt: "10"
                                })
                            }),
                            rekeningData.length == 0 && isLoading == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "create-first-invoice",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            as: "h2",
                                            size: "md",
                                            mt: "10",
                                            children: t("index.needHelpForRekening")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                            colorScheme: "rekening",
                                            mt: "10",
                                            mb: "10",
                                            onClick: onTutorialOpen,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoHelpCircle */.k$3, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    ml: "1",
                                                    children: t("index.openUserGuide")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            rekeningData.length == 0 && isLoading == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "create-first-invoice",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            as: "h2",
                                            size: "md",
                                            mt: "10",
                                            children: t("index.dragAndDropFirstInvoice")
                                        })
                                    }),
                                    renderInvoiceQueueStatus(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            as: "h2",
                                            size: "md",
                                            mt: "10",
                                            children: t("index.or")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                            colorScheme: "rekening",
                                            mt: "10",
                                            mb: "10",
                                            onClick: openFileInput,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAddCircle */.p8f, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    ml: "1",
                                                    children: t("index.addFirstInvoice")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                                datalength: rekeningData.length,
                                pageStart: 0,
                                loadMore: scrollLoadMoreInvoices,
                                hasMore: moreInvoicesAvailable,
                                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                        thickness: "5px",
                                        speed: "1s",
                                        emptyColor: "gray.200",
                                        color: "orange.500",
                                        size: "xl",
                                        mt: "10"
                                    })
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                    style: {
                                        paddingBottom: "50px"
                                    },
                                    columns: 1,
                                    spacing: 3,
                                    children: rekeningData.map(function(item, index) {
                                        var ref, ref1;
                                        var date = new Date(item.date).toLocaleDateString("de-DE");
                                        var dateArray = [
                                            t("months.January"),
                                            t("months.February"),
                                            t("months.March"),
                                            t("months.April"),
                                            t("months.May"),
                                            t("months.June"),
                                            t("months.July"),
                                            t("months.August"),
                                            t("months.September"),
                                            t("months.October"),
                                            t("months.November"),
                                            t("months.December")
                                        ];
                                        var invDate = new Date(item.date).toLocaleString();
                                        //const dateArray = new Date(item.date).getMonth();
                                        var dateNew = new Date(item.date).getMonth();
                                        var yearNew = new Date(item.date).getFullYear();
                                        var monthNew = new Date(item.date).getMonth() + 1;
                                        var addDateHeader = undefined, addDateHeaderYear = "", addDateHeaderCost = undefined;
                                        var invoiceCurrency = item.currency;
                                        if (invoiceCurrency == "EUR" || invoiceCurrency == "" || invoiceCurrency == undefined) {
                                            invoiceCurrency = "€";
                                        } else if (invoiceCurrency == "USD") {
                                            invoiceCurrency = "$";
                                        } else if (invoiceCurrency == "JPY") {
                                            invoiceCurrency = "\xa5";
                                        } else if (invoiceCurrency == "GBP") {
                                            invoiceCurrency = "\xa3";
                                        } else if (invoiceCurrency == "INR") {
                                            invoiceCurrency = "₹";
                                        } else if (invoiceCurrency == "CAD") {
                                            invoiceCurrency = "$";
                                        }
                                        if (dateNew != lastDate) {
                                            lastDate = dateNew;
                                            addDateHeader = dateNew;
                                            addDateHeaderYear = yearNew.toString();
                                            addDateHeaderCost = monthlyCost[yearNew + "_" + dateNew];
                                        }
                                        if (index == rekeningData.length - 1) {
                                            lastDate = undefined;
                                        }
                                        //Mark new inovices
                                        var iconData = categoriesData.find(function(e) {
                                            return e._id == item.category;
                                        });
                                        var IconWeb = io5_index_esm/* IoBriefcase */.BRz;
                                        if (iconData != undefined) {
                                            IconWeb = iconData.iconWebElement;
                                        }
                                        var invoceSelectClassList = "rekening-invoice-item";
                                        if (item.selected != undefined && item.selected == true) {
                                            invoceSelectClassList = "rekening-invoice-item selected";
                                        }
                                        if (changedInvoices.includes(item._id)) {
                                            invoceSelectClassList += " changed-invoice";
                                        }
                                        var invoiceStatus = "";
                                        var invoiceStatusColor = "cream";
                                        try {
                                            var invoiceType = invoiceTypesData.find(function(e) {
                                                return e._id == item.invoiceType;
                                            });
                                            if (invoiceType != undefined) {
                                                var invoiceStatusStep = invoiceType.steps.find(function(e) {
                                                    return e._id == item.invoiceStatus;
                                                });
                                                if (invoiceStatusStep != undefined) {
                                                    invoiceStatus = invoiceStatusStep.title;
                                                    invoiceStatusColor = invoiceStatusStep.color;
                                                }
                                            }
                                        } catch (error) {}
                                        var monthSelected = "";
                                        if (selectedInvoiceMonths.includes(yearNew + "-" + monthNew)) {
                                            monthSelected = "selected";
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                addDateHeader != undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                                    mb: "2",
                                                    columns: 16,
                                                    spacing: 5,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                            colSpan: 8,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                mt: "5",
                                                                spacing: "7",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                        onClick: function(ev) {
                                                                            toggleInvoiceSelectMonth(yearNew, monthNew);
                                                                        },
                                                                        className: "list-checkbox " + monthSelected,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                            className: "list-checkbox-inner"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                        as: "h3",
                                                                        size: "md",
                                                                        ml: "0%",
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        children: [
                                                                            addDateHeaderYear,
                                                                            " ",
                                                                            dateArray[addDateHeader]
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                            colSpan: 7,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                as: "h3",
                                                                size: "md",
                                                                textAlign: "right",
                                                                ml: "0%",
                                                                mt: "5",
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    addDateHeaderCost,
                                                                    currency
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    className: invoceSelectClassList,
                                                    padding: "3",
                                                    borderWidth: "1px",
                                                    borderRadius: "lg",
                                                    style: {
                                                        transition: "all 0.2s"
                                                    },
                                                    _hover: {
                                                        cursor: "pointer",
                                                        backgroundColor: "#f4f4f4"
                                                    },
                                                    onClick: function() {
                                                        openInvoiceById(item._id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                            name: item._id
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
                                                            templateColumns: "repeat(16, 1fr)",
                                                            gap: 4,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                                    colSpan: 1,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                                        spacing: "5px",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                                onClick: function(ev) {
                                                                                    ev.stopPropagation();
                                                                                    ev.preventDefault();
                                                                                    toggleInvoiceSelect([
                                                                                        {
                                                                                            _id: item._id
                                                                                        }
                                                                                    ]);
                                                                                },
                                                                                className: "list-checkbox",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                                    className: "list-checkbox-inner"
                                                                                })
                                                                            }),
                                                                            item.authorData.length != 0 && item.authorData[0].profilePicture == "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                                marginRight: 2,
                                                                                borderRadius: 10,
                                                                                height: 45,
                                                                                width: 45,
                                                                                className: "rekening-invoice-avatar",
                                                                                name: item["authorData"][0]["username"]
                                                                            }),
                                                                            item.authorData.length != 0 && item.authorData[0].profilePicture != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                                marginRight: 2,
                                                                                borderRadius: 10,
                                                                                height: 45,
                                                                                width: 45,
                                                                                className: "rekening-invoice-avatar",
                                                                                src: item["authorData"][0]["profilePictureSignedUrl"] || item["authorData"][0]["profilePicture"]
                                                                            }),
                                                                            item.authorData.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                                marginRight: 2,
                                                                                borderRadius: 10,
                                                                                height: 45,
                                                                                width: 45,
                                                                                className: "rekening-invoice-avatar",
                                                                                name: ""
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "rekening-invoice-icon",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWeb, {
                                                                                    style: {
                                                                                        marginLeft: "2px",
                                                                                        marginTop: "2px"
                                                                                    },
                                                                                    fontSize: "30px"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                    colSpan: 5,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            children: item.shop
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                            display: "flex",
                                                                            alignItems: "baseline",
                                                                            children: [
                                                                                item.invoiceKind != undefined && item.invoiceKind == "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoEarth */.uWg, {
                                                                                    fontSize: "13",
                                                                                    style: {
                                                                                        marginRight: 3
                                                                                    },
                                                                                    color: "#718096"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                                    color: "gray.500",
                                                                                    fontWeight: "semibold",
                                                                                    letterSpacing: "wide",
                                                                                    textTransform: "uppercase",
                                                                                    ml: "0",
                                                                                    children: date
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                    colSpan: 4,
                                                                    children: [
                                                                        (((ref = item) === null || ref === void 0 ? void 0 : ref.scanAttachedSignedUrl) || item.scanAttached) == "" && item.invoiceKind != "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            flex: "",
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            color: "#be3737",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoAlertCircle */.FXL, {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        fontSize: 13,
                                                                                        marginTop: "2px",
                                                                                        marginRight: "3px"
                                                                                    }
                                                                                }),
                                                                                t("index.missingReceipt")
                                                                            ]
                                                                        }),
                                                                        (((ref1 = item) === null || ref1 === void 0 ? void 0 : ref1.scanAttachedSignedUrl) || item.scanAttached) != "" && item.invoiceKind != "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoReceipt */.Mpc, {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        fontSize: 13,
                                                                                        marginTop: "2px",
                                                                                        marginRight: "3px"
                                                                                    }
                                                                                }),
                                                                                t("index.receiptAttached")
                                                                            ]
                                                                        }),
                                                                        item.invoiceKind == "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCar */.nf1, {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        fontSize: 14,
                                                                                        marginTop: "2px",
                                                                                        marginRight: "3px"
                                                                                    }
                                                                                }),
                                                                                t("index.travelExpense")
                                                                            ]
                                                                        }),
                                                                        ((item.linkedTransactionCount || 0) > 0 || item.link) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            color: "green.600",
                                                                            mt: 1,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSwapHorizontal */.LGk, {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        fontSize: 13,
                                                                                        marginTop: "2px",
                                                                                        marginRight: "3px"
                                                                                    }
                                                                                }),
                                                                                t("index.transactionLinked"),
                                                                                (item.linkedTransactionCount || 0) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Badge */.Ct, {
                                                                                    colorScheme: "green",
                                                                                    fontSize: "2xs",
                                                                                    ml: 1,
                                                                                    verticalAlign: "middle",
                                                                                    children: item.linkedTransactionCount
                                                                                })
                                                                            ]
                                                                        }),
                                                                        (item.linkedTransactionCount || 0) === 0 && !item.link && item.invoiceKind != "travel-expense" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            color: "gray.400",
                                                                            mt: 1,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSwapHorizontal */.LGk, {
                                                                                    style: {
                                                                                        float: "left",
                                                                                        fontSize: 13,
                                                                                        marginTop: "2px",
                                                                                        marginRight: "3px"
                                                                                    }
                                                                                }),
                                                                                t("index.transactionNotLinked")
                                                                            ]
                                                                        }),
                                                                        invoiceStatus != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                            display: "flex",
                                                                            alignItems: "baseline",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
                                                                                borderRadius: "full",
                                                                                px: "2",
                                                                                mt: "1",
                                                                                pr: "28px",
                                                                                backgroundColor: invoiceStatusColor,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoLockClosed */.Q6l, {
                                                                                        style: {
                                                                                            float: "left",
                                                                                            marginTop: "2px",
                                                                                            marginRight: "3px"
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                                        children: invoiceStatus
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                                                                    colSpan: 5,
                                                                    textAlign: "right",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                                            as: "h4",
                                                                            size: "sm",
                                                                            children: [
                                                                                item.total,
                                                                                invoiceCurrency
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                            display: "flex",
                                                                            alignItems: "baseline",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                                                textAlign: "right",
                                                                                color: "gray.500",
                                                                                fontWeight: "semibold",
                                                                                letterSpacing: "wide",
                                                                                textTransform: "uppercase",
                                                                                ml: "0",
                                                                                width: "100%",
                                                                                children: [
                                                                                    item.totalNet,
                                                                                    invoiceCurrency
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "rekening-item-right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoChevronForward */.mzm, {
                                                                            fontSize: "35px"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, item._id + "list");
                                    })
                                }, "invoices")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InvoiceDetailDrawer, {
                createInvoiceType: createInvoiceType,
                setBulkUploadCounterFinished: setBulkUploadCounterFinished,
                bulkUploadSettings: bulkUploadSettings,
                setBulkInsertData: setBulkInsertData,
                bulkInsertData: bulkInsertData,
                uploadInProgress: uploadInProgress,
                categoriesData: categoriesData,
                userData: userData,
                setUploadInProgress: setUploadInProgress,
                editInvoiceReadonly: editInvoiceReadonly,
                previewBackwards: previewBackwards,
                previewForwards: previewForwards,
                editInvoiceReadonlyReason: editInvoiceReadonlyReason,
                loadInvoices: loadInvoices,
                invoiceTypesData: invoiceTypesData,
                loadBudgetSpending: loadBudgetSpending,
                loadSingleInvoices: loadSingleInvoices,
                scroller: modules/* scroller */.OK,
                rekeningData: rekeningData,
                setRekeningData: setRekeningData,
                invoiceIsOpen: invoiceIsOpen,
                session: session,
                setChangedInvoices: setChangedInvoices,
                invoiceOnClose: closeInvoiceDrawer,
                setSelectedInvoice: setSelectedInvoice,
                selectedInvoice: selectedInvoice,
                userNotification: userNotification,
                createInvoice: createInvoice,
                setCreateInvoice: setCreateInvoice,
                setDuplicateCurrentFile: setDuplicateCurrentFile,
                setDuplicateUserDecision: setDuplicateUserDecision,
                setIsDuplicateModalOpen: setIsDuplicateModalOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isRefundOpen,
                onClose: onRefundClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("index.refundAll")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    children: [
                                        t("index.sureToSet"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                rekeningData.length,
                                                " ",
                                                t("index.pendingInvoices")
                                            ]
                                        }),
                                        " ",
                                        t("index.withTotalValue"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                totalVisibleValue,
                                                "€"
                                            ]
                                        }),
                                        " ",
                                        t("index.toRefunded")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: onRefundClose,
                                        mr: 3,
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                        isLoading: isLoadingRefund,
                                        onClick: function() {
                                            refundAll();
                                        },
                                        mr: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneCircleSharp */.w_p, {
                                                style: {
                                                    fontSize: "1.2em",
                                                    marginRight: "5px"
                                                }
                                            }),
                                            t("index.refundDone")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isRequestRefundOpen,
                onClose: onRequestRefundClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("index.requestRefundAll")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    children: [
                                        t("index.sureToRequestRefundAll"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                rekeningData.length,
                                                " ",
                                                t("index.invoicesInProgress")
                                            ]
                                        }),
                                        " ",
                                        t("index.withTotalValue"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                            children: [
                                                totalVisibleValue,
                                                "€"
                                            ]
                                        }),
                                        "?"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: onRequestRefundClose,
                                        mr: 3,
                                        children: t("close")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                        isLoading: isLoadingRequestRefund,
                                        onClick: function() {
                                            requestRefundAll();
                                        },
                                        mr: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneCircleSharp */.w_p, {
                                                style: {
                                                    fontSize: "1.2em",
                                                    marginRight: "5px"
                                                }
                                            }),
                                            t("index.requestRefundAll")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isDownloadOpen,
                onClose: onDownloadClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("index.downloadAllVisibleInvoices")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            children: t("index.preparingDownload")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        mt: "5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                            thickness: "4px",
                                            speed: "0.65s",
                                            emptyColor: "gray.200",
                                            color: "orange",
                                            size: "md"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                closeOnOverlayClick: false,
                isOpen: isOpenBulkUploadPrep,
                onClose: onCloseBulkUploadPrep,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("index.bulkImportInvoices")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: [
                                    invoiceTypesData.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        mt: "2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: t("index.invoiceType")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                                value: bulkUploadSettings.invoiceType,
                                                onChange: function(e) {
                                                    onChangeSettingsBulkUpload("invoiceType", e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: t("index.selectInvoiceType")
                                                    }),
                                                    invoiceTypesData.map(function(singleCategory) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: singleCategory._id,
                                                            children: singleCategory.title
                                                        }, singleCategory._id + "-bulk-categories");
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        mt: "4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                fontSize: "smaller",
                                                mb: "1",
                                                fontWeight: "bold",
                                                children: [
                                                    t("index.budget"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        as: "span",
                                                        color: "gray.500",
                                                        fontSize: "xs",
                                                        children: "(Optional - AI will suggest if not selected)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                                value: bulkUploadSettings.category,
                                                onChange: function(e) {
                                                    onChangeSettingsBulkUpload("category", e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                        value: "",
                                                        children: [
                                                            t("index.selectCategory"),
                                                            " (Optional)"
                                                        ]
                                                    }),
                                                    categoriesData.map(function(singleCategory) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: singleCategory._id,
                                                            children: singleCategory.title
                                                        }, singleCategory._id + "budget");
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: onCloseBulkUploadPrep,
                                        mr: 3,
                                        variant: "outline",
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* Button */.zx, {
                                        colorScheme: "rekening",
                                        isLoading: isLoadingRefund,
                                        onClick: function() {
                                            bulkUpload();
                                        },
                                        disabled: invoiceTypesData.length > 1 && bulkUploadSettings.invoiceType == "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoColorWand */.Sbw, {
                                                style: {
                                                    fontSize: "1.2em",
                                                    marginRight: "5px"
                                                }
                                            }),
                                            t("index.startImport")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isOpenBulkUpload,
                onClose: onCloseBulkUpload,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: t("index.bulkImporting")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: bulkUploadCounterFinished != bulkUploadCounterTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                            thickness: "4px",
                                            speed: isDuplicateModalOpen ? "10000s" : "0.65s",
                                            emptyColor: "gray.200",
                                            color: "orange",
                                            size: "md"
                                        })
                                    }),
                                    !isDuplicateModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                            mt: "5",
                                            children: [
                                                t("index.uploadingFiles"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: bulkUploadCounterFinished
                                                }),
                                                " ",
                                                t("index.outOf"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: bulkUploadCounterTotal
                                                }),
                                                " ",
                                                t("index.files")
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_dist_index_esm/* Progress */.Ex, {
                                        mt: "5",
                                        value: bulkUploadCounterFinished / bulkUploadCounterTotal * 100,
                                        size: "xs",
                                        colorScheme: "orange"
                                    }),
                                    isDuplicateModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                mt: "5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: t("index.duplicatedDocuments")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                mt: "1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                    children: [
                                                        '"',
                                                        duplicateCurrentFile.name,
                                                        '"'
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    bulkUploadCounterFinished == bulkUploadCounterTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        mr: 3,
                                        onClick: onCloseBulkUpload,
                                        children: t("done")
                                    }),
                                    bulkUploadCounterFinished != bulkUploadCounterTotal && !isDuplicateModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        mr: 3,
                                        isLoading: true,
                                        disabled: true,
                                        onClick: onCloseBulkUpload,
                                        children: t("done")
                                    }),
                                    isDuplicateModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: handleDuplicateOverwrite,
                                        mr: "3",
                                        children: t("index.importDuplicate")
                                    }),
                                    isDuplicateModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        onClick: handleDuplicateSkip,
                                        colorScheme: "rekening",
                                        children: t("index.skipDocument")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal/* default */.Z, {
                isOpen: isDeleteOpen,
                onCancel: function() {
                    return setIsDeleteOpen(false);
                },
                onConfirm: deleteSelectedInvoices,
                headerMessage: t("index.deleteModal.header", {
                    count: selectedInvoicesIds.length
                }),
                bodyMessage: t("deleteModal.body", {
                    count: selectedInvoicesIds.length
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isAdvancedFilterOpen,
                onClose: onAdvancedFilterClose,
                size: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        maxW: "800px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                                children: "Alle Filter"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                                pb: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                    spacing: 6,
                                    align: "stretch",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Transaktionsdatum"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                                    columns: 2,
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Diese Woche",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Diese Woche"
                                                                    });
                                                                });
                                                            },
                                                            children: "Diese Woche"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Diesen Monat",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Diesen Monat"
                                                                    });
                                                                });
                                                            },
                                                            children: "Diesen Monat"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Letzte 3 Monate",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Letzte 3 Monate"
                                                                    });
                                                                });
                                                            },
                                                            children: "Letzte 3 Monate"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Dieses Jahr",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Dieses Jahr"
                                                                    });
                                                                });
                                                            },
                                                            children: "Dieses Jahr"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Letzte Woche",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Letzte Woche"
                                                                    });
                                                                });
                                                            },
                                                            children: "Letzte Woche"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Letzter Monat",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Letzter Monat"
                                                                    });
                                                                });
                                                            },
                                                            children: "Letzter Monat"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Vergangenes Jahr",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Vergangenes Jahr"
                                                                    });
                                                                });
                                                            },
                                                            children: "Vergangenes Jahr"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.dateRange === "Kein Datumsfilter",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        dateRange: "Kein Datumsfilter"
                                                                    });
                                                                });
                                                            },
                                                            children: "Kein Datumsfilter"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Betrag"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    spacing: 4,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                                                    fontSize: "sm",
                                                                    children: "Von"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                    placeholder: "0.00",
                                                                    value: advancedFilters.amountFrom,
                                                                    onChange: function(e) {
                                                                        return setAdvancedFilters(function(prev) {
                                                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                amountFrom: e.target.value
                                                                            });
                                                                        });
                                                                    },
                                                                    size: "sm"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                                                    fontSize: "sm",
                                                                    children: "Bis"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                    placeholder: "0.00",
                                                                    value: advancedFilters.amountTo,
                                                                    onChange: function(e) {
                                                                        return setAdvancedFilters(function(prev) {
                                                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                amountTo: e.target.value
                                                                            });
                                                                        });
                                                                    },
                                                                    size: "sm"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Transaktionstyp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    spacing: 6,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.transactionType === "Haben",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        transactionType: "Haben"
                                                                    });
                                                                });
                                                            },
                                                            children: "Haben"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* Radio */.Y8, {
                                                            isChecked: advancedFilters.transactionType === "Soll",
                                                            onChange: function() {
                                                                return setAdvancedFilters(function(prev) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                        transactionType: "Soll"
                                                                    });
                                                                });
                                                            },
                                                            children: "Soll"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Benutzer"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    align: "start",
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.users.length === userData.length && userData.length > 0,
                                                            isIndeterminate: advancedFilters.users.length > 0 && advancedFilters.users.length < userData.length,
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            users: userData.map(function(u) {
                                                                                return u._id;
                                                                            })
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            users: []
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Alle ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: (session === null || session === void 0 ? void 0 : (ref3 = session.user_data) === null || ref3 === void 0 ? void 0 : ref3._id) && advancedFilters.users.includes(session.user_data._id),
                                                            onChange: function(e) {
                                                                var ref;
                                                                if (e.target.checked && (session === null || session === void 0 ? void 0 : (ref = session.user_data) === null || ref === void 0 ? void 0 : ref._id)) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            users: (0,_to_consumable_array/* default */.Z)(prev.users).concat([
                                                                                session.user_data._id
                                                                            ])
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            users: prev.users.filter(function(id) {
                                                                                return id !== session.user_data._id;
                                                                            })
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Aktueller Benutzer (Ich)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Karte"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    align: "start",
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* InputGroup */.BZ, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* InputLeftElement */.Z8, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoSearch */.eaK, {
                                                                        size: 16,
                                                                        color: "gray.500"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                                                    placeholder: "Suche aus ".concat(creditorsData.length, " Eintr\xe4gen"),
                                                                    size: "sm"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.creditors.length === creditorsData.length && creditorsData.length > 0,
                                                            isIndeterminate: advancedFilters.creditors.length > 0 && advancedFilters.creditors.length < creditorsData.length,
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            creditors: creditorsData.map(function(c) {
                                                                                return c._id;
                                                                            })
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            creditors: []
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Alle ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                                            columns: 2,
                                                            spacing: 2,
                                                            width: "100%",
                                                            children: creditorsData.map(function(creditor) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                    isChecked: advancedFilters.creditors.includes(creditor._id),
                                                                    onChange: function(e) {
                                                                        if (e.target.checked) {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    creditors: (0,_to_consumable_array/* default */.Z)(prev.creditors).concat([
                                                                                        creditor._id
                                                                                    ])
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    creditors: prev.creditors.filter(function(id) {
                                                                                        return id !== creditor._id;
                                                                                    })
                                                                                });
                                                                            });
                                                                        }
                                                                    },
                                                                    children: [
                                                                        creditor.name,
                                                                        " ",
                                                                        creditor.creditorNumber
                                                                    ]
                                                                }, creditor._id);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Kategorien"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    align: "start",
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.categories.length === categoriesData.length && categoriesData.length > 0,
                                                            isIndeterminate: advancedFilters.categories.length > 0 && advancedFilters.categories.length < categoriesData.length,
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            categories: categoriesData.map(function(c) {
                                                                                return c._id;
                                                                            })
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            categories: []
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Alle ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                                            columns: 2,
                                                            spacing: 2,
                                                            width: "100%",
                                                            children: categoriesData.map(function(category) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                    isChecked: advancedFilters.categories.includes(category._id),
                                                                    onChange: function(e) {
                                                                        if (e.target.checked) {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    categories: (0,_to_consumable_array/* default */.Z)(prev.categories).concat([
                                                                                        category._id
                                                                                    ])
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    categories: prev.categories.filter(function(id) {
                                                                                        return id !== category._id;
                                                                                    })
                                                                                });
                                                                            });
                                                                        }
                                                                    },
                                                                    children: category.title
                                                                }, category._id);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Rechnungstypen"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    align: "start",
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.invoiceTypes.length === invoiceTypesData.length && invoiceTypesData.length > 0,
                                                            isIndeterminate: advancedFilters.invoiceTypes.length > 0 && advancedFilters.invoiceTypes.length < invoiceTypesData.length,
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceTypes: invoiceTypesData.map(function(t) {
                                                                                return t._id;
                                                                            })
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceTypes: []
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Alle ausw\xe4hlen"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                                            columns: 2,
                                                            spacing: 2,
                                                            width: "100%",
                                                            children: invoiceTypesData.map(function(invoiceType) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                    isChecked: advancedFilters.invoiceTypes.includes(invoiceType._id),
                                                                    onChange: function(e) {
                                                                        if (e.target.checked) {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    invoiceTypes: (0,_to_consumable_array/* default */.Z)(prev.invoiceTypes).concat([
                                                                                        invoiceType._id
                                                                                    ])
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setAdvancedFilters(function(prev) {
                                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                                    invoiceTypes: prev.invoiceTypes.filter(function(id) {
                                                                                        return id !== invoiceType._id;
                                                                                    })
                                                                                });
                                                                            });
                                                                        }
                                                                    },
                                                                    children: invoiceType.title
                                                                }, invoiceType._id);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    mb: 3,
                                                    children: "Rechnungsarten"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    align: "start",
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.invoiceKinds.includes("invoice"),
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceKinds: (0,_to_consumable_array/* default */.Z)(prev.invoiceKinds).concat([
                                                                                "invoice"
                                                                            ])
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceKinds: prev.invoiceKinds.filter(function(kind) {
                                                                                return kind !== "invoice";
                                                                            })
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Rechnung"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                            isChecked: advancedFilters.invoiceKinds.includes("travel-expense"),
                                                            onChange: function(e) {
                                                                if (e.target.checked) {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceKinds: (0,_to_consumable_array/* default */.Z)(prev.invoiceKinds).concat([
                                                                                "travel-expense"
                                                                            ])
                                                                        });
                                                                    });
                                                                } else {
                                                                    setAdvancedFilters(function(prev) {
                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                                            invoiceKinds: prev.invoiceKinds.filter(function(kind) {
                                                                                return kind !== "travel-expense";
                                                                            })
                                                                        });
                                                                    });
                                                                }
                                                            },
                                                            children: "Reisekosten"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalFooter */.mz, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "link",
                                        color: "blue.500",
                                        onClick: clearAllFilters,
                                        mr: "auto",
                                        children: "Alle entfernen"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "outline",
                                        colorScheme: "gray",
                                        onClick: testFilter,
                                        mr: 3,
                                        children: "Test Filter"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "outline",
                                        colorScheme: "gray",
                                        onClick: saveAsDefault,
                                        mr: 3,
                                        children: "Als Standard speichern"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        colorScheme: "green",
                                        onClick: applyAdvancedFilters,
                                        children: "Anwenden"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialModal/* default */.Z, {
                isOpen: isTutorialOpen,
                onClose: onTutorialClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QueueProgressOverlay/* default */.Z, {
                isVisible: isQueueOverlayVisible,
                onClose: function() {
                    return setIsQueueOverlayVisible(false);
                },
                session: session,
                onQueueEmpty: function() {
                    // Refresh invoice list when queue is empty
                    loadInvoices();
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [260,2180,7805,7277,9486,1903,2261,5935,9961,6237,3829,4812,3787,8758,4329,3374,7858,6394,1355,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);